(function (factory) {
    typeof define === 'function' && define.amd ? define('index', factory) :
    factory();
  }((function () { 'use strict';
  
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
  
    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
  
    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }
  
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
  
      return obj;
    }
  
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }
  
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }
  
    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }
  
    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };
  
      return _setPrototypeOf(o, p);
    }
  
    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;
  
      try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }
  
    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }
  
      return _construct.apply(null, arguments);
    }
  
    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }
  
    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;
  
      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
  
        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }
  
        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);
  
          _cache.set(Class, Wrapper);
        }
  
        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
  
        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };
  
      return _wrapNativeSuper(Class);
    }
  
    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
  
      return self;
    }
  
    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }
  
      return _assertThisInitialized(self);
    }
  
    function _createSuper(Derived) {
      var hasNativeReflectConstruct = _isNativeReflectConstruct();
  
      return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
  
        if (hasNativeReflectConstruct) {
          var NewTarget = _getPrototypeOf(this).constructor;
  
          result = Reflect.construct(Super, arguments, NewTarget);
        } else {
          result = Super.apply(this, arguments);
        }
  
        return _possibleConstructorReturn(this, result);
      };
    }
  
    function _toConsumableArray(arr) {
      return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
  
    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
  
    function _iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
  
    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
  
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;
  
      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  
      return arr2;
    }
  
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
  
    var Responsive = /*#__PURE__*/function () {
      function Responsive() {
        var _this = this;
  
        _classCallCheck(this, Responsive);
  
        this.currentBreakpoint = Responsive.getCurrentBreakpoint();
        window.addEventListener('resize', function () {
          var newBreakpoint = Responsive.getCurrentBreakpoint();
  
          if (_this.currentBreakpoint === newBreakpoint) {
            return;
          }
  
          document.dispatchEvent(new CustomEvent('breakpoint:changed', {
            detail: {
              previousBreakpoint: _this.currentBreakpoint,
              currentBreakpoint: newBreakpoint
            }
          }));
          _this.currentBreakpoint = newBreakpoint;
        });
      }
  
      _createClass(Responsive, null, [{
        key: "matchesBreakpoint",
        value: function matchesBreakpoint(breakpoint) {
          switch (breakpoint) {
            case 'phone':
              return window.matchMedia('screen and (max-width: 640px)').matches;
  
            case 'tablet':
              return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;
  
            case 'tablet-and-up':
              return window.matchMedia('screen and (min-width: 641px)').matches;
  
            case 'pocket':
              return window.matchMedia('screen and (max-width: 1007px)').matches;
  
            case 'lap':
              return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;
  
            case 'lap-and-up':
              return window.matchMedia('screen and (min-width: 1008px)').matches;
  
            case 'desk':
              return window.matchMedia('screen and (min-width: 1280px)').matches;
  
            case 'widescreen':
              return window.matchMedia('screen and (min-width: 1600px)').matches;
  
            case 'supports-hover':
              return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          }
        }
      }, {
        key: "getCurrentBreakpoint",
        value: function getCurrentBreakpoint() {
          if (window.matchMedia('screen and (max-width: 640px)').matches) {
            return 'phone';
          }
  
          if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
            return 'tablet';
          }
  
          if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
            return 'lap';
          }
  
          if (window.matchMedia('screen and (min-width: 1280px)').matches) {
            return 'desk';
          }
        }
      }]);
  
      return Responsive;
    }();
  
    var Carousel = /*#__PURE__*/function () {
      function Carousel(element) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var overrideSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  
        _classCallCheck(this, Carousel);
  
        this.element = element;
        this.initialConfig = Object.assign(JSON.parse(element.getAttribute('data-flickity-config')), overrideSettings);
        this.options = options;
  
        this._attachListeners();
  
        this._build();
      }
  
      _createClass(Carousel, [{
        key: "destroy",
        value: function destroy() {
          this.flickityInstance.destroy();
  
          if (this.initialConfig['breakpoints'] !== undefined) {
            document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
          }
        }
      }, {
        key: "getFlickityInstance",
        value: function getFlickityInstance() {
          return this.flickityInstance;
        }
      }, {
        key: "selectCell",
        value: function selectCell(index) {
          var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  
          if (shouldPause) {
            this.flickityInstance.pausePlayer();
          }
  
          this.flickityInstance.select(index, false, !shouldAnimate);
        }
      }, {
        key: "next",
        value: function next() {
          this.flickityInstance.next();
        }
      }, {
        key: "previous",
        value: function previous() {
          this.flickityInstance.previous();
        }
      }, {
        key: "pausePlayer",
        value: function pausePlayer() {
          this.flickityInstance.pausePlayer();
        }
      }, {
        key: "unpausePlayer",
        value: function unpausePlayer() {
          this.flickityInstance.unpausePlayer();
        }
      }, {
        key: "resize",
        value: function resize() {
          this.flickityInstance.resize();
        }
      }, {
        key: "getSelectedIndex",
        value: function getSelectedIndex() {
          return this.flickityInstance.selectedIndex;
        }
      }, {
        key: "getSelectedCell",
        value: function getSelectedCell() {
          return this.flickityInstance.selectedCell.element;
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          if (this.initialConfig['breakpoints'] !== undefined) {
            this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
            document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
          }
        }
        /**
         * Create the carousel instance
         */
  
      }, {
        key: "_build",
        value: function _build() {
          var _this = this;
  
          var config = this._processConfig();
  
          this.flickityInstance = new Flickity(this.element, config);
  
          this._validateDraggable();
  
          this.selectedIndex = this.flickityInstance.selectedIndex;
          this.flickityInstance.on('resize', this._validateDraggable.bind(this));
  
          if (this.options['onSelect']) {
            this.flickityInstance.on('select', function () {
              // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
              // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)
              if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
                _this.options['onSelect'](_this.flickityInstance.selectedIndex, _this.flickityInstance.selectedCell.element);
  
                _this.selectedIndex = _this.flickityInstance.selectedIndex;
              }
            });
          }
  
          if (this.options['onSettle']) {
            this.flickityInstance.on('settle', function (index) {
              _this.options['onSettle'](index, _this.flickityInstance.selectedCell.element);
            });
          }
  
          if (this.options['onClick']) {
            this.flickityInstance.on('staticClick', function (event, pointer, cell, index) {
              _this.options['onClick'](cell, index);
            });
          }
        }
        /**
         * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
         * if the displayed elements equals to the amount of elements
         */
  
      }, {
        key: "_validateDraggable",
        value: function _validateDraggable() {
          var isActive = this.flickityInstance.isActive || false;
  
          if (!isActive || !this.flickityInstance.options['draggable']) {
            return; // Not draggable, so nothing to do
          }
  
          if (undefined === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length) {
            this.flickityInstance.unbindDrag();
          } else {
            this.flickityInstance.bindDrag();
          }
        }
        /**
         * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
         */
  
      }, {
        key: "_processConfig",
        value: function _processConfig() {
          var config = Object.assign({}, this.initialConfig);
          delete config['breakpoints'];
  
          if (this.initialConfig['breakpoints'] === undefined) {
            return config; // No change, we simply return the config as it is
          }
  
          var breakpoints = this.initialConfig['breakpoints'];
          breakpoints.forEach(function (breakpoint) {
            if (Responsive.matchesBreakpoint(breakpoint['matches'])) {
              config = Object.assign(config, breakpoint['settings']);
            }
          });
          return config;
        }
        /**
         * Verify if the breakpoint has changed, and optionally update the carousel
         */
  
      }, {
        key: "_onBreakpointChanged",
        value: function _onBreakpointChanged() {
          // The breakpoint may have changed, so we delete the carousel and rebuild it
          this.flickityInstance.destroy();
  
          this._build();
        }
      }]);
  
      return Carousel;
    }();
  
    var Animation = /*#__PURE__*/function () {
      function Animation() {
        _classCallCheck(this, Animation);
      }
  
      _createClass(Animation, null, [{
        key: "slideUp",
        value:
        /**
         * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
         * force an animation
         */
        function slideUp(element) {
          element.style.height = "".concat(element.scrollHeight, "px"); // Force previous height to allow CSS transition
  
          element.offsetHeight; // Force redraw
  
          element.style.height = 0;
        }
        /**
         * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
         * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
         */
  
      }, {
        key: "slideDown",
        value: function slideDown(element) {
          if (element.style.height === 'auto') {
            return;
          } // To do the animation we temporarily hide it, check the height, and transition to it
  
  
          element.style.height = "".concat(element.firstElementChild.scrollHeight, "px");
  
          var transitionEnded = function transitionEnded(event) {
            if (event.propertyName === 'height') {
              element.style.height = 'auto'; // Allows the content to grow normally
  
              element.removeEventListener('transitionend', transitionEnded);
            }
          };
  
          element.addEventListener('transitionend', transitionEnded);
        }
      }]);
  
      return Animation;
    }();
  
    /**
     * Various DOM helper
     */
    var Dom = /*#__PURE__*/function () {
      function Dom() {
        _classCallCheck(this, Dom);
      }
  
      _createClass(Dom, null, [{
        key: "getSiblings",
        value:
        /**
         * Get all the previous and next siblings, optionally filtered by a selector
         */
        function getSiblings(element, filter) {
          var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var siblings = [];
          var currentElement = element; // Do the previous first
  
          while (currentElement = currentElement.previousElementSibling) {
            if (!filter || currentElement.matches(filter)) {
              siblings.push(currentElement);
            }
          }
  
          if (includeSelf) {
            siblings.push(element);
          } // Then the next side
  
  
          currentElement = element;
  
          while (currentElement = currentElement.nextElementSibling) {
            if (!filter || currentElement.matches(filter)) {
              siblings.push(currentElement);
            }
          }
  
          return siblings;
        }
        /**
         * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
         * we need to normalize it
         */
  
      }, {
        key: "nodeListToArray",
        value: function nodeListToArray(nodeList, filter) {
          var items = [];
  
          for (var i = 0; i !== nodeList.length; ++i) {
            if (!filter || nodeList[i].matches(filter)) {
              items.push(nodeList[i]);
            }
          }
  
          return items;
        }
        /**
         * Calculate an element width with its margin
         */
  
      }, {
        key: "outerWidthWithMargin",
        value: function outerWidthWithMargin(element) {
          var width = element.offsetWidth,
              style = getComputedStyle(element);
          width += parseInt(style.marginLeft) + parseInt(style.marginRight);
          return width;
        }
        /**
         * Calculate an element height with its margin
         */
  
      }, {
        key: "outerHeightWithMargin",
        value: function outerHeightWithMargin(element) {
          var height = element.offsetHeight,
              style = getComputedStyle(element);
          height += parseInt(style.marginTop) + parseInt(style.marginBottom);
          return height;
        }
      }]);
  
      return Dom;
    }();
  
    var Accessibility = /*#__PURE__*/function () {
      function Accessibility() {
        _classCallCheck(this, Accessibility);
      }
  
      _createClass(Accessibility, null, [{
        key: "announce",
        value:
        /**
         * Announce a short message to screen readers via a shared live region
         */
        function announce(message) {
          var politeness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assertive';

          if (!message) {
            return;
          }

          var regionId = 'AccessibilityStatusMessage';
          var region = document.getElementById(regionId);

          if (!region) {
            region = document.createElement('div');
            region.id = regionId;
            region.className = 'u-visually-hidden';
            region.setAttribute('role', 'status');
            region.setAttribute('aria-live', politeness);
            region.setAttribute('aria-atomic', 'true');
            document.body.appendChild(region);
          } else {
            // Ensure live region stays exposed while Quick view hides the rest of the page
            region.removeAttribute('aria-hidden');
            region.setAttribute('role', 'status');
            region.setAttribute('aria-atomic', 'true');
          }

          region.setAttribute('aria-live', politeness);
          region.textContent = '';
          window.setTimeout(function () {
            region.textContent = message;
          }, 50);
        }
      }, {
        key: "trapFocus",
        value:
        /**
         * Traps the focus in a particular container
         */
        function trapFocus(container, namespace, preferredFocus) {
          this.listeners = this.listeners || {};
          var elementToFocus = preferredFocus || container.querySelector('[autofocus]') || container.querySelector('.Drawer__Close, .Popover__Close');

          if (!elementToFocus) {
            elementToFocus = container.querySelector('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
          }

          if (elementToFocus) {
            elementToFocus.focus();
          }

          this.listeners[namespace] = function (event) {
            if (container !== event.target && !container.contains(event.target)) {
              var fallbackFocusTarget = container.querySelector('.Drawer__Close, .Popover__Close') || container.querySelector('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');

              if (fallbackFocusTarget) {
                fallbackFocusTarget.focus();
              }
            }
          };

          document.addEventListener('focusin', this.listeners[namespace]);
        }
        /**
         * Removes the trap of focus in a particular container
         */
  
      }, {
        key: "removeTrapFocus",
        value: function removeTrapFocus(container, namespace) {
          if (container) {
            container.removeAttribute('tabindex');
          }
  
          if (this.listeners && this.listeners[namespace]) {
            document.removeEventListener('focusin', this.listeners[namespace]);
          }
        }
        /**
         * Reset any previous trap focus
         */
  
      }, {
        key: "clearTrapFocus",
        value: function clearTrapFocus() {
          for (var key in this.listeners) {
            if (this.listeners.hasOwnProperty(key)) {
              document.removeEventListener('focusin', this.listeners[key]);
            }
          }
  
          this.listeners = {};
        }
      }]);
  
      return Accessibility;
    }();
  
    var Drawer = /*#__PURE__*/function () {
      function Drawer(element) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  
        _classCallCheck(this, Drawer);
  
        this.element = element;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.delegateBody = new domDelegate.Delegate(document.body);
  
        this.onOpen = options['onOpen'] || function () {};
  
        this.onClose = options['onClose'] || function () {};
  
        this.isOpen = false;
        this.activeActivator = null;
        this.direction = this.element.classList.contains('Drawer--fromLeft') ? 'fromLeft' : 'fromRight';
        this.pageOverlayElement = document.querySelector('.PageOverlay');
  
        this._attachListeners();
      }
  
      _createClass(Drawer, [{
        key: "destroy",
        value: function destroy() {
          this.delegateBody.off('click', "[data-action=\"open-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"));
          this.delegateBody.off('click', "[data-action=\"close-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"));
          window.removeEventListener('resize', this._calculateMaxHeightListener);
        }
      }, {
        key: "toggle",
        value: function toggle() {
          this.isOpen ? this.close() : this.open();
        }
      }, {
        key: "open",
        value: function open(event, target) {
          if (this.isOpen) {
            return;
          } // Make sure that the search is closed whenever a drawer is opened
  
  
          this.element.dispatchEvent(new CustomEvent('search:close', {
            bubbles: true
          }));
  
          if (event) {
            event.preventDefault();
          }

          // domDelegate passes the matched element as the second arg; currentTarget is the body root
          var activator = target || (event && event.target && event.target.closest('[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]'));

          if (!activator) {
            activator = document.querySelector('[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]');
          }

          if (activator) {
            this.activeActivator = activator;
          }

          // Hide filter body from AT during open so TalkBack/VoiceOver do not
          // auto-read the entire filter list. Header (title + close) stays available.
          clearTimeout(this._openFocusTimer);
          clearTimeout(this._revealContentTimer);
          this._deferredContent = null;

          if (this.element.classList.contains('CollectionFilters')) {
            this._deferredContent = this.element.querySelector('.Drawer__Content');

            if (this._deferredContent) {
              this._deferredContent.setAttribute('aria-hidden', 'true');
            }
          }

          this.element.removeAttribute('inert');
          this.element.setAttribute('aria-hidden', 'false');

          if (this.activeActivator) {
            this.activeActivator.setAttribute('aria-expanded', 'true');
          }

          this._calculateMaxHeight();

          document.documentElement.classList.add('no-scroll'); // This prevent the body to scroll on iOS. This is honestly a bit hacky, but until the platform supports "touch-action: none" like
          // other browsers, this is the only way to achieve that
          //disableBodyScroll(true, '[data-scrollable]');

          var _thisOpen = this;
          var closeButton = this.element.querySelector('.Drawer__Close');
          var openAnnouncement = this.element.getAttribute('data-open-announcement');

          document.querySelector('#shopify-section-header').style.zIndex = ''; // Ugly hack
          // We attach an event to the page overlay to close it
  
          this.pageOverlayElement.classList.add('is-visible');
          this.pageOverlayElement.addEventListener('click', this._closeListener);
          this.isOpen = true;
          this.onOpen(); // Call the callback to allow other code to hook their logic

          if (openAnnouncement) {
            Accessibility.announce(openAnnouncement, 'assertive');
          }

          Accessibility.trapFocus(this.element, 'drawer', closeButton);

          // Re-focus close after visibility settles, then reveal filter list for navigation
          this._openFocusTimer = setTimeout(function () {
            if (!_thisOpen.isOpen) {
              return;
            }

            var closeBtn = _thisOpen.element.querySelector('.Drawer__Close');

            if (closeBtn) {
              closeBtn.focus();
            }

            _thisOpen._revealContentTimer = setTimeout(function () {
              if (_thisOpen._deferredContent) {
                _thisOpen._deferredContent.removeAttribute('aria-hidden');
                _thisOpen._deferredContent = null;
              }
            }, 500);
          }, 150);
  
          return false;
        }
      }, {
        key: "close",
        value: function close(event) {
          if (!this.isOpen) {
            return;
          }

          clearTimeout(this._openFocusTimer);
          clearTimeout(this._revealContentTimer);

          if (this._deferredContent) {
            this._deferredContent.removeAttribute('aria-hidden');
            this._deferredContent = null;
          }
  
          if (event) {
            event.preventDefault();
          }
  
          this.element.setAttribute('aria-hidden', 'true');
          this.element.setAttribute('inert', '');
          document.documentElement.classList.remove('no-scroll'); //disableBodyScroll(false, '[data-scrollable]');

          Accessibility.removeTrapFocus(this.element, 'drawer');
          this.pageOverlayElement.classList.remove('is-visible');
          this.pageOverlayElement.removeEventListener('click', this._closeListener);
          this.isOpen = false;

          var activator = this.activeActivator || document.querySelector('[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]');
          this.activeActivator = null;

          if (activator) {
            activator.setAttribute('aria-expanded', 'false');
            // Defer focus restore so it wins after the drawer becomes inert/hidden on mobile
            window.setTimeout(function () {
              activator.focus();
            }, 10);
          }

          this.onClose(); // Call the callback to allow other code to hook their logic
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._openListener = this.open.bind(this);
          this._closeListener = this.close.bind(this);
          this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);
          this.delegateBody.on('click', "[data-action=\"open-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"), this._openListener);
          this.delegateBody.on('click', "[data-action=\"close-drawer\"][data-drawer-id=\"".concat(this.element.id, "\"]"), this._closeListener);
          this.element.addEventListener('keyup', this._handleKeyboard.bind(this));
          window.addEventListener('resize', this._calculateMaxHeightListener);
        }
        /**
         * Make sure that we force a max-height so that the drawer always stays on screen
         */
  
      }, {
        key: "_calculateMaxHeight",
        value: function _calculateMaxHeight() {
          this.element.style.maxHeight = window.innerHeight + 'px';
        }
      }, {
        key: "_handleKeyboard",
        value:
        /**
         * Handle a11y events
         */
        function _handleKeyboard(event) {
          if (this.isOpen && event.keyCode === 27) {
            this.close();
          }
        }
      }]);
  
      return Drawer;
    }();
  
    /**
     * Simple plugin that handles the loading bar actions
     *
     * This plugin uses delegate events so it's independent of the sections.
     */
    var LoadingBar = /*#__PURE__*/function () {
      function LoadingBar() {
        _classCallCheck(this, LoadingBar);
  
        this.element = document.querySelector('.LoadingBar');
        document.addEventListener('theme:loading:start', this._onLoadingStart.bind(this));
        document.addEventListener('theme:loading:end', this._onLoadingEnd.bind(this));
        this.element.addEventListener('transitionend', this._onTransitionEnd.bind(this));
      }
  
      _createClass(LoadingBar, [{
        key: "_onLoadingStart",
        value: function _onLoadingStart() {
          this.element.classList.add('is-visible');
          this.element.style.width = '40%';
        }
      }, {
        key: "_onLoadingEnd",
        value: function _onLoadingEnd() {
          this.element.style.width = '100%';
          this.element.classList.add('is-finished');
        }
      }, {
        key: "_onTransitionEnd",
        value: function _onTransitionEnd(event) {
          if (event.propertyName === 'width' && this.element.classList.contains('is-finished')) {
            this.element.classList.remove('is-visible');
            this.element.classList.remove('is-finished');
            this.element.style.width = '0';
          }
        }
      }]);
  
      return LoadingBar;
    }();
  
    var Modal = /*#__PURE__*/function () {
      function Modal() {
        _classCallCheck(this, Modal);
  
        this.domDelegate = new domDelegate.Delegate(document.body);
        this.activeModal = null; // Keep track of the active modal
  
        this.wasLocked = false;
        this.pageOverlayElement = document.querySelector('.PageOverlay');
  
        this._attachListeners();
  
        this._checkOpenByHash();
      }
  
      _createClass(Modal, [{
        key: "_attachListeners",
        value: function _attachListeners() {
          this._closeListener = this._closeModal.bind(this);
          this._handleKeyboardListener = this._handleKeyboard.bind(this);
          this.domDelegate.on('click', '[data-action="open-modal"]', this._openModalEvent.bind(this));
          this.domDelegate.on('click', '[data-action="close-modal"]', this._closeModal.bind(this));
        }
      }, {
        key: "_openModalEvent",
        value: function _openModalEvent(event, target) {
          this._openModal(document.getElementById(target.getAttribute('aria-controls')));
  
          event.preventDefault();
          event.stopPropagation();
        }
      }, {
        key: "_openModal",
        value: function _openModal(modal) {
          var _this = this;
  
          if (this.activeModal || !modal) {
            return; // If there is already an open modal, we return as we only allows one modal at a time
          }
  
          this.activeModal = modal;
          this.domDelegate.on('keyup', this._handleKeyboardListener);
  
          if (document.documentElement.classList.contains('no-scroll')) {
            this.wasLocked = true;
          }
  
          fastdom.mutate(function () {
            Accessibility.clearTrapFocus(); // Needed as the modal can be open on top of a popover
  
            _this._onTransitionEndedListener = _this._onTransitionEnded.bind(_this);
  
            _this.activeModal.addEventListener('transitionend', _this._onTransitionEndedListener);
  
            _this.activeModal.setAttribute('aria-hidden', 'false');
  
            document.documentElement.classList.add('no-scroll'); // If the modal is not a fullscreen modal, then we also display the overlay
  
            if (!_this.activeModal.classList.contains('Modal--fullScreen')) {
              _this.pageOverlayElement.classList.add('is-visible');
  
              _this.pageOverlayElement.addEventListener('click', _this._closeListener);
            }
          });
        }
      }, {
        key: "_closeModal",
        value: function _closeModal() {
          var _this2 = this;
  
          if (!this.activeModal) {
            return; // If no modal are open, we return immediately
          }
  
          this.activeModal.removeEventListener('keyup', this._handleKeyboardListener);
          this.domDelegate.off('keyup');
          fastdom.mutate(function () {
            // If the modal is of video type, we need to remove the iframe to stop the video
            if (_this2.activeModal.classList.contains('Modal--videoContent')) {
              _this2._resetVideoListener = _this2._resetVideo.bind(_this2);
  
              _this2.activeModal.addEventListener('transitionend', _this2._resetVideoListener);
            }
  
            Accessibility.removeTrapFocus(_this2.activeModal, 'modal');
  
            if (!_this2.activeModal.classList.contains('Modal--fullScreen')) {
              _this2.pageOverlayElement.classList.remove('is-visible');
  
              _this2.pageOverlayElement.removeEventListener('click', _this2._closeListener);
            }
  
            _this2.activeModal.setAttribute('aria-hidden', 'true');
  
            _this2.activeModal = null;
  
            if (!_this2.wasLocked) {
              document.documentElement.classList.remove('no-scroll');
            }
          });
        }
      }, {
        key: "_onTransitionEnded",
        value: function _onTransitionEnded(event) {
          if (event.propertyName !== 'visibility') {
            return;
          }
  
          Accessibility.trapFocus(this.activeModal, 'modal'); // Trap the focus first (as this trigger reflows)
  
          this.activeModal.removeEventListener('transitionend', this._onTransitionEndedListener);
        }
      }, {
        key: "_resetVideo",
        value: function _resetVideo(event) {
          if (event.propertyName !== 'visibility') {
            return; // We check the visibility property as it's the one LazySizes uses for triggering lazyloading
          }
  
          var iframe = event.target.querySelector('iframe');
          iframe.parentNode.innerHTML = "<iframe class=\"Image--lazyLoad\" data-src=".concat(iframe.getAttribute('data-src'), " frameborder=\"0\" allowfullscreen>");
          event.target.removeEventListener('transitionend', this._resetVideoListener);
        }
        /**
         * Some forms needs to be open inside a modal, and on page reload we must make sure to properly open the modal again
         */
  
      }, {
        key: "_checkOpenByHash",
        value: function _checkOpenByHash() {
          var hash = window.location.hash,
              modal = document.getElementById(hash.replace('#', ''));
  
          if (modal && modal.classList.contains('Modal')) {
            this._openModal(modal);
          }
        }
        /**
         * Handle a11y events
         */
  
      }, {
        key: "_handleKeyboard",
        value: function _handleKeyboard(event) {
          if (null !== this.activeModal && event.keyCode === 27) {
            this._closeModal();
          }
        }
      }]);
  
      return Modal;
    }();
  
    var Popover = /*#__PURE__*/function () {
      function Popover(element, options) {
        _classCallCheck(this, Popover);
  
        this.element = element;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this._activatorExplicit = Boolean(options['activator']);
        this.activator = options['activator'] || document.querySelector("[aria-controls=\"".concat(element.getAttribute('id'), "\"]"));
        this.preferredPosition = options['preferredPosition'] || 'bottom';
        this.preferredAlignment = options['preferredAlignment'] || undefined;
        this.threshold = options['threshold'] || 20;
        this.isOpen = false;
  
        this.onValueChanged = options['onValueChanged'] || function () {};
  
        this.onOpen = options['onOpen'] || function () {};
  
        this.onClose = options['onClose'] || function () {};
  
        this.showOverlay = options['showOverlay'] === undefined ? true : options['showOverlay'];
        this.suppressActivatorClick = options['suppressActivatorClick'] === true;
        this.pageOverlayElement = document.querySelector('.PageOverlay');
  
        this._attachListeners();
      }
  
      _createClass(Popover, [{
        key: "destroy",
        value: function destroy() {
          this.element.removeEventListener('keyup', this._handleKeyboardListener);
          this.delegateElement.off('click');

          if (this.activator && !this.suppressActivatorClick) {
            this.activator.removeEventListener('click', this._toggleListener);
          }
        }
      }, {
        key: "toggle",
        value: function toggle() {
          this.isOpen ? this.close() : this.open();
        }
      }, {
        key: "open",
        value: function open() {
          var _this = this;
  
          // Note: the additional check on the aria-controls is used here so that a given activator can be used on different
          //       popovers and be modified dynamically in JavaScript
          if (this.isOpen) {
            return;
          }

          if (!this._activatorExplicit && this.activator.getAttribute('aria-controls') !== this.element.id) {
            return;
          }

          clearTimeout(this._openFocusTimer);
          clearTimeout(this._revealContentTimer);
          this._deferredContent = null;

          var isDialog = this.element.getAttribute('role') === 'dialog';
          var isPocket = !Responsive.matchesBreakpoint('lap-and-up');
          var isSortPopover = this.element.classList.contains('CollectionSortPopover');

          // On mobile dialogs (non-sort), hide content briefly so SRs don't read every value
          if (isDialog && isPocket && !isSortPopover) {
            this._deferredContent = this.element.querySelector('.Popover__Content, .Popover__ValueList');

            if (this._deferredContent) {
              this._deferredContent.setAttribute('aria-hidden', 'true');
            }
          }
  
          this.element.removeAttribute('inert');
          this.element.setAttribute('aria-hidden', 'false');
          this.activator.setAttribute('aria-expanded', 'true');
          disableBodyScroll(true, '[data-scrollable]');
          document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open

          var openAnnouncement = this.element.getAttribute('data-open-announcement');

          if (isDialog && openAnnouncement) {
            Accessibility.announce(openAnnouncement, 'assertive');
          }
  
          if (Responsive.matchesBreakpoint('lap-and-up')) {
            document.body.addEventListener('click', this._clickOutsideListener);

            this._position();

            this.element.addEventListener('transitionend', function () {
              _this._focusPopoverInitial();
            }, {
              once: true
            });

            this._openFocusTimer = setTimeout(function () {
              if (_this.isOpen && !_this.element.contains(document.activeElement)) {
                _this._focusPopoverInitial();
              }
            }, 250);
          } else {
            this.element.removeAttribute('style');

            if (this.showOverlay) {
              this.pageOverlayElement.classList.add('is-visible');
              this.pageOverlayElement.addEventListener('click', this._closeListener);
            }

            var closeButton = this.element.querySelector('.Popover__Close');

            // Sort uses Menu Button pattern (no dialog focus trap). Other mobile dialogs trap focus.
            if (isDialog && !isSortPopover) {
              Accessibility.trapFocus(this.element, 'popover-' + this.element.id, closeButton);
            }

            this.element.addEventListener('transitionend', function () {
              _this._focusPopoverInitial();
            }, {
              once: true
            });

            this._openFocusTimer = setTimeout(function () {
              if (!_this.isOpen) {
                return;
              }

              _this._focusPopoverInitial();

              _this._revealContentTimer = setTimeout(function () {
                if (_this._deferredContent) {
                  _this._deferredContent.removeAttribute('aria-hidden');
                  _this._deferredContent = null;
                }
              }, 500);
            }, 150);
          }
  
          this.onOpen(this); // Call the callback to allow other code to hook their logic
  
          this.isOpen = true;
        }
      }, {
        key: "close",
        value: function close(options) {
          if (!this.isOpen) {
            return;
          }

          var restoreFocus = !options || options.restoreFocus !== false;

          clearTimeout(this._openFocusTimer);
          clearTimeout(this._revealContentTimer);

          if (this._deferredContent) {
            this._deferredContent.removeAttribute('aria-hidden');
            this._deferredContent = null;
          }

          this.element.setAttribute('aria-hidden', 'true');
          this.element.setAttribute('inert', '');
          this.activator.setAttribute('aria-expanded', 'false');
          disableBodyScroll(false, '[data-scrollable]');
          document.documentElement.classList.remove('no-scroll');

          if (this.element.classList.contains('CollectionSortPopover')) {
            this._clearSortListboxMaxHeight();
          }

          Accessibility.removeTrapFocus(this.element, 'popover-' + this.element.id);

          if (Responsive.matchesBreakpoint('lap-and-up')) {
            document.body.removeEventListener('click', this._clickOutsideListener);
          } else if (this.showOverlay) {
            this.pageOverlayElement.classList.remove('is-visible');
            this.pageOverlayElement.removeEventListener('click', this._closeListener);
          }
  
          this.element.removeAttribute('tabindex');

          // Menu Button: restore focus on Esc/selection; Tab dismiss leaves focus where it moved
          if (restoreFocus && this.activator) {
            this.activator.focus();
          }

          this.onClose(this); // Call the callback to allow other code to hook their logic

          this.isOpen = false;
        }
      }, {
        key: "_focusPopoverInitial",
        value: function _focusPopoverInitial() {
          var header = this.element.querySelector('.Popover__Header');
          var headerVisible = header && window.getComputedStyle(header).display !== 'none';
          var closeButton = this.element.querySelector('.Popover__Close, [data-action="close-popover"]');
          var target = null;

          // Sort menu focus is handled by CollectionSection Menu Button logic
          if (this.element.classList.contains('CollectionSortPopover')) {
            return;
          }

          if (closeButton && headerVisible) {
            target = closeButton;
          } else {
            target = this.element.querySelector('.Popover__Value.is-selected') || this.element.querySelector('.Popover__Value, [data-action="select-value"]');
          }

          if (!target) {
            this.element.setAttribute('tabindex', '-1');
            target = this.element;
          }

          target.focus();
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._handleKeyboardListener = this._handleKeyboard.bind(this);
          this._clickOutsideListener = this._clickOutside.bind(this);
          this._closeListener = this.close.bind(this);
          this._toggleListener = this.toggle.bind(this);
          this.element.addEventListener('keyup', this._handleKeyboardListener);

          if (this.activator && !this.suppressActivatorClick) {
            this.activator.addEventListener('click', this._toggleListener);
          }

          this.delegateElement.on('click', '[data-action="close-popover"]', this.close.bind(this));
          this.delegateElement.on('click', '[data-action="select-value"]', this._valueChanged.bind(this));

          if (this.element.hasAttribute('id')) {
            this.delegateElement.on('focusout', "#".concat(this.element.getAttribute('id')), this._onFocusOut.bind(this));
          }
        }
        /**
         * Whenever a value is selected, it can notify a callback so that the calling code can do its own logic in response
         * of the value change
         */

      }, {
        key: "_valueChanged",
        value: function _valueChanged(event) {
          Dom.getSiblings(event.target, '.is-selected').forEach(function (item) {
            return item.classList.remove('is-selected');
          });
          event.target.classList.add('is-selected'); // If there is a callback in option we call it with the value
  
          this.onValueChanged(event.target.getAttribute('data-value'), event.target, this.activator);
          this.close();
        }
      }, {
        key: "_onFocusOut",
        value: function _onFocusOut(event) {
          if (this.element.classList.contains('CollectionSortPopover')) {
            var menu = this.element.querySelector('#collection-sort-listbox');

            if (event.relatedTarget === this.activator || menu && menu.contains(event.relatedTarget) || this.element.contains(event.relatedTarget)) {
              return;
            }

            // Some browsers (esp. zoom / AT) report null relatedTarget — confirm focus actually left
            if (!event.relatedTarget) {
              var self = this;
              window.setTimeout(function () {
                if (!self.isOpen) {
                  return;
                }

                var active = document.activeElement;

                if (self.element.contains(active) || active === self.activator || menu && menu.contains(active)) {
                  return;
                }

                self.close({
                  restoreFocus: false
                });
              }, 0);
              return;
            }

            this.close({
              restoreFocus: false
            });
            return;
          }

          if (!this.element.contains(event.relatedTarget) && event.relatedTarget !== this.activator) {
            this.close();
          }
        }
        /**
         * Callback that is called to decide if we should close the popover when a click is captured outside
         */
  
      }, {
        key: "_clickOutside",
        value: function _clickOutside(event) {
          if (!event.target.closest('.Popover') && !event.target.closest('.Modal') && event.target !== this.activator && !this.activator.contains(event.target)) {
            this.close();
          }
        }
        /**
         * On desktop, we reposition the popover in JavaScript by doing some smart logic to detect the most appropriate area
         */
  
      }, {
        key: "_position",
        value: function _position() {
          var _this2 = this;
  
          var topPosition = 0,
              rightPosition = 0,
              position = '',
              alignment = '',
              threshold = this.threshold;
          fastdom.measure(function () {
            var windowHeight = window.innerHeight,
                activatorBoundingRect = _this2.activator.getBoundingClientRect(),
                halfHeight = windowHeight / 2;
  
            if (_this2.preferredPosition === 'bottom') {
              alignment = 'right';
  
              if (_this2.element.clientHeight <= windowHeight - (activatorBoundingRect.bottom + threshold) || windowHeight - activatorBoundingRect.bottom >= halfHeight) {
                position = 'bottom';
              } else {
                position = 'top';
              }
            } else if (_this2.preferredPosition === 'top') {
              alignment = 'right';
  
              if (_this2.element.clientHeight <= activatorBoundingRect.top - threshold || activatorBoundingRect.top >= halfHeight) {
                position = 'top';
              } else {
                position = 'bottom';
              }
            } else {
              position = 'left'; // Is there enough space to use the center alignment (which is preferred)?
  
              var halfElementHeight = _this2.element.clientHeight / 2;
  
              if (activatorBoundingRect.top >= halfElementHeight && windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
                alignment = 'center';
              } else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
                alignment = 'bottom';
              } else {
                alignment = 'top';
              }
            }
  
            if (_this2.preferredAlignment) {
              alignment = _this2.preferredAlignment;
            }
  
            if (position === 'top') {
              topPosition = activatorBoundingRect.top - _this2.element.clientHeight - threshold;
  
              if (alignment === 'center') {
                rightPosition = window.innerWidth - activatorBoundingRect.right - _this2.element.clientWidth / 2 + 3;
              } else {
                rightPosition = window.innerWidth - activatorBoundingRect.right;
              }
            } else if (position === 'bottom') {
              topPosition = activatorBoundingRect.bottom + threshold;
  
              if (alignment === 'center') {
                rightPosition = window.innerWidth - activatorBoundingRect.right - _this2.element.clientWidth / 2 + 3;
              } else {
                rightPosition = window.innerWidth - activatorBoundingRect.right;
              }
            } else {
              rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;
  
              if (alignment === 'center') {
                topPosition = activatorBoundingRect.top - _this2.element.clientHeight / 2 + _this2.activator.clientHeight / 2;
              } else if (alignment === 'top') {
                topPosition = activatorBoundingRect.bottom - _this2.element.clientHeight;
              } else {
                topPosition = activatorBoundingRect.top;
              }
            }
          });
          fastdom.mutate(function () {
            ['Popover--positionBottom', 'Popover--positionTop', 'Popover--positionCenter', 'Popover--alignTop', 'Popover--alignCenter', 'Popover--alignBottom'].map(function (item) {
              return _this2.element.classList.remove(item);
            });
  
            _this2.element.classList.add("Popover--position".concat(position.charAt(0).toUpperCase() + position.slice(1)));
  
            _this2.element.classList.add("Popover--align".concat(alignment.charAt(0).toUpperCase() + alignment.slice(1)));

            var initialTop = parseInt(topPosition, 10);
            var finalRight = parseInt(rightPosition, 10);

            if (_this2.element.classList.contains('CollectionSortPopover')) {
              var activatorRect = _this2.activator.getBoundingClientRect();
              var leftPos = Math.round(activatorRect.left);
              var margin = 16;

              _this2.element.setAttribute('style', "top: ".concat(initialTop, "px; left: ").concat(leftPos, "px; right: auto;"));

              var finalTop = _this2._clampSortPopoverTop(initialTop);

              _this2._applySortListboxMaxHeight(finalTop);
              finalTop = _this2._clampSortPopoverTop(finalTop);

              var popoverWidth = _this2.element.offsetWidth;

              if (leftPos + popoverWidth > window.innerWidth - margin) {
                leftPos = Math.max(margin, window.innerWidth - margin - popoverWidth);
              }

              _this2.element.setAttribute('style', "top: ".concat(finalTop, "px; left: ").concat(leftPos, "px; right: auto;"));
            } else {
              _this2.element.setAttribute('style', "top: ".concat(initialTop, "px; right: ").concat(finalRight, "px;"));
            }
          });
        }
      }, {
        key: "_clampSortPopoverTop",
        value: function _clampSortPopoverTop(topPosition) {
          var margin = 16;
          var viewportHeight = window.innerHeight;
          var popoverHeight = this.element.offsetHeight;

          if (topPosition + popoverHeight > viewportHeight - margin) {
            topPosition = Math.max(margin, viewportHeight - margin - popoverHeight);
          }

          if (topPosition < margin) {
            topPosition = margin;
          }

          return topPosition;
        }
      }, {
        key: "_applySortListboxMaxHeight",
        value: function _applySortListboxMaxHeight(topPosition) {
          var listbox = this.element.querySelector('#collection-sort-listbox');

          if (!listbox) {
            return;
          }

          var margin = 16;
          var availableHeight = window.innerHeight - topPosition - margin;
          var maxHeight = Math.max(120, Math.min(385, availableHeight));

          listbox.style.maxHeight = maxHeight + 'px';
          listbox.style.overflowY = 'auto';
        }
      }, {
        key: "_clearSortListboxMaxHeight",
        value: function _clearSortListboxMaxHeight() {
          var listbox = this.element.querySelector('#collection-sort-listbox');

          if (listbox) {
            listbox.style.maxHeight = '';
            listbox.style.overflowY = '';
          }
        }
  
      }, {
        key: "_handleKeyboard",
        value: function _handleKeyboard(event) {
          if (this.isOpen && event.keyCode === 27) {
            this.close();
          }
        }
      }]);
  
      return Popover;
    }();
  
    /**
     * This class will coordinate all the transitions from the website
     */
    var PageTransition = /*#__PURE__*/function () {
      function PageTransition() {
        _classCallCheck(this, PageTransition);
  
        this.domDelegate = new domDelegate.Delegate(document.body);
        this.pageTransition = document.querySelector('.PageTransition');
  
        this._attachListeners();
      }
  
      _createClass(PageTransition, [{
        key: "_attachListeners",
        value: function _attachListeners() {
          this.domDelegate.on('click', 'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])', this._onPageUnload.bind(this));
        }
        /**
         * This callback captures click and transition from one page to another by doing a transition
         */
  
      }, {
        key: "_onPageUnload",
        value: function _onPageUnload(event, target) {
          var _this = this;
  
          if (event.defaultPrevented || event.ctrlKey || event.metaKey || !window.theme.showPageTransition || !this.pageTransition) {
            return;
          }
  
          event.preventDefault(); // Prevent the click to happen
  
          if (window.theme.showPageTransition && this.pageTransition) {
            var doTransition = function doTransition(event) {
              // Animation is finished, we can transition
              if (event.propertyName === 'opacity') {
                _this.pageTransition.removeEventListener('transitionend', doTransition);
  
                window.location.href = target.href;
              }
            };
  
            this.pageTransition.addEventListener('transitionend', doTransition);
            this.pageTransition.style.visibility = 'visible';
            this.pageTransition.style.opacity = '1';
          }
        }
      }], [{
        key: "getInstance",
        value: function getInstance() {
          if (!this.instance) {
            this.instance = new PageTransition();
          }
  
          return this.instance;
        }
      }]);
  
      return PageTransition;
    }();
  
    /**
     * Note: this was a feature that was added at the very end and couldn't do something much cleaner without rewriting large parts of the theme...
     */
    var ProductItemColorSwatch = /*#__PURE__*/function () {
      function ProductItemColorSwatch(element) {
        _classCallCheck(this, ProductItemColorSwatch);
  
        this.element = element;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.delegateElement.on('change', '.ColorSwatch__Radio', this._colorChanged.bind(this));
      }
  
      _createClass(ProductItemColorSwatch, [{
        key: "_colorChanged",
        value: function _colorChanged(event, target) {
          // We need to change the URL of the various links
          var productItem = target.closest('.ProductItem'),
              variantUrl = target.getAttribute('data-variant-url');
          productItem.querySelector('.ProductItem__ImageWrapper').setAttribute('href', variantUrl);
          productItem.querySelector('.ProductItem__Title > a').setAttribute('href', variantUrl); // If we have a custom image for the variant, we change it
  
          var originalImageElement = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
  
          if (target.hasAttribute('data-image-url') && target.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
            var newImageElement = document.createElement('img');
            newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
            newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'));
            newImageElement.setAttribute('data-src', target.getAttribute('data-image-url'));
            newImageElement.setAttribute('data-widths', target.getAttribute('data-image-widths'));
            newImageElement.setAttribute('data-sizes', 'auto');
            newImageElement.setAttribute('alt', '');
            newImageElement.setAttribute('aria-hidden', 'true');
  
            if (window.theme.productImageSize === 'natural') {
              originalImageElement.parentNode.style.paddingBottom = "".concat(100.0 / target.getAttribute('data-image-aspect-ratio'), "%");
            }
  
            originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.getAttribute('data-image-aspect-ratio'));
            originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
          }
        }
      }]);
  
      return ProductItemColorSwatch;
    }();
  
    var Image = /*#__PURE__*/function () {
      function Image() {
        _classCallCheck(this, Image);
      }
  
      _createClass(Image, null, [{
        key: "getSizedImageUrl",
        value:
        /**
         * Create a CDN URL (similar to the img_url filter in Liquid)
         */
        function getSizedImageUrl(src, size) {
          if (size === null) {
            return src;
          }
  
          if (size === 'master') {
            return src.replace(/http(s)?:/, '');
          }
  
          var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
          if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];
            return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
          } else {
            return null;
          }
        }
        /**
         * From a given set of desired sizes and a given image, filter out any unwanted sizes
         */
  
      }, {
        key: "getSupportedSizes",
        value: function getSupportedSizes(image, desiredSizes) {
          var supportedSizes = [],
              imageWidth = image['width'];
          desiredSizes.forEach(function (width) {
            if (imageWidth >= width) {
              supportedSizes.push(width);
            }
          });
          return supportedSizes;
        }
      }]);
  
      return Image;
    }();
  
    var ProductImageZoom = /*#__PURE__*/function () {
      function ProductImageZoom(element, slideshow) {
        _classCallCheck(this, ProductImageZoom);
  
        this.element = element;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.delegateRoot = new domDelegate.Delegate(document.body);
        this.slideshow = slideshow;
  
        this._attachListeners();
      }
  
      _createClass(ProductImageZoom, [{
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off('click');
          this.delegateElement.off('keydown');
          this._teardownPhotoSwipeUi();
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on('click', '[data-action="open-product-zoom"]', this._initPhotoSwipe.bind(this));
          this.delegateElement.on('click', '.Product__SlideItem__ZoomButton', this._initPhotoSwipeFromImageClick.bind(this));
          // Explicit keyboard path: Space can scroll the page unless prevented, and some agents skip native button activation
          this.delegateElement.on('keydown', '[data-action="open-product-zoom"]', this._onZoomTriggerKeydown.bind(this));
          this.delegateElement.on('keydown', '.Product__SlideItem__ZoomButton', this._onZoomTriggerKeydown.bind(this));
        }
      }, {
        key: "_onZoomTriggerKeydown",
        value: function _onZoomTriggerKeydown(event, target) {
          if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') {
            return;
          }

          // Avoid double-open when the browser also synthesizes a click from Enter/Space
          if (event.repeat) {
            return;
          }

          event.preventDefault();

          if (target.getAttribute('data-action') === 'open-product-zoom') {
            this._initPhotoSwipe();
            return;
          }

          this._initPhotoSwipeFromImageClick(event, target);
        }
      }, {
        key: "_teardownPhotoSwipeUi",
        value: function _teardownPhotoSwipeUi() {
          this._disablePhotoSwipeFocusTrap();
          this._unbindPhotoSwipeControlButtons();
          this.delegateRoot.off('pswpTap');
        }
      }, {
        key: "_initPhotoSwipe",
        value: function _initPhotoSwipe() {
          if (this.photoSwipeInstance) {
            return;
          }

          var images = [];
          var selectedIndex = 0;

          if (this.slideshow && this.slideshow.flickityInstance && this.slideshow.flickityInstance.cells) {
            this.slideshow.flickityInstance.cells.forEach(function (item) {
              if (item.element.classList.contains('Product__SlideItem--image')) {
                var image = item.element.querySelector('img[data-original-src]') || item.element.querySelector('img');

                if (image) {
                  images.push(image);
                }
              }
            });

            if (this.slideshow.flickityInstance.selectedElement) {
              selectedIndex = parseInt(this.slideshow.flickityInstance.selectedElement.getAttribute('data-image-media-position')) || 0;
            }
          }

          if (!images.length) {
            images = Dom.nodeListToArray(this.element.querySelectorAll('.Product__SlideItem--image img[data-original-src]'));
            var selectedSlide = this.element.querySelector('.Product__SlideItem--image.is-selected') || this.element.querySelector('.Product__SlideItem--image');

            if (selectedSlide) {
              selectedIndex = parseInt(selectedSlide.getAttribute('data-image-media-position')) || 0;
            }
          }

          this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), selectedIndex);
        }
      }, {
        key: "_initPhotoSwipeFromImageClick",
        value: function _initPhotoSwipeFromImageClick(event, target) {
          if (this.photoSwipeInstance) {
            return;
          }

          var slideItem = target.closest('.Product__SlideItem--image');

          if (!slideItem) {
            return;
          }

          var images = Dom.nodeListToArray(this.element.querySelectorAll('.Product__SlideItem--image img[data-original-src]'));

          if (!images.length) {
            images = Dom.nodeListToArray(this.element.querySelectorAll('.Product__SlideItem--image img.Image--lazyLoad, .Product__SlideItem--image img.Image--lazyLoaded'));
          }

          this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(slideItem.getAttribute('data-image-media-position')));
        }
      }, {
        key: "_createPhotoSwipeItemsFromImages",
        value: function _createPhotoSwipeItemsFromImages(images) {
          return images.filter(function (image) {
            return image && image.getAttribute('data-original-src');
          }).map(function (image) {
            var maxWidth = parseInt(image.getAttribute('data-max-width')),
                maxHeight = parseInt(image.getAttribute('data-max-height')),
                maxDimension = Responsive.matchesBreakpoint('phone') ? 1200 : 1800,
                reduceFactor = 1.0;

            if (maxWidth >= maxHeight) {
              reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
            } else {
              reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
            }

            var requestedWidth = Math.floor(maxWidth / reduceFactor);
            var requestedHeight = Math.floor(maxHeight / reduceFactor);
            return {
              msrc: image.currentSrc || image.src,
              w: requestedWidth,
              h: requestedHeight,
              initialZoomLevel: 0.65,
              alt: image.getAttribute('data-image-alt') || image.getAttribute('alt') || '',
              src: Image.getSizedImageUrl(image.getAttribute('data-original-src'), requestedWidth + 'x' + requestedHeight)
            };
          });
        }
      }, {
        key: "_ensurePhotoSwipeDialogName",
        value: function _ensurePhotoSwipeDialogName(photoswipeContainer) {
          var root = photoswipeContainer || document.querySelector('.pswp');

          if (!root) {
            return;
          }

          var dialogName = (window.languages && window.languages.productImageViewer) || 'Product image viewer';

          root.setAttribute('role', 'dialog');
          root.setAttribute('aria-modal', 'true');
          root.setAttribute('aria-label', dialogName);
          root.removeAttribute('aria-labelledby');
          root.setAttribute('aria-hidden', 'false');

          // Remove legacy heading title if present (was announced as "heading level 2")
          var legacyTitle = root.querySelector('#pswp-dialog-title');
          if (legacyTitle) {
            legacyTitle.remove();
          }
        }
      }, {
        key: "_announcePhotoSwipeOpen",
        value: function _announcePhotoSwipeOpen() {
          var liveRegion = document.getElementById('pswp-status');
          var dialogName = (window.languages && window.languages.productImageViewer) || 'Product image viewer';

          if (!liveRegion) {
            return;
          }

          liveRegion.setAttribute('aria-live', 'assertive');
          liveRegion.textContent = '';

          window.setTimeout(function () {
            liveRegion.textContent = dialogName;
            window.setTimeout(function () {
              liveRegion.setAttribute('aria-live', 'polite');
            }, 1000);
          }, 30);
        }
      }, {
        key: "_createPhotoSwipeInstance",
        value: function _createPhotoSwipeInstance(items, selectedImageIndex) {
          var _this = this;
          var photoswipeContainer = document.querySelector('.pswp');

          if (!photoswipeContainer || !items || !items.length) {
            return;
          }

          this._ensurePhotoSwipeDialogName(photoswipeContainer);
          this._photoSwipeFocusTarget = 'close';
          this._photoSwipeIsReady = false;
          this._photoSwipeLastAnnouncedStatus = '';
          this._photoSwipeIgnoreActivateUntil = Date.now() + 400;
          this._photoSwipePreviousFocus = document.activeElement;
          this._teardownPhotoSwipeUi();

          this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
            index: selectedImageIndex,
            showHideOpacity: true,
            showAnimationDuration: 500,
            loop: false,
            history: false,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            allowPanToNext: false,
            pinchToClose: false,
            focus: false,
            isClickableElement: function (element) {
              return element.tagName === 'A' || element.tagName === 'BUTTON';
            },
            errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + '</p>',
            scaleMode: 'zoom',
            getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
              if (isMouseClick) {
                return 1.6;
              }

              return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            },
            getThumbBoundsFn: function getThumbBoundsFn(index) {
              var thumbnail = _this.element.querySelector(".Product__Slideshow .Carousel__Cell[data-image-media-position=\"".concat(parseInt(index), "\"] img[data-original-src]")) || _this.element.querySelector(".Product__Slideshow .Carousel__Cell[data-image-media-position=\"".concat(parseInt(index), "\"] img"));

              if (!thumbnail) {
                return {
                  x: 0,
                  y: 0,
                  w: 0
                };
              }

              var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                  rect = thumbnail.getBoundingClientRect();
              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          });

          var originalUpdateSize = this.photoSwipeInstance.updateSize,
              lastWidth = null;

          this.photoSwipeInstance.updateSize = function () {
            if (lastWidth === null || lastWidth !== window.innerWidth) {
              originalUpdateSize(this, arguments);
            }

            lastWidth = window.innerWidth;
          };

          this.photoSwipeInstance.listen('beforeChange', this._onSlideChanged.bind(this));
          this.photoSwipeInstance.listen('afterChange', this._onAfterSlideChanged.bind(this));
          this.photoSwipeInstance.listen('destroy', this._destroyPhotoSwipe.bind(this));
          this.photoSwipeInstance.listen('doubleTap', this._onDoubleTap.bind(this));
          this.photoSwipeInstance.listen('initialZoomIn', this._onInitialZoomIn.bind(this));
          this.photoSwipeInstance.listen('initialZoomOut', this._onInitialZoomOut.bind(this));
          this.delegateRoot.on('pswpTap', '.pswp__scroll-wrap', this._onSingleTap.bind(this));
          this._bindPhotoSwipeControlButtons();
          this.photoSwipeInstance.init();

          // Trap focus as soon as the dialog opens (do not wait for zoom animation).
          this._setPhotoSwipeBackgroundInert(true);
          this._enablePhotoSwipeFocusTrap();
        }
      }, {
        key: "_bindPhotoSwipeControlButtons",
        value: function _bindPhotoSwipeControlButtons() {
          var _this = this;
          var root = document.querySelector('.pswp');

          if (!root) {
            return;
          }

          this._unbindPhotoSwipeControlButtons();

          var closeButton = root.querySelector('.pswp__button--close');
          var prevButton = root.querySelector('.pswp__button--prev');
          var nextButton = root.querySelector('.pswp__button--next');
          var zoomInButton = root.querySelector('.pswp__button--zoom-in');
          var zoomOutButton = root.querySelector('.pswp__button--zoom-out');

          this._onPhotoSwipeCloseActivate = function (event) {
            _this._activatePhotoSwipeControl('close', event);
          };

          this._onPhotoSwipePrevActivate = function (event) {
            _this._activatePhotoSwipeControl('prev', event);
          };

          this._onPhotoSwipeNextActivate = function (event) {
            _this._activatePhotoSwipeControl('next', event);
          };

          this._onPhotoSwipeZoomInActivate = function (event) {
            _this._activatePhotoSwipeControl('zoom-in', event);
          };

          this._onPhotoSwipeZoomOutActivate = function (event) {
            _this._activatePhotoSwipeControl('zoom-out', event);
          };

          [closeButton, prevButton, nextButton, zoomInButton, zoomOutButton].forEach(function (button) {
            if (button) {
              button.setAttribute('type', 'button');
            }
          });

          if (closeButton) {
            closeButton.setAttribute('aria-label', window.languages.productImageViewerClose || 'Close image viewer dialog');
            closeButton.setAttribute('title', window.languages.productImageViewerCloseTitle || 'Press Escape or enter key');
            closeButton.addEventListener('click', this._onPhotoSwipeCloseActivate);
          }

          if (prevButton) {
            prevButton.setAttribute('aria-label', window.languages.productImageViewerPrev || 'Go to previous image');
            prevButton.setAttribute('title', window.languages.productImageViewerPrevTitle || 'Press left arrow or enter key');
            prevButton.addEventListener('click', this._onPhotoSwipePrevActivate);
          }

          if (nextButton) {
            nextButton.setAttribute('aria-label', window.languages.productImageViewerNext || 'Go to next image');
            nextButton.setAttribute('title', window.languages.productImageViewerNextTitle || 'Press right arrow or enter key');
            nextButton.addEventListener('click', this._onPhotoSwipeNextActivate);
          }

          if (zoomInButton) {
            zoomInButton.setAttribute('aria-label', window.languages.productImageViewerZoomIn || 'Zoom in');
            zoomInButton.setAttribute('title', window.languages.productImageViewerZoomIn || 'Zoom in');
            zoomInButton.addEventListener('click', this._onPhotoSwipeZoomInActivate);
          }

          if (zoomOutButton) {
            zoomOutButton.setAttribute('aria-label', window.languages.productImageViewerZoomOut || 'Zoom out');
            zoomOutButton.setAttribute('title', window.languages.productImageViewerZoomOut || 'Zoom out');
            zoomOutButton.addEventListener('click', this._onPhotoSwipeZoomOutActivate);
          }

          this._photoSwipeControlButtons = {
            close: closeButton,
            prev: prevButton,
            next: nextButton,
            zoomIn: zoomInButton,
            zoomOut: zoomOutButton
          };
        }
      }, {
        key: "_unbindPhotoSwipeControlButtons",
        value: function _unbindPhotoSwipeControlButtons() {
          var buttons = this._photoSwipeControlButtons;

          if (!buttons) {
            return;
          }

          if (buttons.close) {
            buttons.close.removeEventListener('click', this._onPhotoSwipeCloseActivate);
          }

          if (buttons.prev) {
            buttons.prev.removeEventListener('click', this._onPhotoSwipePrevActivate);
          }

          if (buttons.next) {
            buttons.next.removeEventListener('click', this._onPhotoSwipeNextActivate);
          }

          if (buttons.zoomIn) {
            buttons.zoomIn.removeEventListener('click', this._onPhotoSwipeZoomInActivate);
          }

          if (buttons.zoomOut) {
            buttons.zoomOut.removeEventListener('click', this._onPhotoSwipeZoomOutActivate);
          }

          this._photoSwipeControlButtons = null;
        }
      }, {
        key: "_getPhotoSwipeZoomCenter",
        value: function _getPhotoSwipeZoomCenter() {
          if (!this.photoSwipeInstance || !this.photoSwipeInstance.viewportSize) {
            return {
              x: window.innerWidth / 2,
              y: window.innerHeight / 2
            };
          }

          return {
            x: this.photoSwipeInstance.viewportSize.x / 2,
            y: this.photoSwipeInstance.viewportSize.y / 2
          };
        }
      }, {
        key: "_getPhotoSwipeMaxZoomLevel",
        value: function _getPhotoSwipeMaxZoomLevel() {
          if (!this.photoSwipeInstance || !this.photoSwipeInstance.currItem) {
            return 1.6;
          }

          var item = this.photoSwipeInstance.currItem;

          if (typeof this.photoSwipeInstance.options.getDoubleTapZoom === 'function') {
            return this.photoSwipeInstance.options.getDoubleTapZoom(true, item);
          }

          return 1.6;
        }
      }, {
        key: "_updatePhotoSwipeZoomButtonStates",
        value: function _updatePhotoSwipeZoomButtonStates() {
          var root = document.querySelector('.pswp');

          if (!root || !this.photoSwipeInstance || !this.photoSwipeInstance.currItem) {
            return;
          }

          var zoomInButton = root.querySelector('.pswp__button--zoom-in');
          var zoomOutButton = root.querySelector('.pswp__button--zoom-out');
          var currentZoom = this.photoSwipeInstance.getZoomLevel();
          var initialZoom = this.photoSwipeInstance.currItem.initialZoomLevel;
          var maxZoom = this._getPhotoSwipeMaxZoomLevel();
          var epsilon = 0.02;

          if (zoomInButton) {
            if (currentZoom >= maxZoom - epsilon) {
              zoomInButton.setAttribute('disabled', 'disabled');
            } else {
              zoomInButton.removeAttribute('disabled');
            }
          }

          if (zoomOutButton) {
            if (currentZoom <= initialZoom + epsilon) {
              zoomOutButton.setAttribute('disabled', 'disabled');
            } else {
              zoomOutButton.removeAttribute('disabled');
            }
          }
        }
      }, {
        key: "_zoomPhotoSwipe",
        value: function _zoomPhotoSwipe(direction) {
          var _thisZoom = this;

          if (!this.photoSwipeInstance || !this.photoSwipeInstance.currItem) {
            return;
          }

          var currentZoom = this.photoSwipeInstance.getZoomLevel();
          var initialZoom = this.photoSwipeInstance.currItem.initialZoomLevel;
          var maxZoom = this._getPhotoSwipeMaxZoomLevel();
          var center = this._getPhotoSwipeZoomCenter();
          var targetZoom = currentZoom;

          if (direction === 'in') {
            if (currentZoom < maxZoom - 0.02) {
              // Step toward max; first step matches mouse toggle zoom
              targetZoom = currentZoom <= initialZoom + 0.02 ? maxZoom : Math.min(currentZoom * 1.35, maxZoom);
            }
          } else if (direction === 'out') {
            if (currentZoom > initialZoom + 0.02) {
              targetZoom = currentZoom >= maxZoom - 0.02 ? initialZoom : Math.max(currentZoom / 1.35, initialZoom);
            }
          }

          if (Math.abs(targetZoom - currentZoom) < 0.01) {
            this._updatePhotoSwipeZoomButtonStates();
            return;
          }

          this._photoSwipeFocusTarget = direction === 'in' ? 'zoom-in' : 'zoom-out';
          this.photoSwipeInstance.zoomTo(targetZoom, center, 333);

          window.setTimeout(function () {
            if (!_thisZoom.photoSwipeInstance) {
              return;
            }

            _thisZoom._updatePhotoSwipeZoomButtonStates();
            _thisZoom._restorePhotoSwipeFocus();
          }, 350);
        }
      }, {
        key: "_activatePhotoSwipeControl",
        value: function _activatePhotoSwipeControl(action, event) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }

          if (!this.photoSwipeInstance) {
            return;
          }

          // Ignore accidental activation from the same Enter/Space that opened the dialog
          if (Date.now() < (this._photoSwipeIgnoreActivateUntil || 0)) {
            return;
          }

          if (action === 'close') {
            this.photoSwipeInstance.close();
            return;
          }

          if (action === 'prev') {
            this._photoSwipeFocusTarget = 'prev';
            this.photoSwipeInstance.prev();
            return;
          }

          if (action === 'next') {
            this._photoSwipeFocusTarget = 'next';
            this.photoSwipeInstance.next();
            return;
          }

          if (action === 'zoom-in') {
            this._zoomPhotoSwipe('in');
            return;
          }

          if (action === 'zoom-out') {
            this._zoomPhotoSwipe('out');
          }
        }
      }, {
        key: "_onSlideChanged",
        value: function _onSlideChanged() {
          if (!this.photoSwipeInstance) {
            return;
          }

          var prevButton = this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev');
          var nextButton = this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next');

          if (this.photoSwipeInstance.getCurrentIndex() === 0) {
            prevButton.setAttribute('disabled', 'disabled');
          } else {
            prevButton.removeAttribute('disabled');
          }

          if (this.photoSwipeInstance.getCurrentIndex() + 1 === this.photoSwipeInstance.options.getNumItemsFn()) {
            nextButton.setAttribute('disabled', 'disabled');
          } else {
            nextButton.removeAttribute('disabled');
          }

          this._updatePhotoSwipeZoomButtonStates();
        }
      }, {
        key: "_onAfterSlideChanged",
        value: function _onAfterSlideChanged() {
          if (!this._photoSwipeIsReady) {
            return;
          }

          this._syncPhotoSwipeImageFocusability();
          this._updatePhotoSwipeZoomButtonStates();
          this._ensurePhotoSwipeDialogName();
          this._restorePhotoSwipeFocus();
          // Announce after focus settles so status is heard while user stays on Next/Previous
          this._announcePhotoSwipeSlideChange();
        }
      }, {
        key: "_buildPhotoSwipeSlideStatusMessage",
        value: function _buildPhotoSwipeSlideStatusMessage() {
          if (!this.photoSwipeInstance) {
            return '';
          }

          var index = this.photoSwipeInstance.getCurrentIndex() + 1;
          var count = this.photoSwipeInstance.options.getNumItemsFn();
          var title = this.photoSwipeInstance.currItem && this.photoSwipeInstance.currItem.alt
            ? this.photoSwipeInstance.currItem.alt.trim()
            : '';

          if (title) {
            return (window.languages.productImageStatus || 'Image INDEX of COUNT: TITLE')
              .replace('INDEX', String(index))
              .replace('COUNT', String(count))
              .replace('TITLE', title);
          }

          return (window.languages.productImageStatusUntitled || 'Image INDEX of COUNT')
            .replace('INDEX', String(index))
            .replace('COUNT', String(count));
        }
      }, {
        key: "_announcePhotoSwipeSlideChange",
        value: function _announcePhotoSwipeSlideChange() {
          var liveRegion = document.getElementById('pswp-status');

          if (!liveRegion || !this.photoSwipeInstance) {
            return;
          }

          var message = this._buildPhotoSwipeSlideStatusMessage();

          if (!message) {
            return;
          }

          // Skip duplicate announcement of the same slide
          if (this._photoSwipeLastAnnouncedStatus === message) {
            return;
          }

          this._photoSwipeLastAnnouncedStatus = message;

          liveRegion.setAttribute('aria-live', 'polite');
          liveRegion.setAttribute('aria-atomic', 'true');
          liveRegion.textContent = '';

          window.setTimeout(function () {
            liveRegion.textContent = message;
          }, 50);
        }
      }, {
        key: "_getCurrentPhotoSwipeImage",
        value: function _getCurrentPhotoSwipeImage() {
          if (!this.photoSwipeInstance || !this.photoSwipeInstance.currItem) {
            return null;
          }

          var container = this.photoSwipeInstance.currItem.container;

          if (!container) {
            return document.querySelector('.pswp .pswp__img:not(.pswp__img--placeholder)');
          }

          return container.querySelector('.pswp__img:not(.pswp__img--placeholder)') || container.querySelector('.pswp__img');
        }
      }, {
        key: "_syncPhotoSwipeImageFocusability",
        value: function _syncPhotoSwipeImageFocusability() {
          var pswpElement = document.querySelector('.pswp');

          if (!pswpElement || !this.photoSwipeInstance) {
            return;
          }

          var currentImage = this._getCurrentPhotoSwipeImage();
          var imageLabel = this._buildPhotoSwipeSlideStatusMessage();

          Dom.nodeListToArray(pswpElement.querySelectorAll('.pswp__img')).forEach(function (img) {
            img.setAttribute('tabindex', '-1');

            if (img === currentImage) {
              img.setAttribute('role', 'img');
              if (imageLabel) {
                img.setAttribute('aria-label', imageLabel);
              }
              img.removeAttribute('aria-hidden');
            } else {
              img.setAttribute('aria-hidden', 'true');
              img.removeAttribute('aria-label');
            }
          });
        }
      }, {
        key: "_focusElementSafely",
        value: function _focusElementSafely(element) {
          if (!element || typeof element.focus !== 'function') {
            return;
          }

          try {
            element.focus({
              preventScroll: true
            });
          } catch (error) {
            element.focus();
          }
        }
      }, {
        key: "_restorePhotoSwipeFocus",
        value: function _restorePhotoSwipeFocus() {
          var _this2 = this;

          if (!this.photoSwipeInstance) {
            return;
          }

          var focusTarget = this._photoSwipeFocusTarget || 'close';
          var root = document.querySelector('.pswp');

          window.requestAnimationFrame(function () {
            if (!_this2.photoSwipeInstance || !root) {
              return;
            }

            if (focusTarget === 'next') {
              var nextButton = root.querySelector('.pswp__button--next');

              if (nextButton && !nextButton.hasAttribute('disabled')) {
                _this2._focusElementSafely(nextButton);
                return;
              }
            }

            if (focusTarget === 'prev') {
              var prevButton = root.querySelector('.pswp__button--prev');

              if (prevButton && !prevButton.hasAttribute('disabled')) {
                _this2._focusElementSafely(prevButton);
                return;
              }
            }

            if (focusTarget === 'zoom-in') {
              var zoomInButton = root.querySelector('.pswp__button--zoom-in');

              if (zoomInButton && !zoomInButton.hasAttribute('disabled')) {
                _this2._focusElementSafely(zoomInButton);
                return;
              }

              var zoomOutFallback = root.querySelector('.pswp__button--zoom-out');

              if (zoomOutFallback && !zoomOutFallback.hasAttribute('disabled')) {
                _this2._focusElementSafely(zoomOutFallback);
                return;
              }
            }

            if (focusTarget === 'zoom-out') {
              var zoomOutButton = root.querySelector('.pswp__button--zoom-out');

              if (zoomOutButton && !zoomOutButton.hasAttribute('disabled')) {
                _this2._focusElementSafely(zoomOutButton);
                return;
              }

              var zoomInFallback = root.querySelector('.pswp__button--zoom-in');

              if (zoomInFallback && !zoomInFallback.hasAttribute('disabled')) {
                _this2._focusElementSafely(zoomInFallback);
                return;
              }
            }

            var closeButton = root.querySelector('.pswp__button--close');

            if (closeButton) {
              _this2._focusElementSafely(closeButton);
            }
          });
        }
      }, {
        key: "_onSingleTap",
        value: function _onSingleTap(event) {
          if (event.target.closest && event.target.closest('.pswp__button')) {
            return;
          }

          if (!event.detail || event.detail.pointerType === 'mouse') {
            if (event.target.classList.contains('pswp__img')) {
              var _thisTap = this;
              this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
              window.setTimeout(function () {
                _thisTap._updatePhotoSwipeZoomButtonStates();
              }, 350);
            }
          } else {
            if (event.target.classList.contains('pswp__button')) {
              return;
            }

            event.target.closest('.pswp').querySelector('.pswp__ui').classList.toggle('pswp__ui--hidden');
          }
        }
      }, {
        key: "_onDoubleTap",
        value: function _onDoubleTap(point) {
          var _thisDoubleTap = this;
          var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

          if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
            this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
          } else {
            this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
          }

          window.setTimeout(function () {
            _thisDoubleTap._updatePhotoSwipeZoomButtonStates();
          }, 350);
        }
      }, {
        key: "_onInitialZoomIn",
        value: function _onInitialZoomIn() {
          var _this3 = this;
          var root = document.querySelector('.pswp');
          var ui = document.querySelector('.pswp__ui');

          if (ui) {
            ui.classList.remove('pswp__ui--hidden');
          }

          this._ensurePhotoSwipeDialogName(root);
          this._photoSwipeIsReady = true;
          this._photoSwipeFocusTarget = 'close';
          this._syncPhotoSwipeImageFocusability();
          this._updatePhotoSwipeZoomButtonStates();
          this._setPhotoSwipeBackgroundInert(true);
          this._enablePhotoSwipeFocusTrap();

          // After open animation: announce dialog name, then move focus inside
          window.setTimeout(function () {
            if (!_this3.photoSwipeInstance) {
              return;
            }

            _this3._ensurePhotoSwipeDialogName(root);
            _this3._announcePhotoSwipeOpen();

            // Focus the dialog first so SRs announce its accessible name
            if (root) {
              _this3._focusElementSafely(root);
            }

            window.setTimeout(function () {
              if (!_this3.photoSwipeInstance) {
                return;
              }

              _this3._restorePhotoSwipeFocus();
            }, 250);
          }, 150);
        }
      }, {
        key: "_isPhotoSwipeControlVisible",
        value: function _isPhotoSwipeControlVisible(element) {
          if (!element || element.hasAttribute('disabled') || element.getAttribute('aria-hidden') === 'true') {
            return false;
          }

          // Prefer layout checks over opacity: PhotoSwipe UI animates opacity and
          // disabled zoom controls use opacity, which falsely excluded them before.
          if (element.offsetParent === null && element !== document.body) {
            var style = window.getComputedStyle(element);

            if (style.position !== 'fixed' && style.position !== 'sticky') {
              return false;
            }
          }

          var rect = element.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0;
        }
      }, {
        key: "_getPhotoSwipeFocusableElements",
        value: function _getPhotoSwipeFocusableElements() {
          var pswpElement = document.querySelector('.pswp');

          if (!pswpElement) {
            return [];
          }

          var preferredOrder = ['.pswp__button--close', '.pswp__button--zoom-in', '.pswp__button--zoom-out', '.pswp__button--next', '.pswp__button--prev'];
          var focusable = [];
          var _thisFocusable = this;

          preferredOrder.forEach(function (selector) {
            var element = pswpElement.querySelector(selector);

            if (_thisFocusable._isPhotoSwipeControlVisible(element)) {
              focusable.push(element);
            }
          });

          // Fallback: any visible control button inside the dialog
          if (!focusable.length) {
            Dom.nodeListToArray(pswpElement.querySelectorAll('button.pswp__button')).forEach(function (element) {
              if (_thisFocusable._isPhotoSwipeControlVisible(element) && focusable.indexOf(element) === -1) {
                focusable.push(element);
              }
            });
          }

          return focusable;
        }
      }, {
        key: "_setPhotoSwipeBackgroundInert",
        value: function _setPhotoSwipeBackgroundInert(isInert) {
          var pswpElement = document.querySelector('.pswp');

          if (!pswpElement) {
            return;
          }

          var markInert = function markInert(element) {
            if (!element || element === pswpElement || element.contains(pswpElement)) {
              return;
            }

            if (element.matches && element.matches('script, style, link, noscript, template')) {
              return;
            }

            if (isInert) {
              if (!element.hasAttribute('data-pswp-inert')) {
                element.setAttribute('data-pswp-inert', 'true');

                if ('inert' in element) {
                  element.inert = true;
                } else if (!element.hasAttribute('aria-hidden')) {
                  element.setAttribute('aria-hidden', 'true');
                  element.setAttribute('data-pswp-aria-hidden', 'true');
                }
              }
            } else if (element.hasAttribute('data-pswp-inert')) {
              element.removeAttribute('data-pswp-inert');

              if ('inert' in element) {
                element.inert = false;
              }

              if (element.getAttribute('data-pswp-aria-hidden') === 'true') {
                element.removeAttribute('aria-hidden');
                element.removeAttribute('data-pswp-aria-hidden');
              }
            }
          };

          if (!isInert) {
            Dom.nodeListToArray(document.querySelectorAll('[data-pswp-inert]')).forEach(markInert);
            return;
          }

          var node = pswpElement.parentElement;

          while (node && node !== document.documentElement) {
            Dom.nodeListToArray(node.children).forEach(markInert);
            node = node.parentElement;
          }
        }
      }, {
        key: "_enablePhotoSwipeFocusTrap",
        value: function _enablePhotoSwipeFocusTrap() {
          this._disablePhotoSwipeFocusTrap(false);
          this._boundPhotoSwipeKeydown = this._onPhotoSwipeKeydown.bind(this);
          this._boundPhotoSwipeFocusIn = this._onPhotoSwipeFocusIn.bind(this);
          document.addEventListener('keydown', this._boundPhotoSwipeKeydown, true);
          document.addEventListener('focusin', this._boundPhotoSwipeFocusIn, true);
        }
      }, {
        key: "_disablePhotoSwipeFocusTrap",
        value: function _disablePhotoSwipeFocusTrap() {
          var clearInert = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

          if (this._boundPhotoSwipeKeydown) {
            document.removeEventListener('keydown', this._boundPhotoSwipeKeydown, true);
            this._boundPhotoSwipeKeydown = null;
          }

          if (this._boundPhotoSwipeFocusIn) {
            document.removeEventListener('focusin', this._boundPhotoSwipeFocusIn, true);
            this._boundPhotoSwipeFocusIn = null;
          }

          if (clearInert) {
            this._setPhotoSwipeBackgroundInert(false);
          }
        }
      }, {
        key: "_onPhotoSwipeKeydown",
        value: function _onPhotoSwipeKeydown(event) {
          if (!this.photoSwipeInstance || event.key !== 'Tab') {
            return;
          }

          var pswpElement = document.querySelector('.pswp');

          if (!pswpElement || !pswpElement.classList.contains('pswp--open')) {
            return;
          }

          var focusableElements = this._getPhotoSwipeFocusableElements();

          if (!focusableElements.length) {
            event.preventDefault();
            this._focusElementSafely(pswpElement);
            return;
          }

          var currentIndex = focusableElements.indexOf(document.activeElement);
          event.preventDefault();

          if (event.shiftKey) {
            var prevIndex = currentIndex <= 0 ? focusableElements.length - 1 : currentIndex - 1;
            this._focusElementSafely(focusableElements[prevIndex]);
            return;
          }

          var nextIndex = currentIndex === -1 || currentIndex >= focusableElements.length - 1 ? 0 : currentIndex + 1;
          this._focusElementSafely(focusableElements[nextIndex]);
        }
      }, {
        key: "_onPhotoSwipeFocusIn",
        value: function _onPhotoSwipeFocusIn(event) {
          if (!this.photoSwipeInstance) {
            return;
          }

          var pswpElement = document.querySelector('.pswp');

          if (!pswpElement || !pswpElement.classList.contains('pswp--open')) {
            return;
          }

          // Allow any focus inside the dialog (controls, dialog root, status region).
          if (pswpElement.contains(event.target)) {
            return;
          }

          var focusableElements = this._getPhotoSwipeFocusableElements();

          if (focusableElements.length) {
            this._focusElementSafely(focusableElements[0]);
          } else {
            this._focusElementSafely(pswpElement);
          }
        }
      }, {
        key: "_onInitialZoomOut",
        value: function _onInitialZoomOut() {
          var ui = document.querySelector('.pswp__ui');

          if (ui) {
            ui.classList.add('pswp__ui--hidden');
          }
        }
      }, {
        key: "_destroyPhotoSwipe",
        value: function _destroyPhotoSwipe() {
          this._photoSwipeIsReady = false;
          this._teardownPhotoSwipeUi();
          this._setPhotoSwipeBackgroundInert(false);
          this._photoSwipeFocusTarget = null;
          this._photoSwipeLastAnnouncedStatus = '';
          this._photoSwipeIgnoreActivateUntil = 0;
          this.photoSwipeInstance = null;

          var pswpElement = document.querySelector('.pswp');

          if (pswpElement) {
            pswpElement.setAttribute('aria-hidden', 'true');
          }

          var liveRegion = document.getElementById('pswp-status');

          if (liveRegion) {
            liveRegion.textContent = '';
          }

          var previousFocus = this._photoSwipePreviousFocus;
          this._photoSwipePreviousFocus = null;

          if (previousFocus && typeof previousFocus.focus === 'function') {
            window.requestAnimationFrame(function () {
              try {
                previousFocus.focus({
                  preventScroll: true
                });
              } catch (error) {
                previousFocus.focus();
              }
            });
          }
        }
      }]);
  
      return ProductImageZoom;
    }();
  
    var ProductModel = /*#__PURE__*/function () {
      function ProductModel(element, stackProductImages) {
        _classCallCheck(this, ProductModel);
  
        this.element = element;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.delegateRoot = new domDelegate.Delegate(document.documentElement);
        this.stackProductImages = stackProductImages;
  
        this._attachListeners();
  
        var stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
        document.head.appendChild(stylesheet);
        window.Shopify.loadFeatures([{
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this._setupModelViewerUI.bind(this)
        }, {
          name: 'shopify-xr',
          version: '1.0'
        }]);
      }
  
      _createClass(ProductModel, [{
        key: "destroy",
        value: function destroy() {}
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          var _this = this;
  
          this.element.querySelector('model-viewer').addEventListener('shopify_model_viewer_ui_toggle_play', function () {
            _this.element.dispatchEvent(new CustomEvent('model:played', {
              bubbles: true
            }));
          });
          this.element.querySelector('model-viewer').addEventListener('shopify_model_viewer_ui_toggle_pause', function () {
            _this.element.dispatchEvent(new CustomEvent('model:paused', {
              bubbles: true
            }));
          });
        }
      }, {
        key: "hasBeenSelected",
        value: function hasBeenSelected() {
          // As per guidelines, we only need to autoplay when it's not a touch device
          if (Responsive.matchesBreakpoint('supports-hover')) {
            this.modelUi.play();
          }
        }
      }, {
        key: "hasBeenDeselected",
        value: function hasBeenDeselected() {
          // In all cases, we just turn it off
          this.modelUi.pause();
        }
      }, {
        key: "_setupModelViewerUI",
        value: function _setupModelViewerUI() {
          this.modelElement = this.element.querySelector('model-viewer');
          this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement);
        }
      }]);
  
      return ProductModel;
    }();
  
    var ProductReviews = /*#__PURE__*/function () {
      function ProductReviews(container) {
        _classCallCheck(this, ProductReviews);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.delegateElement.on('click', '.spr-summary-actions-newreview', this._onNewReviewClicked.bind(this)); // Extending Shopify Reviews is a bit manual, but let's do it!
  
        window.SPRCallbacks = {};
        window.SPRCallbacks.onFormSuccess = this._onFormSuccess.bind(this);
        window.SPRCallbacks.onReviewsLoad = this._onReviewsLoad.bind(this);
      }
  
      _createClass(ProductReviews, [{
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off();
        }
      }, {
        key: "_updatePagination",
        value: function _updatePagination(event, target) {
          // Unfortunately, we have to use this ugly jQuery style stuff
          SPR.$(target).data('page', parseInt(target.getAttribute('data-page')) + 1);
        }
      }, {
        key: "_onFormSuccess",
        value: function _onFormSuccess() {
          var formSuccess = this.element.querySelector('.spr-form-message-success');
          window.scrollTo(0, formSuccess.offsetTop - 45);
        }
      }, {
        key: "_onReviewsLoad",
        value: function _onReviewsLoad() {
          // We want to move "spr-pagination-next" before the "new review" button in the "spr-summary-actions" div
          var sprSummaryActions = this.element.querySelector('.spr-summary-actions'),
              previousSprPaginationNext = sprSummaryActions.querySelector('.spr-pagination-next'),
              sprPaginationNext = this.element.querySelector('.spr-pagination .spr-pagination-next');
  
          if (previousSprPaginationNext) {
            previousSprPaginationNext.remove();
          }
  
          if (sprPaginationNext) {
            sprSummaryActions.insertBefore(sprPaginationNext, sprSummaryActions.firstChild);
          }
        }
      }, {
        key: "_onNewReviewClicked",
        value: function _onNewReviewClicked(event, target) {
          target.style.display = 'none';
  
          if (target.previousElementSibling) {
            target.previousElementSibling.style.display = 'none';
          }
        }
      }]);
  
      return ProductReviews;
    }();
  
    /**
     * This implementation allows to serialize a form
     */
    var Form = /*#__PURE__*/function () {
      function Form() {
        _classCallCheck(this, Form);
      }
  
      _createClass(Form, null, [{
        key: "serialize",
        value: function serialize(form) {
          function stringKey(key, value) {
            var beginBracket = key.lastIndexOf('[');
  
            if (beginBracket === -1) {
              var _hash = {};
              _hash[key] = value;
              return _hash;
            }
  
            var newKey = key.substr(0, beginBracket);
            var newValue = {};
            newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
            return stringKey(newKey, newValue);
          }
  
          var hash = {};
  
          for (var i = 0, len = form.elements.length; i < len; i++) {
            var formElement = form.elements[i];
  
            if (formElement.name === '' || formElement.disabled) {
              continue;
            }
  
            if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
              var stringKeys = stringKey(formElement.name, formElement.value);
              hash = Form.extend(hash, stringKeys);
            }
          }
  
          return hash;
        }
      }, {
        key: "extend",
        value: function extend() {
          var extended = {};
          var i = 0; // Merge the object into the extended object
  
          var merge = function merge(obj) {
            for (var prop in obj) {
              if (obj.hasOwnProperty(prop)) {
                // If property is an object, merge properties
                if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                  extended[prop] = Form.extend(extended[prop], obj[prop]);
                } else {
                  extended[prop] = obj[prop];
                }
              }
            }
          }; // Loop through each object and conduct a merge
  
  
          for (; i < arguments.length; i++) {
            merge(arguments[i]);
          }
  
          return extended;
        }
      }]);
  
      return Form;
    }();
  
    var Currency = /*#__PURE__*/function () {
      function Currency() {
        _classCallCheck(this, Currency);
      }
  
      _createClass(Currency, null, [{
        key: "formatMoney",
        value:
        /**
         * Format money values based on your shop currency settings
         *
         * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
         * @param  {String} format - shop money_format setting
         * @return {String} value - formatted value
         */
        function formatMoney(cents, format) {
          if (typeof cents === 'string') {
            cents = cents.replace('.', '');
          }
  
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
              formatString = format || '$';
  
          function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
          }
  
          function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ',');
            decimal = defaultTo(decimal, '.');
  
            if (isNaN(number) || number == null) {
              return 0;
            }
  
            number = (number / 100.0).toFixed(precision);
            var parts = number.split('.'),
                dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                centsAmount = parts[1] ? decimal + parts[1] : '';
            return dollarsAmount + centsAmount;
          }
  
          var value = '';
  
          switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
              value = formatWithDelimiters(cents, 2);
              break;
  
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
  
            case 'amount_with_space_separator':
              value = formatWithDelimiters(cents, 2, ' ', '.');
              break;
  
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
  
            case 'amount_no_decimals_with_space_separator':
              value = formatWithDelimiters(cents, 0, ' ');
              break;
  
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');
              break;
          }
  
          if (formatString.indexOf('with_comma_separator') !== -1) {
            return formatString.replace(placeholderRegex, value).replace(',00', '');
          } else {
            return formatString.replace(placeholderRegex, value).replace('.00', '');
          }
        }
      }]);
  
      return Currency;
    }();
  
    var VariantSelector = /*#__PURE__*/function () {
      function VariantSelector(element, parentProductVariants) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  
        _classCallCheck(this, VariantSelector);
  
        this.element = element;
        this.parentProductVariants = parentProductVariants;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.activator = options['activator'] || document.querySelector("[aria-controls=\"".concat(element.getAttribute('id'), "\"]"));
  
        this.onValueChangedCallback = options['onValueChanged'] || function () {};
  
        this.isOpen = false;
        this.pageOverlayElement = document.querySelector('.PageOverlay');
        this.variantChoiceList = Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector__Choice'));
        this.variantCarousel = new Carousel(this.element.querySelector('.VariantSelector__Carousel'), {
          onSelect: this._variantChanged.bind(this),
          onClick: this._variantSelected.bind(this)
        });
  
        this._attachListeners();
      }
  
      _createClass(VariantSelector, [{
        key: "destroy",
        value: function destroy() {
          this.element.removeEventListener('keyup', this._handleKeyboardListener);
          this.delegateElement.off('click');
          this.activator.removeEventListener('click', this._toggleListener);
          this.variantCarousel.destroy();
        }
      }, {
        key: "toggle",
        value: function toggle() {
          this.isOpen ? this.close() : this.open();
        }
      }, {
        key: "open",
        value: function open() {
          if (this.isOpen) {
            return;
          }
  
          this.element.setAttribute('aria-hidden', 'false');
          this.activator.setAttribute('aria-expanded', 'true');
          Accessibility.trapFocus(this.element, 'variant-selector');
          document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open
  
          this.element.setAttribute('style', '');
          this.pageOverlayElement.classList.add('is-visible');
          this.pageOverlayElement.addEventListener('click', this._closeListener);
          this.isOpen = true;
        }
      }, {
        key: "close",
        value: function close() {
          if (!this.isOpen) {
            return;
          }
  
          this.element.setAttribute('aria-hidden', 'true');
          this.activator.setAttribute('aria-expanded', 'false');
          Accessibility.removeTrapFocus(this.element, 'variant-selector');
          document.documentElement.classList.remove('no-scroll');
          this.pageOverlayElement.classList.remove('is-visible');
          this.pageOverlayElement.removeEventListener('click', this._closeListener);
          this.isOpen = false;
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._handleKeyboardListener = this._handleKeyboard.bind(this);
          this._closeListener = this.close.bind(this);
          this._toggleListener = this.toggle.bind(this);
          this.element.addEventListener('keyup', this._handleKeyboardListener);
          this.activator.addEventListener('click', this._toggleListener);
          this.delegateElement.on('click', '[data-action="select-variant"]', this._onVariantSelect.bind(this));
          this.parentProductVariants.delegateElement.on('variant:changed', this._onVariantChanged.bind(this));
        }
        /**
         * Called when the variant is changed (but not yet selected)
         */
  
      }, {
        key: "_variantChanged",
        value: function _variantChanged(selectedIndex) {
          var activeChoice = this.variantChoiceList[selectedIndex];
          activeChoice.classList.add('is-selected');
          Dom.getSiblings(activeChoice, '.is-selected').forEach(function (item) {
            return item.classList.remove('is-selected');
          });
        }
        /**
         * Called when a variant is clicked or selected
         */
  
      }, {
        key: "_variantSelected",
        value: function _variantSelected(cellElement, cellIndex) {
          if (this.variantCarousel.getSelectedIndex() === cellIndex) {
            this.onValueChangedCallback(cellElement.getAttribute('data-option-value'), cellElement, this.activator);
            this.close();
          } else {
            this.variantCarousel.selectCell(cellIndex);
          }
        }
      }, {
        key: "_onVariantChanged",
        value: function _onVariantChanged(event) {
          var _this = this;
  
          var selectedVariant = event.detail.variant,
              imageWrapperElements = this.element.querySelectorAll('.VariantSelector__ImageWrapper'),
              found = false;
          Dom.nodeListToArray(imageWrapperElements).forEach(function (image) {
            var colorPosition = parseInt(image.parentElement.getAttribute('data-option-position')) - 1,
                combinationExcludedColor = '';
            selectedVariant.options.forEach(function (optionValue, index) {
              if (index !== colorPosition) {
                combinationExcludedColor += optionValue;
              }
            });
  
            if (image.getAttribute('data-variant-title') === combinationExcludedColor) {
              image.setAttribute('aria-hidden', 'false');
              found = true;
            } else {
              image.setAttribute('aria-hidden', 'true');
            }
          });
  
          if (!found) {
            imageWrapperElements.children[0].setAttribute('aria-hidden', 'false');
          }
  
          var foundColorIndex = 0;
          Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector__ChoicePrice')).forEach(function (priceElement, index) {
            var colorPosition = parseInt(priceElement.getAttribute('data-color-position')) - 1;
  
            _this.parentProductVariants.productData['variants'].forEach(function (variant) {
              var matchOptionsExcludedColor = true;
              variant['options'].forEach(function (option, index) {
                if (index !== colorPosition) {
                  if (variant['options'][index] !== selectedVariant['options'][index]) {
                    matchOptionsExcludedColor = false;
                  }
                }
              });
  
              if (matchOptionsExcludedColor && variant['options'][colorPosition] === selectedVariant['options'][colorPosition]) {
                if (foundColorIndex++ === index) {
                  priceElement.innerHTML = "<span class=\"Heading Text--subdued\">".concat(Currency.formatMoney(variant['price'], window.theme.moneyFormat), "</span>");
                }
              }
            });
          });
        }
        /**
         * Called when the button "choose this variant" is explicitly clicked
         */
  
      }, {
        key: "_onVariantSelect",
        value: function _onVariantSelect() {
          var selectedCell = this.variantCarousel.flickityInstance.selectedCell.element;
          this.onValueChangedCallback(selectedCell.getAttribute('data-option-value'), selectedCell, this.activator);
          this.close();
        }
        /**
         * Handle a11y events
         */
  
      }, {
        key: "_handleKeyboard",
        value: function _handleKeyboard(event) {
          if (this.isOpen && event.keyCode === 27) {
            this.close();
          }
        }
      }]);
  
      return VariantSelector;
    }();
  
    /**
     * Handle the store availability management. The parameter is the div that will hold the content. The function
     * "updateWithVariant" must be called whenever the variant is changed.
     */
  
    var StoreAvailability = /*#__PURE__*/function () {
      function StoreAvailability(element, productTitle) {
        _classCallCheck(this, StoreAvailability);
  
        this.element = element;
        this.productTitle = productTitle;
        this.existingDrawers = {};
      }
  
      _createClass(StoreAvailability, [{
        key: "updateWithVariant",
        value: function updateWithVariant(variant) {
          if (!this.element) {
            return; // If the element to inject the store availability does not exist, we return immediately
          } // If the variant is null (for instance unavailable variant), we clear the container
  
  
          if (!variant) {
            this.element.textContent = '';
            return;
          } // If we have a new variant we render the section
  
  
          this._renderAvailabilitySection(variant['id']);
        }
      }, {
        key: "_renderAvailabilitySection",
        value: function _renderAvailabilitySection(id) {
          var _this = this;
  
          // First we clear the previous content
          this.element.innerHTML = ''; // If there is already an element with the given modal we remove it first
  
          var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));
  
          if (availabilityModal) {
            availabilityModal.remove();
          }
  
          if (this.existingDrawers["StoreAvailabilityModal-".concat(id)]) {
            this.existingDrawers["StoreAvailabilityModal-".concat(id)].destroy();
            delete this.existingDrawers["StoreAvailabilityModal-".concat(id)];
          }
  
          return fetch("".concat(window.routes.rootUrlWithoutSlash, "/variants/").concat(id, "?section_id=store-availability")).then(function (response) {
            return response.text().then(function (content) {
              _this.element.innerHTML = content;
              _this.element.innerHTML = _this.element.firstElementChild.innerHTML; // The product title is not rendered so we have to render it manually
  
              var productTitle = _this.element.querySelector('.store-availabilities-modal__product-title');
  
              if (productTitle) {
                productTitle.textContent = _this.productTitle;
              } // In order for our modal system to work we have to append the modal to the body instead
  
  
              var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(id));
              document.body.appendChild(availabilityModal); // Create the drawer
  
              _this.existingDrawers["StoreAvailabilityModal-".concat(id)] = new Drawer(availabilityModal);
            });
          });
        }
      }]);
  
      return StoreAvailability;
    }();

    function toggleBackInStock(show) {
      var backInStock = document.getElementById('backInStock');
      var addToCartButton = document.getElementById('product-add-to-cart');

      if (!backInStock) {
        return;
      }

      if (show) {
        backInStock.style.display = 'block';
        backInStock.classList.add('is-visible');
        document.body.classList.add('product-back-in-stock-active');

        if (addToCartButton) {
          addToCartButton.style.display = 'none';
        }
      } else {
        backInStock.style.display = 'none';
        backInStock.classList.remove('is-visible');
        document.body.classList.remove('product-back-in-stock-active');

        if (addToCartButton) {
          addToCartButton.style.display = '';
        }
      }
    }

    window.applyGlobalePidProperties = function (variantId) {
      if (!variantId) {
        return;
      }

      var data = (window.globalePidMap && (window.globalePidMap[variantId] || window.globalePidMap[String(variantId)])) || {};
      var mid = data.mididentifier || '';
      var std = data.standardcode || '';

      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        var midInput = form.querySelector('[name="properties[_globale.mididentifier]"]');
        var stdInput = form.querySelector('[name="properties[_globale.standardcode]"]');

        if (!midInput) {
          midInput = document.createElement('input');
          midInput.type = 'hidden';
          midInput.name = 'properties[_globale.mididentifier]';
          form.appendChild(midInput);
        }

        if (!stdInput) {
          stdInput = document.createElement('input');
          stdInput.type = 'hidden';
          stdInput.name = 'properties[_globale.standardcode]';
          form.appendChild(stdInput);
        }

        // Keep existing values if map entry is missing (e.g. sticky form before map loads)
        if (data.mididentifier !== undefined || data.standardcode !== undefined) {
          midInput.value = mid;
          stdInput.value = std;
        }
      });
    };

    var ProductVariants = /*#__PURE__*/function () {
      function ProductVariants(container, options) {
        var _this = this;
  
        _classCallCheck(this, ProductVariants);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.options = options;
        var jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML);
        this.productData = jsonData['product'];
        this.variantsInventories = jsonData['inventories'] || {};
        // this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData['id'])); // We init value with the first selected variant
        this.masterSelector = this.element.querySelector("#product-select"); // We init value with the first selected variant
  
        this.productData['variants'].forEach(function (variant) {
          if (variant['id'] === jsonData['selected_variant_id']) {
            _this.currentVariant = variant;
            _this.option1 = variant['option1'];
            _this.option2 = variant['option2'];
            _this.option3 = variant['option3'];
          }
          
        });
        this.storeAvailability = new StoreAvailability(this.element.querySelector('.ProductMeta__StoreAvailabilityContainer'), this.productData['title']);
        this.storeAvailability.updateWithVariant(this.currentVariant);
  
        this._attachListeners();
  
        this._createSelectors();

        this._updateAddToCartButton(this.currentVariant);
        this._updateGlobalePidProperties(this.currentVariant);
        this._onProtectedActionClickBound = this._onProtectedActionClick.bind(this);
        this.element.addEventListener('click', this._onProtectedActionClickBound, true);
        this._onFormSubmitBound = this._onFormSubmit.bind(this);
        var productFormElement = this.element.querySelector('form[action*="/cart/add"]');

        if (productFormElement) {
          productFormElement.addEventListener('submit', this._onFormSubmitBound);
        }
      }
  
      _createClass(ProductVariants, [{
        key: "destroy",
        value: function destroy() {
          this.delegateElement.off('click');
          this.element.removeEventListener('click', this._onProtectedActionClickBound, true);
          var productFormElement = this.element.querySelector('form[action*="/cart/add"]');

          if (productFormElement && this._onFormSubmitBound) {
            productFormElement.removeEventListener('submit', this._onFormSubmitBound);
          }
          this.formPopovers.forEach(function (popover) {
            return popover.destroy();
          });
          this.formVariantSelectors.forEach(function (selector) {
            return selector.destroy();
          });
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on('click', '[data-action="add-to-cart"]', this._addToCart.bind(this));
          this.delegateElement.on('click', '[data-action="decrease-quantity"]', this._decreaseQuantity.bind(this));
          this.delegateElement.on('click', '[data-action="increase-quantity"]', this._increaseQuantity.bind(this));
          this.delegateElement.on('change', '[name="quantity"]', this._validateQuantity.bind(this)); // Hook when a radio button change
  
          this.delegateElement.on('change', '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this));
        }
        /**
         * Selectors can either be popovers or dedicated variant selectors. We therefore pre-create them all here
         */
  
      }, {
        key: "_createSelectors",
        value: function _createSelectors() {
          var _this2 = this;
  
          // Create the instances for each selector
          this.formPopovers = [];
          this.formVariantSelectors = [];
          Dom.nodeListToArray(this.element.querySelectorAll('.OptionSelector')).forEach(function (item) {
            var popover = new Popover(item, {
              preferredPosition: 'left',
              onValueChanged: _this2._onOptionChanged.bind(_this2)
            });
  
            _this2.formPopovers.push(popover);
          });
          Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector')).forEach(function (item) {
            var variantSelector = new VariantSelector(item, _this2, {
              onValueChanged: _this2._onOptionChanged.bind(_this2)
            });
  
            _this2.formVariantSelectors.push(variantSelector);
          });
        }
        /**
         * ---------------------------------------------------------------------------------------------------
         * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
         *
         * Please note that this code is highly dependant on the markup and classes, so make sure to NOT
         * edit this code
         * ---------------------------------------------------------------------------------------------------
         */
  
        /**
         * This callback is called whenever the variant changes and allows to update data about the active variant
         */
  
      }, {
        key: "_onVariantChanged",
        value: function _onVariantChanged(previousVariant, newVariant) {
          // 1st: the prices
          this._updateProductPrices(newVariant, previousVariant); // 2nd: update inventory
  
  
          this._updateInventory(newVariant, previousVariant); // 3rd: update SKU
  
          this._updateproductDetails(newVariant, previousVariant);

          this._updateSku(newVariant, previousVariant); // 4th: update the price measurement
  
  
          this._updateUnitPrice(newVariant, previousVariant); // 5th: the add to cart button
  
  
          this._updateAddToCartButton(newVariant, previousVariant); // 6th: store availability
  
  
          this.storeAvailability.updateWithVariant(newVariant); // Finally, we send an event so that other system could hook and do their own logic

          this._updateLensId(newVariant, previousVariant);

          this._updateGlobalePidProperties(newVariant);
            
         // stickycart data update
          // console.log(newVariant);
             if(typeof newVariant === 'undefined' || newVariant == null){
              
          }else{
               
          var activeVal = newVariant.id;
          var activeName = newVariant.title;
          var activePrice = '$'+(Math.round(newVariant.price) / 100).toFixed(2);
          document.querySelectorAll('.pr-active').forEach(function (el) {
            el.setAttribute('data-value', activeVal);
            el.textContent = activeName + ' - ' + activePrice;
          });
          document.querySelectorAll('.selectedvar').forEach(function (el) {
            el.value = activeVal;
          });
         // console.log(newVariant);
          if(newVariant.available == true){

            document.querySelectorAll('.selectedvar').forEach(function (el) {
              el.value = activeVal;
            });
            document.querySelectorAll('.pr-active').forEach(function (el) {
              el.setAttribute('data-value', activeVal);
              el.textContent = activeName + ' - ' + activePrice;
            });
            document.querySelectorAll('.col-actions button').forEach(function (btn) {
              btn.disabled = false;
            });
            // $('body').find('.col-actions button').html('ADD TO CART');
          }else{
            
            document.querySelectorAll('.col-actions button').forEach(function (btn) {
              btn.disabled = true;
            });
            // $('body').find('.col-actions button').html('OUT OF STOCK');
          }
             }
          
          this.element.dispatchEvent(new CustomEvent('variant:changed', {
            bubbles: true,
            detail: {
              variant: newVariant,
              previousVariant: previousVariant
              
            }
          }));
        }
        /**
         * Sync Global-e EU PID hidden line-item properties for the active variant
         */
  
      }, {
        key: "_updateGlobalePidProperties",
        value: function _updateGlobalePidProperties(newVariant) {
          var variantId = typeof newVariant === 'object' && newVariant ? newVariant.id : newVariant;
          window.applyGlobalePidProperties(variantId);
        }
        /**
         * Update the prices (optionally showing compare at price)
         */
  
      }, {
        key: "_updateProductPrices",
        value: function _updateProductPrices(newVariant, previousVariant) {
          var productMetaPrices = this.element.querySelector('.ProductMeta__PriceList'),
              currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
  
          if (!productMetaPrices) {
            return;
          }
  
          if (!newVariant) {
            productMetaPrices.style.display = 'none';
          } else {
            if (previousVariant && previousVariant['price'] === newVariant['price'] && previousVariant['compare_at_price'] === newVariant['compare_at_price']) {
              return; // The price do not have changed so let's return to avoid changing the DOM for nothing
            }
  
            productMetaPrices.innerHTML = '';
  
            if (newVariant['compare_at_price'] > newVariant['price']) {
              var saleLabel = window.languages && window.languages.productSalePrice ? window.languages.productSalePrice : 'Sale price:';
              var originalLabel = window.languages && window.languages.productOriginalPrice ? window.languages.productOriginalPrice : 'Original price:';
              var saleMoney = Currency.formatMoney(newVariant['price'], currencyFormat);
              var originalMoney = Currency.formatMoney(newVariant['compare_at_price'], currencyFormat);
              productMetaPrices.innerHTML += "<span class=\"u-visually-hidden\">".concat(saleLabel, " ").concat(saleMoney, ". ").concat(originalLabel, " ").concat(originalMoney, ".</span>");
              productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price Price--highlight Text--subdued u-h4\" data-money-convertible aria-hidden=\"true\">".concat(saleMoney, "</span>");
              productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price Price--compareAt Text--subdued u-h4\" data-money-convertible aria-hidden=\"true\">".concat(originalMoney, "</span>");
            } else {
              productMetaPrices.innerHTML += "<span class=\"ProductMeta__Price Price Text--subdued u-h4\" data-money-convertible>".concat(Currency.formatMoney(newVariant['price'], currencyFormat), "</span>");
            }
  
            productMetaPrices.style.display = '';
          }
        }
        /**
         * Update the inventory (if needed)
         */
  
      }, {
        key: "_updateInventory",
        value: function _updateInventory(newVariant) {
          if (!this.options['showInventoryQuantity']) {
            return;
          }
  
          var productFormInventory = this.element.querySelector('.ProductForm__Inventory'),
              variantInventory = newVariant ? this.variantsInventories[newVariant['id']] : null;
  
          if (!newVariant || null === variantInventory['inventory_management'] || variantInventory['inventory_quantity'] <= 0 || this.options['inventoryQuantityThreshold'] > 0 && variantInventory['inventory_quantity'] > this.options['inventoryQuantityThreshold']) {
            productFormInventory.style.display = 'none';
          } else {
            productFormInventory.innerHTML = variantInventory['inventory_message'];
            productFormInventory.style.display = '';
          }
        }
        /**
         * Update the SKU
         */
  
      }, {
        key: "_updateSku",
        value: function _updateSku(newVariant) {
          if (!this.options['showSku'] || !newVariant) {
            return;
          }
  
          var productSkuNumber = this.element.querySelector('.ProductMeta__SkuNumber');
  
          if (productSkuNumber && newVariant['sku']) {
            productSkuNumber.innerText = newVariant['sku'];
          }
        
        }
        /**
         * Update the productdetails
         */
  
      },
      {
        key: "_updateproductDetails",
        value: function _updateproductDetails(newVariant) {
            var variants = window.variants;
        var variantDescription = document.querySelector('.Product__InfoWrapper');
        var descriptionList = "";
        if(typeof newVariant === 'undefined' || newVariant == null || !variantDescription){
          // console.log(newVariant);
        }else{
        var myColorData = variants[newVariant.id].color_data;
         if(variants[newVariant.id].feature1){ 
            descriptionList += "<li><span>" + variants[newVariant.id].feature1 + "</span></li>"
          };
         if(variants[newVariant.id].feature2){ descriptionList += "<li><span>" + variants[newVariant.id].feature2 + "</span></li>"};
         if(variants[newVariant.id].feature3){ descriptionList += "<li><span>" + variants[newVariant.id].feature3 + "</span></li>"};
         if(variants[newVariant.id].feature4){ descriptionList += "<li><span>" + variants[newVariant.id].feature4 + "</span></li>"};
         if(variants[newVariant.id].feature5){ descriptionList += "<li><span>" + variants[newVariant.id].feature5 + "</span></li>"};
         if(variants[newVariant.id].feature6){ descriptionList += "<li><span>" + variants[newVariant.id].feature6 + "</span></li>"};
         if(variants[newVariant.id].feature7){ descriptionList += "<li><span>" + variants[newVariant.id].feature7 + "</span></li>"};
          var variantFeatures = variantDescription.querySelector('.variant-features');
          if (variantFeatures) {
            variantFeatures.innerHTML = "<ul class='variant-details-list circle'>" + descriptionList + "</ul>";
          }
          var selectedValueSplit = variantDescription.querySelector('.ProductForm__SelectedValuesplit');
          if(typeof myColorData !== 'undefined'){
             // console.log(myColorData);
            if (selectedValueSplit) selectedValueSplit.innerHTML = " " +variants[newVariant.id].color_data;
          }else{
          if(variants[newVariant.id].lens && variants[newVariant.id].frame){
           
            if (selectedValueSplit) selectedValueSplit.innerHTML = variants[newVariant.id].lens + " - " + variants[newVariant.id].frame;
          }   
          }

         //lens changes
          if(variants[newVariant.id].lens){
            var lensContent = variantDescription.querySelector('.specificationcontent .lens_content');
            if (lensContent) lensContent.innerHTML = variants[newVariant.id].lens;
          }
          if(variants[newVariant.id].fit_guide){ 
            document.querySelectorAll('.fitguideImage').forEach(function (fitGuideImage) {
              fitGuideImage.setAttribute('src', variants[newVariant.id].fit_guide);
              if (variants[newVariant.id].fit_guide_alt) {
                fitGuideImage.setAttribute('alt', variants[newVariant.id].fit_guide_alt);
              } else if (!fitGuideImage.getAttribute('alt')) {
                fitGuideImage.setAttribute('alt', 'Fit guide diagram showing Eye Size options, a bridge width, and a temple length on the frame.');
              }
            });
          }
  
          //frame changes
          if(variants[newVariant.id].frame){
            var frameContent = variantDescription.querySelector('.specificationcontent .frame_content');
            if (frameContent) frameContent.innerHTML = variants[newVariant.id].frame;
          }

          //size changes
          if(variants[newVariant.id].size){
            var sizeContent = variantDescription.querySelector('.specificationcontent .size_content');
            if (sizeContent) sizeContent.innerHTML = variants[newVariant.id].size;
          }
//temple changes
if(variants[newVariant.id].temple){
  var templeContent = variantDescription.querySelector('.specificationcontent .temple_content');
  if (templeContent) templeContent.innerHTML = variants[newVariant.id].temple;
}
          //sku change
          var currentVariantSku = variantDescription.querySelector('.specificationcontent .current_variant');
          if (currentVariantSku) currentVariantSku.innerHTML = newVariant.sku;
        }
        }
      }, 
      
      /**
      * Update the unit price
      */
     {
        key: "_updateLensId",
        value: function _updateLensId(newVariant) {
          var lensAdvizorBtn = document.querySelector('.la-select-lenses-btn');
          if(lensAdvizorBtn){

            var productTempVariant = this.currentVariant.title;
            var cleanProductVar = productTempVariant.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-').replace('--', '-').replace('---', '-').toLowerCase();
            
            var lensadvizorProductVariant = document.querySelectorAll('#lensadOptions option');
            var matched = false;
            lensadvizorProductVariant.forEach(function(option){
              if (matched) return;
              var selectPrTitle = option.getAttribute('data-title');
              var selectPrvalue = option.value;
              if(selectPrTitle && cleanProductVar.indexOf(selectPrTitle) != -1){
                document.querySelectorAll('.ProductForm__BuyButtons').forEach(function (el) {
                  el.classList.add('lensActive');
                });
                lensAdvizorBtn.setAttribute('style','display:block !important');
                lensAdvizorBtn.setAttribute('data-la-variant-id',selectPrvalue);
                matched = true;
              } else {
                document.querySelectorAll('.ProductForm__BuyButtons').forEach(function (el) {
                  el.classList.remove('lensActive');
                });
                lensAdvizorBtn.setAttribute('style','display:none !important');
              }
            });
            
          }

        }
        /**
         * Update the lens id
         */
  
      }, 
      
      {
        key: "_updateUnitPrice",
        value: function _updateUnitPrice(newVariant) {
          if (!newVariant) {
            return;
          }
  
          var unitPriceMeasurement = this.element.querySelector('.ProductMeta__UnitPriceMeasurement');
  
          if (!unitPriceMeasurement) {
            return;
          }
  
          if (!newVariant.hasOwnProperty('unit_price')) {
            unitPriceMeasurement.style.display = 'none';
            return;
          }
  
          unitPriceMeasurement.style.display = 'block';
          unitPriceMeasurement.querySelector('.UnitPriceMeasurement__Price').innerHTML = Currency.formatMoney(newVariant['unit_price'], window.theme.moneyFormat);
          unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceUnit').textContent = newVariant['unit_price_measurement']['reference_unit'];
          var unitPriceReferenceValue = unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceValue');
          unitPriceReferenceValue.textContent = newVariant['unit_price_measurement']['reference_value'];
          unitPriceReferenceValue.style.display = newVariant['unit_price_measurement']['reference_value'] === 1 ? 'none' : 'inline';
        }
        /**
         * Update the add to cart
         */
  
      }, {
        key: "_isSizeSelected",
        value: function _isSizeSelected() {
          var requiresSizeSelection = this.element.querySelector('input[selection="selection"]') !== null;
          return !requiresSizeSelection || this.element.querySelector('input[selection="selection"]:checked') !== null;
        }
      }, {
        key: "_getSizeOptionElement",
        value: function _getSizeOptionElement() {
          var sizeInput = this.element.querySelector('input[selection="selection"]');
          return sizeInput ? sizeInput.closest('.ProductForm__Option') : null;
        }
      }, {
        key: "_showSizeError",
        value: function _showSizeError() {
          var sizeError = this.element.querySelector('.ProductForm__SizeError');

          if (!sizeError) {
            return;
          }

          sizeError.style.display = '';
          var sizeOption = this._getSizeOptionElement();

          if (sizeOption) {
            sizeOption.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        }
      }, {
        key: "_hideSizeError",
        value: function _hideSizeError() {
          var sizeError = this.element.querySelector('.ProductForm__SizeError');

          if (sizeError) {
            sizeError.style.display = 'none';
          }
        }
      }, {
        key: "_onProtectedActionClick",
        value: function _onProtectedActionClick(event) {
          var lensAdvizorButton = event.target.closest('lensadvizor-quick-buy');
          var addToCartButton = event.target.closest('.ProductForm__AddToCart');

          if (!lensAdvizorButton && !addToCartButton) {
            return;
          }

          if (!this.element.contains(lensAdvizorButton || addToCartButton)) {
            return;
          }

          if (this._isSizeSelected()) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          this._showSizeError();

          if (lensAdvizorButton) {
            document.dispatchEvent(new CustomEvent('LensAdvizor:selectLensModal:close'));
          }
        }
      }, {
        key: "_onFormSubmit",
        value: function _onFormSubmit(event) {
          if (!this._isSizeSelected()) {
            event.preventDefault();
            this._showSizeError();
          }
        }
      }, {
        key: "_updateAddToCartButton",
        value: function _updateAddToCartButton(newVariant) {
          console.log('started here...');
          var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'),
              shopifyPaymentButton = this.element.querySelector('.shopify-payment-button');

          var isSizeSelected = this._isSizeSelected();
          
             if(typeof newVariant === 'undefined' || newVariant == null){
              addToCartButton.setAttribute('disabled', 'disabled');
              addToCartButton.removeAttribute('data-action');
              addToCartButton.classList.add('Button--secondary');
              addToCartButton.innerHTML = window.languages.productFormUnavailable;
               
             } else {
                var checkinventorypolicy = inventory_policy[newVariant.id];
                var checkinventoryButton = inventory_button[newVariant.id];
                var checkinventory_quantity = Number(inventory_quantity[newVariant.id]);
                console.log(checkinventoryButton);
                document.querySelectorAll('.product-tabs-accordion-item.lens_view_tab').forEach(function (el) {
                  el.style.display = 'none';
                });
                document.querySelectorAll('.product-tabs-accordion-item.fit_guide_tab').forEach(function (el) {
                  el.style.display = 'none';
                });
                document.querySelectorAll('.lens_view_tab.variant_'+newVariant.id).forEach(function (el) {
                  el.style.display = '';
                });
                document.querySelectorAll('.fit_guide_tab.variant_'+newVariant.id).forEach(function (el) {
                  el.style.display = '';
                });

                if (addToCartButton) {
                  addToCartButton.classList.remove('Button--secondary');
                  addToCartButton.classList.remove('Button--primary');
                  var backInStock = document.getElementById('backInStock');
        
                if (!newVariant) {
                  addToCartButton.setAttribute('disabled', 'disabled');
                  addToCartButton.removeAttribute('data-action');
                  addToCartButton.classList.add('Button--secondary');
                  addToCartButton.innerHTML = window.languages.productFormUnavailable;
                } else {
                  if (newVariant['available']) {
                    document.querySelectorAll('.col-actions button').forEach(function (btn) {
                      btn.innerHTML = 'ADD TO CART';
                    });
                    addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');

                    if (!isSizeSelected) {
                      addToCartButton.removeAttribute('disabled');
                      addToCartButton.removeAttribute('data-action');
                      document.querySelectorAll('.col-actions button').forEach(function (btn) {
                        btn.disabled = false;
                      });
                    } else {
                      addToCartButton.removeAttribute('disabled');
                      addToCartButton.setAttribute('data-action', 'add-to-cart');
                      document.querySelectorAll('.col-actions button').forEach(function (btn) {
                        btn.disabled = false;
                      });
                    }
  
                if (undefined === this.options['showPriceInButton'] || this.options['showPriceInButton']) {
                  addToCartButton.innerHTML = "\n            <span>".concat(window.languages.productFormAddToCart, "</span>\n            <span class=\"Button__SeparatorDot\"></span>\n            <span data-money-convertible>").concat(Currency.formatMoney(newVariant['price'], window.theme.moneyFormat), "</span>\n          ");
                } else {
                  addToCartButton.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>");
                }
                toggleBackInStock(false);
                document.querySelectorAll('.klaviyotrigger').forEach(function (el) { el.style.display = 'none'; });
                addToCartButton.style.display = 'block';
                document.querySelectorAll('.groups-btn').forEach(function (el) {
                  el.style.display = '';
                });
                if (!this.options['hideShopPayForRx']) {
                  var paymentTerms = document.getElementById('paymentterms');
                  if (paymentTerms) paymentTerms.style.display = '';
                }
            } 
            //     else if(newVariant['available'] && checkinventorypolicy == '' && checkinventory_quantity > 0){
            //     $('body').find('.col-actions button').html('ADD TO CART');
            //     addToCartButton.removeAttribute('disabled');
            //     addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
            //     addToCartButton.setAttribute('data-action', 'add-to-cart');
  
            //     if (undefined === this.options['showPriceInButton'] || this.options['showPriceInButton']) {
            //       addToCartButton.innerHTML = "\n            <span>".concat(window.languages.productFormAddToCart, "</span>\n            <span class=\"Button__SeparatorDot\"></span>\n            <span data-money-convertible>").concat(Currency.formatMoney(newVariant['price'], window.theme.moneyFormat), "</span>\n          ");
            //     } else {
            //       addToCartButton.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>");
            //     }
            //     $('#backInStock').css('display','none');
            //     $('.klaviyotrigger').hide();
            //     addToCartButton.style.display = 'block';
            //     $('.groups-btn').show();
            //     $('#paymentterms').show();
            
            // } 
              else if(checkinventoryButton == true && checkinventory_quantity == 0){
                addToCartButton.setAttribute('disabled', 'disabled');
                addToCartButton.classList.add('Button--secondary');
                addToCartButton.innerHTML = 'OUT OF STOCK';
                document.querySelectorAll('.col-actions button').forEach(function (btn) { btn.textContent = 'OUT OF STOCK'; });
                toggleBackInStock(true);
                document.querySelectorAll('.groups-btn').forEach(function (el) { el.style.display = 'none'; });
                var paymentTermsSold = document.getElementById('paymentterms');
                if (paymentTermsSold) paymentTermsSold.style.display = 'none';
              } else if(checkinventoryButton == false && checkinventory_quantity <= 0){
                addToCartButton.setAttribute('disabled', 'disabled');
                addToCartButton.classList.add('Button--secondary');
                addToCartButton.innerHTML = window.languages.productFormSoldOut;
                document.querySelectorAll('.col-actions button').forEach(function (btn) { btn.textContent = 'SOLD OUT'; });
                toggleBackInStock(false);
                document.querySelectorAll('.groups-btn').forEach(function (el) { el.style.display = 'none'; });
                var paymentTermsOos = document.getElementById('paymentterms');
                if (paymentTermsOos) paymentTermsOos.style.display = 'none';
              } 
              // else if(checkinventoryButton == '' && checkinventory_quantity > 0) {
              //   $('body').find('.col-actions button').html('ADD TO CART');
              //   addToCartButton.removeAttribute('disabled');
              //   addToCartButton.innerHTML = 'ADD TO CART';
              //   addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
              //   addToCartButton.setAttribute('data-action', 'add-to-cart');
              //   $('#backInStock').css('display','none');
              //   $('.klaviyotrigger').hide();
              //   addToCartButton.style.display = 'block';
              //   $('.groups-btn').show();
              //   $('#paymentterms').show();
              // }
              else {
                addToCartButton.setAttribute('disabled', 'disabled');
                addToCartButton.classList.add('Button--secondary');
                addToCartButton.removeAttribute('data-action');
                addToCartButton.innerHTML = 'OUT OF STOCK';
                document.querySelectorAll('.col-actions button').forEach(function (btn) { btn.textContent = 'OUT OF STOCK'; });
                document.querySelectorAll('.klaviyotrigger').forEach(function (el) { el.style.display = 'block'; });
                toggleBackInStock(true);
                document.querySelectorAll('.groups-btn').forEach(function (el) { el.style.display = 'none'; });
                var paymentTermsFinal = document.getElementById('paymentterms');
                if (paymentTermsFinal) paymentTermsFinal.style.display = 'none';
              }
            }
          }
  
          if (this.options['showPaymentButton'] && shopifyPaymentButton && !this.options['hideShopPayForRx']) {
            if (!newVariant || !newVariant['available']) {
              shopifyPaymentButton.style.display = 'none';
            } else {
              shopifyPaymentButton.style.display = 'block';
            }
          } else if (shopifyPaymentButton && this.options['hideShopPayForRx']) {
            shopifyPaymentButton.style.display = 'none';
          }
        }
        }
        /**
         * ---------------------------------------------------------------------------------------------------
         * INTERNAL CODE THAT HANDLE VARIANT CHANGES
         * ---------------------------------------------------------------------------------------------------
         */
  
        /**
         * Whenever an option is changed, this code fetch the corresponding active variant
         */
  
      },{
        key: "_onOptionChanged",
        value: function _onOptionChanged(newValue, target, activator) {
          // We change the value associated with the activator, and check if we have a color swatch
          if (activator) {
            this['option' + target.getAttribute('data-option-position')] = newValue;
            activator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue;
          } else {
            this['option' + target.getAttribute('data-option-position')] = target.value;
            var selectedValue = target.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');
  
            if (selectedValue) {
              selectedValue.innerHTML = target.value;
            }

            if (target.hasAttribute('selection') && target.checked) {
              this._hideSizeError();
            }
          } // Finally, we get the new variant
  
  
          var previousVariant = this.currentVariant;
          this.currentVariant = this._getCurrentVariantFromOptions();
  
          this._onVariantChanged(previousVariant, this.currentVariant);
  
          if (this.currentVariant) {
            if (this.options['enableHistoryState']) {
              this._updateHistoryState(this.currentVariant);
            } // We need to modify the hidden select that contain the id attribute as well
  
  
            this.masterSelector.querySelector('[selected]').removeAttribute('selected');
            this.masterSelector.querySelector("[value=\"".concat(this.currentVariant['id'], "\"]")).setAttribute('selected', 'selected');
            this.masterSelector.dispatchEvent(new Event('change', {
              bubbles: true
            }));
          }
        }
        /**
         * Get the active variant based on the options
         */
  
      }, {
        key: "_getCurrentVariantFromOptions",
        value: function _getCurrentVariantFromOptions() {
          var _this3 = this;
  
          var found = false;
          this.productData['variants'].forEach(function (variant) {
            if (variant['option1'] === _this3.option1 && variant['option2'] === _this3.option2 && variant['option3'] === _this3.option3) {
              found = variant;
            }
          });
          return found || null;
        }
        /**
         * Update the history state for browsers that support it
         */
  
      }, {
        key: "_updateHistoryState",
        value: function _updateHistoryState(variant) {
          if (!history.replaceState) {
            return;
          }
  
          var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(variant.id);
          window.history.replaceState({
            path: newUrl
          }, '', newUrl);
        }
        /**
         * ---------------------------------------------------------------------------------------------------
         * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
         * ---------------------------------------------------------------------------------------------------
         */
  
      }, {
        key: "_addToCart",
        value: function _addToCart(event) {
          var _this4 = this;

          if (!this._isSizeSelected()) {
            event.preventDefault();
            this._showSizeError();
            return;
          }
  
          if (!this.options['useAjaxCart']) {
            return; // When using a cart type of page, we just simply redirect to the cart page
          }

          event.preventDefault(); // Prevent form to be submitted
  
          var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'); // First, we switch the status of the button
  
          addToCartButton.setAttribute('disabled', 'disabled');
          document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
  
          var formElement = this.element.querySelector('form[action*="/cart/add"]');
          fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(Form.serialize(formElement)),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
  
            }
          }).then(function (response) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            var quantityElement = formElement.querySelector('[name="quantity"]');
  
            if (response.ok) {
              addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render
  
              _this4.element.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: _this4.currentVariant,
                  quantity: quantityElement ? parseInt(quantityElement.value) : 1
                }
              }));
            } else {
              response.json().then(function (content) {
                var errorMessageElement = document.createElement('span');
                errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                errorMessageElement.innerHTML = content['description'];
                addToCartButton.removeAttribute('disabled');
                addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                setTimeout(function () {
                  errorMessageElement.remove();
                }, 2500);
              });
            }
          });
          event.preventDefault();
        }
        /**
         * ---------------------------------------------------------------------------------------------------
         * OTHER
         * ---------------------------------------------------------------------------------------------------
         */
  
        /**
         * When using the quantity selector, this can be used to decrease the quantity (be ensuring it won't be lower than 1)
         */
  
      }, {
        key: "_decreaseQuantity",
        value: function _decreaseQuantity(event, target) {
          target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
        }
        /**
         * When using the quantity selector, this can be used to increase the quantity
         */
  
      }, {
        key: "_increaseQuantity",
        value: function _increaseQuantity(event, target) {
          target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
        }
        /**
         * Make sure the quantity does not go below when manually changed
         */
  
      }, {
        key: "_validateQuantity",
        value: function _validateQuantity(event, target) {
          target.value = Math.max(parseInt(target.value) || 1, 1);
        }
      }]);
  
      return ProductVariants;
    }();
  
    var ProductVideo = /*#__PURE__*/function () {
      function ProductVideo(element, stackProductImages, enableVideoLooping) {
        _classCallCheck(this, ProductVideo);
  
        this.element = element;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.stackProductImages = stackProductImages;
        this.enableVideoLooping = enableVideoLooping;
        this.player = null;
  
        switch (this.element.getAttribute('data-media-type')) {
          case 'video':
            var stylesheet = document.createElement('link');
            stylesheet.rel = 'stylesheet';
            stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
            document.head.appendChild(stylesheet);
            window.Shopify.loadFeatures([{
              name: 'video-ui',
              version: '1.0',
              onLoad: this._setupHtml5Video.bind(this)
            }]);
            break;
  
          case 'external_video':
            this._setupExternalVideo();
  
            break;
        }
      }
  
      _createClass(ProductVideo, [{
        key: "destroy",
        value: function destroy() {
          if (this.player) {
            this.player.destroy(); // Both Plyr and YouTube API use the same name
          }
        }
      }, {
        key: "hasBeenSelected",
        value: function hasBeenSelected() {
          // As per guidelines, we only need to autoplay when it's not a touch device
          if (Responsive.matchesBreakpoint('supports-hover')) {
            this.play();
          }
        }
      }, {
        key: "hasBeenDeselected",
        value: function hasBeenDeselected() {
          this.pause();
        }
      }, {
        key: "play",
        value: function play() {
          switch (this.element.getAttribute('data-media-type')) {
            case 'video':
              this.player.play();
              break;
  
            case 'external_video':
              this.player.playVideo();
              break;
          }
        }
      }, {
        key: "pause",
        value: function pause() {
          switch (this.element.getAttribute('data-media-type')) {
            case 'video':
              this.player.pause();
              break;
  
            case 'external_video':
              this.player.pauseVideo();
              break;
          }
        }
      }, {
        key: "_setupHtml5Video",
        value: function _setupHtml5Video() {
          var _this = this;
  
          this.player = new Shopify.Plyr(this.element.querySelector('video'), {
            controls: ['play', 'progress', 'mute', 'volume', 'play-large', 'fullscreen'],
            loop: {
              active: this.enableVideoLooping
            },
            hideControlsOnPause: true,
            clickToPlay: true,
            iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
            tooltips: {
              controls: false,
              seek: true
            }
          });
          this.player.on('play', function () {
            _this.element.dispatchEvent(new CustomEvent('video:played', {
              bubbles: true
            }));
          });
          this.player.on('pause', function () {
            _this.element.dispatchEvent(new CustomEvent('video:paused', {
              bubbles: true
            }));
          });
        }
      }, {
        key: "_setupExternalVideo",
        value: function _setupExternalVideo() {
          if (this.element.getAttribute('data-video-host') === 'youtube') {
            this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this));
          }
        }
      }, {
        key: "_setupYouTubePlayer",
        value: function _setupYouTubePlayer() {
          var _this2 = this;
  
          var playerLoadingInterval = setInterval(function () {
            if (window.YT !== undefined && window.YT.Player !== undefined) {
              _this2.player = new YT.Player(_this2.element.querySelector('iframe'), {
                videoId: _this2.element.getAttribute('data-video-id'),
                events: {
                  onStateChange: function onStateChange(event) {
                    if (event.data === window.YT.PlayerState.PLAYING) {
                      _this2.element.dispatchEvent(new CustomEvent('video:played', {
                        bubbles: true
                      }));
                    } else if (event.data === YT.PlayerState.PAUSED) {
                      _this2.element.dispatchEvent(new CustomEvent('video:paused', {
                        bubbles: true
                      }));
                    }
  
                    if (event.data === window.YT.PlayerState.ENDED && _this2.enableVideoLooping) {
                      event.target.seekTo(0);
                    }
                  }
                }
              });
              clearInterval(playerLoadingInterval);
            }
          }, 50);
        }
      }, {
        key: "_loadYouTubeScript",
        value: function _loadYouTubeScript() {
          return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            document.body.appendChild(script);
            script.onload = resolve;
            script.onerror = reject;
            script.async = true;
            script.src = '//www.youtube.com/iframe_api';
          });
        }
      }]);
  
      return ProductVideo;
    }();
  
    /**
     * This code has been heavily inspired by this: https://kitaitimakoto.gitlab.io/scrollspy-example/index.en.html#whatsthis
     */
    var ScrollSpy = /*#__PURE__*/function () {
      function ScrollSpy(container, elementsToSpy, observerOptions) {
        var _this = this;
  
        _classCallCheck(this, ScrollSpy);
  
        this.container = container;
        this.targets = [];
        this.targetIndices = {};
        this.indicesInViewPort = [];
        this.observer = new IntersectionObserver(this._onIntersectionChange.bind(this), observerOptions);
        elementsToSpy.forEach(function (elementToSpy, index) {
          _this.targets.push(elementToSpy);
  
          _this.targetIndices[elementToSpy.id] = index;
  
          _this.observer.observe(elementToSpy);
        });
      }
  
      _createClass(ScrollSpy, [{
        key: "destroy",
        value: function destroy() {
          this.observer.disconnect();
        }
        /**
         * Called whenever there is a change of visibility
         */
  
      }, {
        key: "_onIntersectionChange",
        value: function _onIntersectionChange(changes) {
          var oldTargetIndex = this.indicesInViewPort[0] || 0;
  
          for (var i = changes.length - 1; i >= 0; i--) {
            this._updateIndicesInViewPort(changes[i], oldTargetIndex);
          } // Firefox generates duplicates so make sure to remove
  
  
          this.indicesInViewPort = this.indicesInViewPort.filter(function (value, index, self) {
            return self.indexOf(value) === index;
          });
  
          if (this.indicesInViewPort.length === 0 || oldTargetIndex === this.indicesInViewPort[0]) {
            return;
          }
  
          var event = new CustomEvent('scrollspy:target:changed', {
            detail: {
              newTarget: this.targets[this.indicesInViewPort[0]],
              oldTarget: this.targets[oldTargetIndex]
            }
          });
          this.container.dispatchEvent(event);
        }
        /**
         * Update indices visible in the view port
         */
  
      }, {
        key: "_updateIndicesInViewPort",
        value: function _updateIndicesInViewPort(change, oldTargetIndex) {
          var index = this.targetIndices[change.target.id];
  
          if (change.intersectionRatio === 0) {
            var indexInViewPort = this.indicesInViewPort.indexOf(index);
  
            if (indexInViewPort !== -1) {
              this.indicesInViewPort.splice(indexInViewPort, 1);
            }
          } else {
            if (index < oldTargetIndex) {
              this.indicesInViewPort.unshift(index);
            } else if (index > this.indicesInViewPort[this.indicesInViewPort.length - 1]) {
              this.indicesInViewPort.push(index);
            } else {
              this.indicesInViewPort.push(index);
              this.indicesInViewPort.sort();
            }
          }
        }
      }]);
  
      return ScrollSpy;
    }();
  
    var SearchBar = /*#__PURE__*/function () {
      function SearchBar() {
        _classCallCheck(this, SearchBar);
  
        this.documentDelegate = new domDelegate.Delegate(document.body);
        this.searchElement = document.getElementById('Search');
        this.searchInputElement = this.searchElement.querySelector('[name="q"]');
        this.searchResultsElement = this.searchElement.querySelector('.Search__Results');
        this.queryMap = {};
        this.isOpen = false;
        this.pageOverlayElement = document.querySelector('.PageOverlay');
  
        this._attachListeners();
      }
  
      _createClass(SearchBar, [{
        key: "destroy",
        value: function destroy() {
          this.searchInputElement.removeEventListener('keydown', this._preventSubmissionListener);
          this.searchInputElement.removeEventListener('input', this._onInputListener);
          document.removeEventListener('keydown', this._onSearchButtonKeydown, true);
          this.documentDelegate.off();
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._preventSubmissionListener = this._preventSubmission.bind(this);
          this._onInputListener = this._debounce(this._onInput.bind(this), 250);
          this._onSearchButtonKeydown = this._onSearchButtonKeydown.bind(this);
          this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener);
          this.searchInputElement.addEventListener('input', this._onInputListener);
          this.documentDelegate.on('click', '[data-action="toggle-search"]', this._toggleSearch.bind(this));
          this.documentDelegate.on('click', '[data-action="open-search"]', this._openSearch.bind(this));
          this.documentDelegate.on('click', '[data-action="close-search"]', this._closeSearch.bind(this));
          this.documentDelegate.on('search:close', this._closeSearch.bind(this)); // Allow for third-party elements to close the bar
          document.addEventListener('keydown', this._onSearchButtonKeydown, true);
        }
      }, {
        key: "_onSearchButtonKeydown",
        value: function _onSearchButtonKeydown(event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          var focused = event.target.closest('[data-action="toggle-search"]');
          if (!focused) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          var icon = focused;
          var buttons = document.querySelectorAll('[data-action="toggle-search"]');
          for (var i = 0; i < buttons.length; i++) {
            if (buttons[i].classList.contains('Header__Icon') && buttons[i].offsetParent !== null) {
              icon = buttons[i];
              break;
            }
          }
          icon.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
            detail: 1,
            button: 0,
            buttons: 1
          }));
        }
        /**
         * Toggle the search
         */
  
      }, {
        key: "_setSearchButtonsExpanded",
        value: function _setSearchButtonsExpanded(expanded) {
          document.querySelectorAll('[data-action="toggle-search"]').forEach(function (button) {
            button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          });
        }
      }, {
        key: "_focusSearchInput",
        value: function _focusSearchInput() {
          var input = this.searchInputElement;
          if (!input) return;
          try {
            input.focus({
              preventScroll: false
            });
          } catch (err) {
            input.focus();
          }
        }
      }, {
        key: "_toggleSearch",
        value: function _toggleSearch(event) {
          if (this.isOpen) {
            this._closeSearch(event);
          } else {
            this._openSearch(event);
          }

          Shopify.analytics.publish('search_click');

          event.preventDefault();
        }
        /**
         * Open the search form and trap focus
         */
  
      }, {
        key: "_openSearch",
        value: function _openSearch() {
          var _this = this;
  
          this.searchElement.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('no-scroll');
          this._setSearchButtonsExpanded(true);
          if (this.searchInputElement) {
            this.searchInputElement.setAttribute('autofocus', '');
          }
          Accessibility.trapFocus(this.searchElement, 'search');
          this._focusSearchInput();
  
          var onFocusListener = function onFocusListener() {
            _this._focusSearchInput();
            _this.searchElement.removeEventListener('transitionend', onFocusListener);
          };
  
          this.searchElement.addEventListener('transitionend', onFocusListener);
          window.setTimeout(function () {
            _this._focusSearchInput();
          }, 50);
          window.setTimeout(function () {
            _this._focusSearchInput();
          }, 300);
          this.isOpen = true;
          this.pageOverlayElement.classList.add('is-visible');
          document.querySelector('#shopify-section-header').style.zIndex = 10;
        }
        /**
         * Close the search form and clear focus
         */
  
      }, {
        key: "_closeSearch",
        value: function _closeSearch() {
          var _this2 = this;
  
          this.searchElement.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('no-scroll');
          if (this.searchInputElement) {
            this.searchInputElement.removeAttribute('autofocus');
          }
          this._setSearchButtonsExpanded(false);
          Accessibility.removeTrapFocus(this.searchElement, 'search');
          this.isOpen = false;
  
          var onTransitionEnd = function onTransitionEnd(event) {
            if (event.propertyName === 'visibility') {
              document.querySelector('#shopify-section-header').style.zIndex = '';
  
              _this2.pageOverlayElement.removeEventListener('transitionend', onTransitionEnd);
            }
          };
  
          this.pageOverlayElement.addEventListener('transitionend', onTransitionEnd);
          this.pageOverlayElement.classList.remove('is-visible');
          var opener = this.searchOpener;
          this.searchOpener = null;
          window.setTimeout(function () {
            if (opener && document.contains(opener) && typeof opener.focus === 'function') {
              opener.focus();
            }
          }, 50);
        }
        /**
         * In order to prevent an odd UX where hitting the enter always choose the product results, if the search is set to product + something else,
         * then we disable submission using enter key
         */
  
      }, {
        key: "_preventSubmission",
        value: function _preventSubmission(event) {
          if (event.keyCode === 13 && window.theme.searchMode !== 'product') {
            // event.preventDefault();
          }
        }
        /**
         * This is called when the user has stopped typing (after debounce delay)
         */
  
      }, {
        key: "_onInput",
        value: function _onInput(event) {
          var _this3 = this;
  
          if (event.keyCode === 13) {
            return;
          } // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
          // keep track of sent requests, and only use the results of the last one
  
  
          this.lastInputValue = event.target.value;
  
          if (this.lastInputValue === '') {
            this._resetSearch();
  
            return;
          }
  
          var queryOptions = {
            method: 'GET',
            credentials: 'same-origin'
          };
          var queries = [fetch("".concat(window.routes.searchUrl, "?section_id=predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "&options[prefix]=last&type=product"), queryOptions)];
  
          if (window.theme.searchMode !== 'product') {
            queries.push(fetch("".concat(window.routes.searchUrl, "?section_id=predictive-search&q=").concat(encodeURIComponent(this.lastInputValue), "&options[prefix]=last&type=").concat(window.theme.searchMode.replace('product,', '')), queryOptions));
          }

          window.Shopify.analytics.publish('dynamic_search');
          console.log(this.lastInputValue);
          
          this.queryMap[this.lastInputValue] = true;
          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          Promise.all(queries).then(function (responses) {
            // If we receive the result for a query that is not the last one, we simply do not process the result
            if (_this3.lastInputValue !== event.target.value) {
              return;
            }
  
            delete _this3.queryMap[event.target.value];
            Promise.all(responses.map(function (response) {
              return response.text();
            })).then(function (contents) {
              // If we have only one content then we only have product, otherwise we have products and articles
              if (window.theme.searchMode === 'product') {
                _this3.searchResultsElement.innerHTML = contents[0];
              } else {
                _this3.searchResultsElement.innerHTML = "<div class=\"PageLayout PageLayout--breakLap\">\n              <div class=\"PageLayout__Section\">".concat(contents[0], "</div>\n              <div class=\"PageLayout__Section PageLayout__Section--secondary\">").concat(contents[1], "</div>\n            </div>");
              }
              
              _this3.searchResultsElement.setAttribute('aria-hidden', 'false');
            });
            
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          });
        }
      }, {
        key: "_resetSearch",
        value: function _resetSearch() {
          if (window.theme.searchMode === 'product') {
            this.searchResultsElement.innerHTML = '';
          } else {
            this.searchResultsElement.innerHTML = "<div class=\"PageLayout PageLayout--breakLap\">\n              <div class=\"PageLayout__Section\"></div>\n              <div class=\"PageLayout__Section PageLayout__Section--secondary\"></div>\n            </div>";
          }
  
          this.searchResultsElement.setAttribute('aria-hidden', 'true');
          document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
        }
        /**
         * Simple function that allows to debounce
         */
  
      }, {
        key: "_debounce",
        value: function _debounce(fn, delay) {
          var _this4 = this;
  
          var timer = null;
          return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
  
            clearTimeout(timer);
            timer = setTimeout(function () {
              fn.apply(_this4, args);
            }, delay);
          };
        }
      }]);
  
      return SearchBar;
    }();
  

    (function initBoostSearchHeadingFix() {
      var timer = null;

      function promoteBoostSearchHeadings() {
        var headings = document.querySelectorAll("h3.boost-sd__suggestion-queries-header, h3.boost-sd__instant-search-product-list-header");
        Array.prototype.forEach.call(headings, function (heading) {
          if (!heading.parentNode || heading.offsetHeight === 0) {
            return;
          }

          var replacement = document.createElement("h2");
          var computed = window.getComputedStyle(heading);
          var i;

          for (i = 0; i < heading.attributes.length; i++) {
            replacement.setAttribute(heading.attributes[i].name, heading.attributes[i].value);
          }

          replacement.removeAttribute("tabindex");

          if (replacement.getAttribute("role") === "text") {
            replacement.removeAttribute("role");
          }

          replacement.style.fontSize = computed.fontSize;
          replacement.style.fontWeight = computed.fontWeight;
          replacement.style.fontFamily = computed.fontFamily;
          replacement.style.lineHeight = computed.lineHeight;
          replacement.style.letterSpacing = computed.letterSpacing;
          replacement.style.textTransform = computed.textTransform;
          replacement.style.color = computed.color;
          replacement.style.margin = computed.margin;
          replacement.style.padding = computed.padding;

          while (heading.firstChild) {
            replacement.appendChild(heading.firstChild);
          }

          heading.parentNode.replaceChild(replacement, heading);
        });
      }

      function schedulePromote() {
        clearTimeout(timer);
        timer = setTimeout(promoteBoostSearchHeadings, 500);
      }

      if (document.body) {
        new MutationObserver(schedulePromote).observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    })();

    (function initRandolphSwiperNavFocus() {
      window.Randolph = window.Randolph || {};

      window.Randolph.createSwiperNavFocusHandler = function(options) {
        var root = options.root;
        var nextBtn = options.nextBtn;
        var prevBtn = options.prevBtn;
        var navSelector = options.navSelector || '.swiper-button-next, .swiper-button-prev, .flyout-ycab__nav-btn';
        var pendingNavBtn = null;

        if (!root || !nextBtn || !prevBtn) {
          return {
            slideChangeTransitionEnd: function() {},
            syncNavTabIndex: function() {}
          };
        }

        function isNextButton(btn) {
          return btn === nextBtn
            || (btn.classList && btn.classList.contains('swiper-button-next'))
            || (btn.classList && btn.classList.contains('flyout-ycab__nav-btn--next'));
        }

        function focusElement(el) {
          if (!el || typeof el.focus !== 'function') return;
          try {
            el.focus({ preventScroll: true });
          } catch (err) {
            el.focus();
          }
        }

        function isUsableButton(btn) {
          return !!btn
            && !btn.classList.contains('swiper-button-disabled')
            && btn.offsetParent !== null;
        }

        function focusButton(btn) {
          if (!btn || btn.classList.contains('swiper-button-disabled')) return;
          focusElement(btn);
        }

        /**
         * The arrow the user was working with has run out of slides. Focus moves to
         * the arrow that still has somewhere to go, so the next Tab leaves the
         * carousel for the following section instead of dropping into the track.
         */
        function focusAfterExhausted(swiper, btn) {
          var forward = isNextButton(btn);
          var other = forward ? prevBtn : nextBtn;

          if (isUsableButton(other)) {
            focusElement(other);
            return;
          }

          // Neither arrow can move: the row is showing everything it has.
          focusBoundarySlide(swiper, forward ? 'last' : 'first');
        }

        function getVisibleSlides(swiper) {
          if (!swiper || !swiper.slides) return [];

          return Array.prototype.filter.call(swiper.slides, function(slide, index) {
            if (slide.classList.contains('swiper-slide-visible')) return true;

            if (typeof swiper.params.slidesPerView === 'number') {
              var start = swiper.activeIndex || 0;
              return index >= start && index < start + Math.ceil(swiper.params.slidesPerView);
            }

            return slide.classList.contains('swiper-slide-active');
          });
        }

        /**
         * Fractional slidesPerView leaves an edge slide half outside the clipping
         * box. Focusing one makes the browser scroll the box to reveal it, which
         * visibly drags the whole row and its overlay buttons sideways.
         */
        function getFullyVisibleSlides(swiper, visible) {
          if (!swiper || !swiper.el) return visible;

          var frame = swiper.el.getBoundingClientRect();

          return visible.filter(function(slide) {
            var rect = slide.getBoundingClientRect();
            return rect.left >= frame.left - 1 && rect.right <= frame.right + 1;
          });
        }

        function focusSlideControl(slide) {
          if (!slide) return;
          var target = slide.querySelector('a[href], button:not([disabled])');

          if (target) {
            focusElement(target);
          }
        }

        function focusBoundarySlide(swiper, position) {
          var visible = getVisibleSlides(swiper);
          if (!visible.length) return;

          var candidates = getFullyVisibleSlides(swiper, visible);
          if (!candidates.length) candidates = visible;

          if (position === 'last') {
            focusSlideControl(candidates[candidates.length - 1]);
          } else {
            focusSlideControl(candidates[0]);
          }
        }

        function resolveSwiper() {
          if (typeof options.getSwiper === 'function') return options.getSwiper();
          var el = root.classList.contains('swiper') ? root : root.querySelector('.swiper');
          return el ? el.swiper : null;
        }

        function syncNavTabIndex() {
          [nextBtn, prevBtn].forEach(function(btn) {
            if (!btn) return;

            if (btn.classList.contains('swiper-button-disabled')) {
              btn.setAttribute('tabindex', '-1');

              // Some breakpoints hide disabled arrows outright, which would drop
              // focus to the body, so it moves on before the button disappears.
              if (document.activeElement === btn) {
                focusAfterExhausted(resolveSwiper(), btn);
              }
            } else {
              btn.removeAttribute('tabindex');
            }
          });
        }

        function onKeydown(event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          var btn = event.target.closest(navSelector);
          if (!btn || !root.contains(btn)) return;
          if (btn.classList.contains('swiper-button-disabled')) return;
          pendingNavBtn = btn;
        }

        function slideChangeTransitionEnd(swiper) {
          syncNavTabIndex();

          if (!pendingNavBtn) return;

          var btn = pendingNavBtn;
          pendingNavBtn = null;

          // The row moved, so focus stays on the arrow that moved it and the user
          // can keep pressing Enter. Only an arrow that has run out hands focus on.
          var pressed = isNextButton(btn) ? nextBtn : prevBtn;

          if (isUsableButton(pressed)) {
            focusElement(pressed);
          } else {
            focusAfterExhausted(swiper, btn);
          }
        }

        root.addEventListener('keydown', onKeydown);

        return {
          slideChangeTransitionEnd: slideChangeTransitionEnd,
          syncNavTabIndex: syncNavTabIndex,
          destroy: function() {
            root.removeEventListener('keydown', onKeydown);
          }
        };
      };

      function findNavContext(swiperEl) {
        var node = swiperEl;

        while (node) {
          var nextBtn = node.querySelector('.swiper-button-next, .flyout-ycab__nav-btn--next');
          var prevBtn = node.querySelector('.swiper-button-prev, .flyout-ycab__nav-btn--prev');

          if (nextBtn && prevBtn) {
            return {
              root: node,
              nextBtn: nextBtn,
              prevBtn: prevBtn,
              navSelector: node.querySelector('.flyout-ycab__nav-btn')
                ? '.flyout-ycab__nav-btn'
                : '.swiper-button-next, .swiper-button-prev'
            };
          }

          node = node.parentElement;
        }

        return null;
      }

      function attach(swiperEl) {
        if (!swiperEl || swiperEl.dataset.randolphNavFocusAttached === 'true') return;

        var swiper = swiperEl.swiper;
        if (!swiper) return;

        var ctx = findNavContext(swiperEl);
        if (!ctx) return;

        swiperEl.dataset.randolphNavFocusAttached = 'true';

        var handler = window.Randolph.createSwiperNavFocusHandler(ctx);
        handler.syncNavTabIndex();
        swiper.on('init', handler.syncNavTabIndex);
        swiper.on('slideChange', handler.syncNavTabIndex);
        swiper.on('resize', handler.syncNavTabIndex);
        swiper.on('slideChangeTransitionEnd', function() {
          handler.slideChangeTransitionEnd(swiper);
        });
      }

      /**
       * Swiper moves slides with transforms, so its clipping boxes should never
       * scroll. Browsers still scroll them when focus lands on a control near the
       * clipped edge, which makes overlay controls (quick view, arrows) look like
       * they jumped to another spot on the card.
       */
      function guardScroll(swiperEl) {
        if (!swiperEl || swiperEl.dataset.randolphScrollGuard === 'true') return;

        var swiper = swiperEl.swiper;
        if (!swiper) return;

        var freeMode = swiper.params.freeMode;
        var freeModeEnabled = freeMode === true || (freeMode && freeMode.enabled === true);
        if (swiper.params.cssMode === true || freeModeEnabled) return;

        swiperEl.dataset.randolphScrollGuard = 'true';

        // Each axis is judged on its own: a modal with `overflow-x: hidden` and
        // `overflow-y: auto` must keep its vertical scrolling, so only the clipped
        // axis is ever forced back to 0. Axes the user can scroll are left alone.
        function axisLocks(el) {
          var styles = window.getComputedStyle(el);
          return {
            node: el,
            lockX: ['hidden', 'clip'].indexOf(styles.overflowX) !== -1,
            lockY: ['hidden', 'clip'].indexOf(styles.overflowY) !== -1
          };
        }

        var clippedBoxes = [];
        var node = swiperEl;

        while (node && node !== document.body) {
          var locks = axisLocks(node);
          if (locks.lockX || locks.lockY) clippedBoxes.push(locks);
          node = node.parentElement;
        }

        if (!clippedBoxes.length) return;

        function reset() {
          clippedBoxes.forEach(function(box) {
            if (box.lockX && box.node.scrollLeft !== 0) box.node.scrollLeft = 0;
            if (box.lockY && box.node.scrollTop !== 0) box.node.scrollTop = 0;
          });
        }

        function resetNow() {
          reset();
          window.requestAnimationFrame(reset);
        }

        clippedBoxes.forEach(function(box) {
          box.node.addEventListener('scroll', reset, true);
        });

        swiperEl.addEventListener('focusin', resetNow, true);
        swiperEl.addEventListener('keyup', resetNow, true);
      }

      /**
       * A slide the row only shows part of is taken out of reach entirely: focusing a
       * control that sits past the edge makes the browser scroll the clipped box to
       * reveal it, which drags the whole row and its overlay buttons sideways. So the
       * cut-off slide loses its tab stops and is hidden from assistive tech, which
       * VoiceOver needs because it walks the accessibility tree and ignores tabindex
       * on its own. Either way the step after the last whole card is the Next arrow,
       * and the row only moves when the user asks for it.
       *
       * Everything is measured from rects, so the cut-off point follows whatever
       * slidesPerView the current breakpoint happens to use.
       */
      function silenceWrapper(swiperEl) {
        var wrapper = swiperEl.querySelector('.swiper-wrapper');
        if (!wrapper) return;
        wrapper.setAttribute('aria-live', 'off');
        wrapper.setAttribute('aria-atomic', 'false');
        wrapper.removeAttribute('aria-relevant');
      }

      function limitReachToWholeSlides(swiperEl) {
        if (!swiperEl || swiperEl.dataset.randolphTabLimit === 'true') return;

        var swiper = swiperEl.swiper;
        if (!swiper) return;

        swiperEl.dataset.randolphTabLimit = 'true';
        silenceWrapper(swiperEl);

        var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

        /**
         * Some breakpoints let the row spill outside its box on purpose, so there the
         * screen edge decides what counts as shown rather than the box.
         */
        function frameEdges() {
          var styles = window.getComputedStyle(swiperEl);

          if (['hidden', 'clip'].indexOf(styles.overflowX) === -1) {
            return {
              left: 0,
              right: window.innerWidth || document.documentElement.clientWidth
            };
          }

          var rect = swiperEl.getBoundingClientRect();
          return { left: rect.left, right: rect.right };
        }

        function hide(el) {
          if (el.dataset.randolphTabHidden !== 'true') {
            var current = el.getAttribute('tabindex');
            // A -1 already there came from a section's own visibility sweep, so it is
            // not remembered as an authored value that has to come back.
            if (current !== null && current !== '-1') {
              el.dataset.randolphTabIndex = current;
            }
            el.dataset.randolphTabHidden = 'true';
          }

          // Re-asserted every pass because sections run their own visibility sweep.
          if (el.getAttribute('tabindex') !== '-1') el.setAttribute('tabindex', '-1');
        }

        function show(el) {
          if (el.dataset.randolphTabHidden !== 'true') return;

          delete el.dataset.randolphTabHidden;

          if (typeof el.dataset.randolphTabIndex === 'string') {
            el.setAttribute('tabindex', el.dataset.randolphTabIndex);
            delete el.dataset.randolphTabIndex;
          } else {
            el.removeAttribute('tabindex');
          }
        }

        function controlsOf(slide) {
          return Array.prototype.slice.call(slide.querySelectorAll(FOCUSABLE));
        }

        function takeOut(slide) {
          // Never hide a slide from under someone already working inside it.
          if (slide.contains(document.activeElement)) return;

          if (slide.dataset.randolphSlideOut !== 'true') {
            var previous = slide.getAttribute('aria-hidden');
            // A 'true' already there came from a section's own sweep over the slides
            // that sit right outside the row, so it is not an authored value.
            if (previous !== null && previous !== 'true') {
              slide.dataset.randolphAriaHidden = previous;
            }
            slide.dataset.randolphSlideOut = 'true';
          }

          if (slide.getAttribute('aria-hidden') !== 'true') {
            slide.setAttribute('aria-hidden', 'true');
          }

          controlsOf(slide).forEach(hide);
        }

        function bringBack(slide) {
          if (slide.dataset.randolphSlideOut === 'true') {
            delete slide.dataset.randolphSlideOut;

            if (typeof slide.dataset.randolphAriaHidden === 'string') {
              slide.setAttribute('aria-hidden', slide.dataset.randolphAriaHidden);
              delete slide.dataset.randolphAriaHidden;
            } else {
              slide.removeAttribute('aria-hidden');
            }
          }

          controlsOf(slide).forEach(show);
        }

        function apply() {
          silenceWrapper(swiperEl);
          var slides = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-slide'));
          if (!slides.length) return;

          // Once the slider is gone nothing is clipped any more, so every card it
          // used to hold has to be reachable again.
          if (swiper.destroyed || swiper.enabled === false) {
            slides.forEach(bringBack);
            return;
          }

          var edges = frameEdges();
          var whole = [];

          slides.forEach(function(slide) {
            var rect = slide.getBoundingClientRect();
            if (rect.width > 0 && rect.left >= edges.left - 1 && rect.right <= edges.right + 1) {
              whole.push(slide);
            }
          });

          // A card wider than the row would otherwise leave nothing to reach at all,
          // so then every slide keeps whatever its section gave it.
          if (!whole.length) {
            slides.forEach(bringBack);
            return;
          }

          slides.forEach(function(slide) {
            if (whole.indexOf(slide) !== -1) {
              bringBack(slide);
            } else {
              takeOut(slide);
            }
          });
        }

        // Sections sweep slide visibility on the same events, so this waits a frame
        // to have the final say on which slides can be reached.
        function schedule() {
          window.requestAnimationFrame(apply);
        }

        schedule();
        swiper.on('slideChange', schedule);
        swiper.on('transitionEnd', schedule);
        swiper.on('touchEnd', schedule);
        swiper.on('resize', schedule);
        swiper.on('update', schedule);
        swiper.on('observerUpdate', schedule);
        swiper.on('slidesLengthChange', schedule);
        // A slide holding focus is left alone, so it is reconsidered once focus goes.
        swiperEl.addEventListener('focusout', schedule);
        // The first pass can run before the row has its final width.
        window.addEventListener('load', schedule);
      }

      /**
       * Position in a carousel was never spoken. The arrows keep focus while the
       * row moves, and slides are named after their product, so the set could
       * advance in silence. Each slider gets a status region for the move, and the
       * slide names carry their position for anyone browsing card by card.
       * Autoplaying sliders are skipped so they cannot chatter on a timer.
       */
      function announceSlidePosition(swiperEl) {
        if (!swiperEl || swiperEl.dataset.randolphSlideStatus === 'true') return;

        var swiper = swiperEl.swiper;
        if (!swiper) return;

        var autoplay = swiper.params.autoplay;
        if (autoplay === true || (autoplay && autoplay.enabled === true)) return;

        swiperEl.dataset.randolphSlideStatus = 'true';

        var messages = window.languages || {};
        var singleTemplate = messages.sliderSlidePosition || 'Slide INDEX of COUNT';
        var rangeTemplate = messages.sliderSlidePositionRange || 'Slides START to END of COUNT';
        var namedTemplate = messages.sliderSlidePositionNamed || 'POSITION, NAME';

        // Swiper labels every slide "3 / 8" on its own, which loses the product
        // name and would overwrite the labels below whenever the set changes.
        var SWIPER_DEFAULT_LABEL = /^\d+\s*\/\s*\d+$/;
        if (swiper.params.a11y) swiper.params.a11y.slideLabelMessage = '';

        var status = document.createElement('div');
        status.className = 'u-visually-hidden';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.setAttribute('aria-atomic', 'true');
        (swiperEl.parentElement || swiperEl).appendChild(status);

        var announceTimer = null;

        function fill(template, values) {
          return Object.keys(values).reduce(function(text, token) {
            return text.replace(token, function() {
              return values[token];
            });
          }, template);
        }

        function realSlides() {
          return Array.prototype.slice.call(
            swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
          );
        }

        // A looped slider clones its slides, and a clone has to report the
        // position of the slide it was cloned from.
        function positionOf(slide, slides) {
          var clonedFrom = slide.getAttribute('data-swiper-slide-index');
          if (slide.classList.contains('swiper-slide-duplicate') && clonedFrom !== null) {
            return parseInt(clonedFrom, 10) + 1;
          }
          return slides.indexOf(slide) + 1;
        }

        function positionText(start, end, total) {
          if (start === end) return fill(singleTemplate, { INDEX: start, COUNT: total });
          return fill(rangeTemplate, { START: start, END: end, COUNT: total });
        }

        function slideName(slide) {
          if (typeof slide.dataset.randolphSlideName === 'string') {
            return slide.dataset.randolphSlideName;
          }

          var name = '';
          var labelledBy = slide.getAttribute('aria-labelledby');

          if (labelledBy) {
            labelledBy.split(/\s+/).forEach(function(id) {
              var source = document.getElementById(id);
              if (!source) return;
              var text = (source.textContent || '').replace(/\s+/g, ' ').trim();
              if (text) name = name ? name + ' ' + text : text;
            });
          }

          if (!name) {
            name = (slide.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
            if (SWIPER_DEFAULT_LABEL.test(name)) name = '';
          }

          slide.dataset.randolphSlideName = name;
          return name;
        }

        function labelSlides() {
          var slides = realSlides();
          var total = slides.length;
          if (total < 2) return;
          var positionOnly = swiperEl.getAttribute('data-slide-labels') === 'position';

          Array.prototype.forEach.call(swiperEl.querySelectorAll('.swiper-slide'), function(slide) {
            // Only sliders that already opted into the slide pattern are relabelled,
            // so decorative rows keep the names their section gave them.
            if (slide.getAttribute('role') !== 'group') return;

            var position = positionOf(slide, slides);
            if (position < 1) return;

            var name = positionOnly ? '' : slideName(slide);
            if (positionOnly) {
              slide.dataset.randolphSlideName = '';
            }
            var text = positionText(position, position, total);

            slide.setAttribute('aria-label', name ? fill(namedTemplate, { POSITION: text, NAME: name }) : text);
            // aria-labelledby outranks aria-label, so the position would go unread.
            if (slide.hasAttribute('aria-labelledby')) slide.removeAttribute('aria-labelledby');
          });
        }

        function announce() {
          if (swiper.destroyed || swiper.isLocked) return;

          var slides = realSlides();
          var total = slides.length;
          if (total < 2) return;

          var shown = Array.prototype.slice.call(swiperEl.querySelectorAll('.swiper-slide-visible'));
          if (!shown.length) {
            var active = swiperEl.querySelector('.swiper-slide-active');
            if (active) shown = [active];
          }

          var positions = shown.map(function(slide) {
            return positionOf(slide, slides);
          }).filter(function(position) {
            return position > 0;
          });

          if (!positions.length) return;

          var text = positionText(
            Math.min.apply(null, positions),
            Math.max.apply(null, positions),
            total
          );

          if (status.textContent === text) {
            // An unchanged region stays silent, so empty it before repeating.
            status.textContent = '';
            window.setTimeout(function() {
              status.textContent = text;
            }, 50);
            return;
          }

          status.textContent = text;
        }

        function schedule() {
          window.clearTimeout(announceTimer);
          announceTimer = window.setTimeout(announce, 250);
        }

        labelSlides();

        swiper.on('slideChangeTransitionEnd', schedule);
        swiper.on('slideChange', labelSlides);
        swiper.on('resize', labelSlides);
        swiper.on('slidesLengthChange', labelSlides);
        swiper.on('slidesGridLengthChange', labelSlides);
      }

      function scan() {
        document.querySelectorAll('.swiper.swiper-initialized').forEach(function(swiperEl) {
          attach(swiperEl);
          guardScroll(swiperEl);
          limitReachToWholeSlides(swiperEl);
          announceSlidePosition(swiperEl);
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scan);
      } else {
        scan();
      }

      window.addEventListener('load', scan);

      if (window.MutationObserver && document.body) {
        new MutationObserver(scan).observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }
    })();

    (function initBoostSearchCloseRoleFix() {
      var timer = null;

      function fixCloseButton() {
        document.querySelectorAll('button[data-group="close-search-form"]').forEach(function (button) {
          if (button.getAttribute('role') === 'textbox') {
            button.removeAttribute('role');
          }
          var label = (button.getAttribute('aria-label') || '').trim();
          if (!label || /^close$/i.test(label)) {
            button.setAttribute('aria-label', 'Close search');
          }
        });
      }

      function scheduleFix() {
        clearTimeout(timer);
        timer = setTimeout(fixCloseButton, 50);
      }

      fixCloseButton();
      if (document.body) {
        new MutationObserver(scheduleFix).observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['role', 'aria-label']
        });
      }
    })();

    (function initOkendoSortExpandedState() {
      function bindSortSelect(select) {
        if (!select || select.getAttribute('data-oke-expanded-bound') === 'true') return;
        select.setAttribute('data-oke-expanded-bound', 'true');
        if (!select.hasAttribute('aria-expanded')) {
          select.setAttribute('aria-expanded', 'false');
        }
        function expand() {
          select.setAttribute('aria-expanded', 'true');
        }
        function collapse() {
          select.setAttribute('aria-expanded', 'false');
        }
        select.addEventListener('mousedown', expand);
        select.addEventListener('keydown', function (event) {
          if (event.key === ' ' || event.key === 'Enter' || event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'F4') {
            expand();
          }
          if (event.key === 'Escape') {
            collapse();
          }
        });
        select.addEventListener('change', collapse);
        select.addEventListener('blur', collapse);
      }

      function bindAll() {
        document.querySelectorAll('select.oke-sortSelect-sort, select[id^="oke-sortSelect"]').forEach(bindSortSelect);
      }

      bindAll();
      if (document.body) {
        new MutationObserver(bindAll).observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    })();

    var CountrySelector = /*#__PURE__*/function () {
      function CountrySelector(countrySelect, provinceSelect) {
        _classCallCheck(this, CountrySelector);
  
        this.countrySelect = countrySelect;
        this.provinceSelect = provinceSelect;
  
        if (this.countrySelect && this.provinceSelect) {
          this._attachListeners();
  
          this._initSelectors();
        }
      }
  
      _createClass(CountrySelector, [{
        key: "destroy",
        value: function destroy() {
          if (this.countrySelect) {
            this.countrySelect.removeEventListener('change', this._onCountryChangedListener);
          }
        }
      }, {
        key: "_initSelectors",
        value: function _initSelectors() {
          // Check first the default value of country
          var defaultCountry = this.countrySelect.getAttribute('data-default');
  
          if (defaultCountry) {
            for (var i = 0; i !== this.countrySelect.options.length; ++i) {
              if (this.countrySelect.options[i].text === defaultCountry) {
                this.countrySelect.selectedIndex = i;
                break;
              }
            }
          } else {
            this.countrySelect.selectedIndex = 0;
          }
  
          var event = new Event('change', {
            bubbles: true
          });
          this.countrySelect.dispatchEvent(event); // Then the province
  
          var defaultProvince = this.provinceSelect.getAttribute('data-default');
  
          if (defaultProvince) {
            for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i) {
              if (this.provinceSelect.options[_i].text === defaultProvince) {
                this.provinceSelect.selectedIndex = _i;
                break;
              }
            }
          }
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onCountryChangedListener = this._onCountryChanged.bind(this);
          this.countrySelect.addEventListener('change', this._onCountryChangedListener);
        }
      }, {
        key: "_onCountryChanged",
        value: function _onCountryChanged() {
          var _this = this;
  
          var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex],
              provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]'); // First remove all options
  
          this.provinceSelect.innerHTML = '';
  
          if (provinces.length === 0) {
            this.provinceSelect.parentNode.style.display = 'none';
            return;
          } // We need to build the provinces array
  
  
          provinces.forEach(function (data) {
            _this.provinceSelect.options.add(new Option(data[1], data[0]));
          });
          this.provinceSelect.parentNode.style.display = 'block';
        }
      }]);
  
      return CountrySelector;
    }();
  
    var ShippingEstimator = /*#__PURE__*/function () {
      function ShippingEstimator(element) {
        _classCallCheck(this, ShippingEstimator);
  
        this.element = element;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.countrySelector = new CountrySelector(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]'));
  
        this._attachListeners();
      }
  
      _createClass(ShippingEstimator, [{
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off('click');
          this.countrySelector.destroy();
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on('click', '.ShippingEstimator__Submit', this._fetchRates.bind(this));
        }
      }, {
        key: "_fetchRates",
        value: function _fetchRates() {
          var _this = this;
  
          var country = this.element.querySelector('[name="country"]').value,
              province = this.element.querySelector('[name="province"]').value,
              zip = this.element.querySelector('[name="zip"]').value;
          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(zip, "&shipping_address[country]=").concat(country, "&shipping_address[province]=").concat(province), {
            credentials: 'same-origin',
            method: 'GET'
          }).then(function (response) {
            response.json().then(function (result) {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
  
              var resultsContainer = _this.element.querySelector('.ShippingEstimator__Results'),
                  errorContainer = _this.element.querySelector('.ShippingEstimator__Error');
  
              if (response.ok) {
                var shippingRates = result['shipping_rates'];
  
                if (shippingRates.length === 0) {
                  resultsContainer.innerHTML = "<p>".concat(window.languages.shippingEstimatorNoResults, "</p>");
                } else {
                  var html = '';
  
                  if (shippingRates.length === 1) {
                    html += "<p>".concat(window.languages.shippingEstimatorOneResult, "</p><ul>");
                  } else {
                    html += "<p>".concat(window.languages.shippingEstimatorMoreResults.replace('', shippingRates.length), "</p><ul>");
                  }
  
                  shippingRates.forEach(function (item) {
                    html += "<li>".concat(item['name'], ": ").concat(Currency.formatMoney(item['price'], window.theme.moneyFormat), "</li>");
                  });
                  html += '</ul>';
                  resultsContainer.firstElementChild.innerHTML = html;
                }
  
                TweenLite.fromTo(resultsContainer.firstElementChild, 0.6, {
                  autoAlpha: 0,
                  y: -15
                }, {
                  autoAlpha: 1,
                  y: 0,
                  delay: 0.35
                });
                errorContainer.style.display = 'none';
                resultsContainer.style.display = 'block';
                Animation.slideDown(resultsContainer);
              } else {
                var errorHtml = '';
                Object.keys(result).forEach(function (key) {
                  errorHtml += "<li class=\"Alert__ErrorItem\">".concat(key, " ").concat(result[key], "</li>");
                });
                errorContainer.innerHTML = "<ul class=\"Alert__ErrorList\">".concat(errorHtml, "</ul>");
                resultsContainer.style.display = 'none';
                errorContainer.style.display = 'block';
              }
            });
          });
        }
      }]);
  
      return ShippingEstimator;
    }();
  
    var AddressesSection = function AddressesSection() {
      var _this = this;
  
      _classCallCheck(this, AddressesSection);
  
      this.countrySelectors = [];
      Dom.nodeListToArray(document.querySelectorAll('.Modal--address')).forEach(function (modal) {
        _this.countrySelectors.push(new CountrySelector(modal.querySelector('[name="address[country]"]'), modal.querySelector('[name="address[province]"]')));
      });
    };
  
    var ArticleList = /*#__PURE__*/function () {
      function ArticleList(container) {
        var _this = this;
  
        _classCallCheck(this, ArticleList);
  
        this.element = container;
  
        if (window.theme.showElementStaggering) {
          this.timeline = new TimelineLite({
            delay: window.theme.showPageTransition ? 0.5 : 0
          });
          this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
          Dom.nodeListToArray(this.element.querySelectorAll('.ArticleItem')).forEach(function (item) {
            _this.intersectionObserver.observe(item);
          });
        }
      }
  
      _createClass(ArticleList, [{
        key: "onUnload",
        value: function onUnload() {
          if (window.theme.showElementStaggering) {
            this.intersectionObserver.disconnect();
            this.timeline.kill();
          }
        }
      }, {
        key: "_reveal",
        value: function _reveal(results) {
          var _this2 = this;
  
          var toReveal = [];
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              // isIntersecting does not exist on Samsung Android browser
              toReveal.push(result.target);
  
              _this2.intersectionObserver.unobserve(result.target);
            }
          });
  
          if (toReveal.length === 0) {
            return;
          }
  
          this.timeline.staggerFromTo(toReveal, 0.45, {
            autoAlpha: 0,
            y: 30
          }, {
            autoAlpha: 1,
            y: 0
          }, 0.2);
        }
      }]);
  
      return ArticleList;
    }();
  
    var ArticleSection = /*#__PURE__*/function () {
      function ArticleSection(container) {
        var _this = this;
  
        _classCallCheck(this, ArticleSection);
  
        this.element = container;
        this.toolbarElement = this.element.querySelector('.ArticleToolbar');
        this.articleNavElement = this.element.querySelector('.ArticleNav');
        var articleImageElement = this.element.querySelector('.Article__Image');
  
        if (articleImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
          this.parallaxInstance = new Rellax('.Article__Image', {
            speed: -7,
            center: false,
            round: true
          });
        }
  
        if (window.theme.showElementStaggering) {
          this.timeline = new TimelineLite({
            delay: window.theme.showPageTransition ? 0.5 : 0
          });
          this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
          Dom.nodeListToArray(this.element.querySelectorAll('.ArticleItem')).forEach(function (item) {
            _this.intersectionObserver.observe(item);
          });
        }
  
        this._attachListeners();
        this._checkToolbarVisibility();
      }
  
      _createClass(ArticleSection, [{
        key: "onUnload",
        value: function onUnload() {
          if (this.parallaxInstance) {
            this.parallaxInstance.destroy();
          }
  
          if (window.theme.showElementStaggering) {
            this.intersectionObserver.disconnect();
            this.timeline.kill();
          }
  
          window.removeEventListener('scroll', this._onScrollListener);
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onScrollListener = this._checkToolbarVisibility.bind(this);
          window.addEventListener('scroll', this._onScrollListener);
        }
      }, {
        key: "_checkToolbarVisibility",
        value: function _checkToolbarVisibility() {
          var _this2 = this;

          if (!this.toolbarElement) {
            return;
          }
  
          var lastYPosition = 0,
              headerHeight = 0,
              navBottom = 0,
              isFixedHeader = 0,
              header = document.querySelector('.Header');
          fastdom.measure(function () {
            lastYPosition = window.pageYOffset;
            headerHeight = header ? header.offsetHeight : 0;
            isFixedHeader = parseInt(window.getComputedStyle(document.body).getPropertyValue('--use-sticky-header') || 0);
  
            if (_this2.articleNavElement) {
              navBottom = _this2.articleNavElement.offsetTop + _this2.articleNavElement.clientHeight - headerHeight;
            }
          });
          fastdom.mutate(function () {
            var toolbarTopOffset = isFixedHeader ? Math.max(headerHeight - 1, 0) + 'px' : null;
            _this2.toolbarElement.style.top = toolbarTopOffset;
  
            if (_this2.articleNavElement) {
              if (lastYPosition > 150 && _this2.articleNavElement && lastYPosition < navBottom) {
                _this2.toolbarElement.classList.add('is-visible');
              } else {
                _this2.toolbarElement.classList.remove('is-visible');
              }
            } else {
              if (lastYPosition > 150) {
                _this2.toolbarElement.classList.add('is-visible');
              } else {
                _this2.toolbarElement.classList.remove('is-visible');
              }
            }
          });
        }
      }, {
        key: "_reveal",
        value: function _reveal(results) {
          var _this3 = this;
  
          var toReveal = [];
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              // isIntersecting does not exist on Samsung Android browser
              toReveal.push(result.target);
  
              _this3.intersectionObserver.unobserve(result.target);
            }
          });
  
          if (toReveal.length === 0) {
            return;
          }
  
          this.timeline.staggerFromTo(toReveal, 0.45, {
            autoAlpha: 0,
            y: 30
          }, {
            autoAlpha: 1,
            y: 0
          }, 0.2);
        }
      }]);
  
      return ArticleSection;
    }();
  
    var CartSection = /*#__PURE__*/function () {
      function CartSection(container) {
        _classCallCheck(this, CartSection);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.documentDelegate = new domDelegate.Delegate(document.documentElement);
        this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
        this.itemCount = this.options['itemCount'];
        this.isCartNoteOpen = false;
  
        if (this.options['drawer']) {
          this.sidebarDrawer = new Drawer(this.element, {
            onClose: this._onDrawerClosed.bind(this)
          });
        }
  
        if (this.options['hasShippingEstimator']) {
          this.shippingEstimator = new ShippingEstimator(this.element.querySelector('.ShippingEstimator'));
        }
  
        this._attachListeners();
      }
  
      _createClass(CartSection, [{
        key: "onUnload",
        value: function onUnload() {
          if (this.options['hasShippingEstimator']) {
            this.shippingEstimator.destroy();
          }
  
          this.delegateElement.off();
          document.removeEventListener('product:added', this._onProductAddedListener);
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onProductAddedListener = this._onProductAdded.bind(this);
          this.delegateElement.on('change', '#cart-note', this._updateCartNote.bind(this));
  
          if (this.options['type'] !== 'page') {
            this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
            this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._updateItemQuantity.bind(this));
          } else {
            this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._reloadPageWithQuantity.bind(this));
          } // We have some listeners that are specific to the fact it's a drawer or the dedicated cart page
  
  
          if (this.options['drawer']) {
            this.delegateElement.on('click', '[data-action="toggle-cart-note"]', this._toggleCartNote.bind(this));
          }
  
          document.addEventListener('product:added', this._onProductAddedListener); // We attach a listener at page level which allows to re-render the cart
  
          this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false));
        }
      }, {
        key: "_updateCartNote",
        value: function _updateCartNote(event, target) {
          fetch("".concat(window.routes.cartUrl, "/update.js"), {
            body: JSON.stringify({
              note: target.value
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
  
            }
          });
        }
      }, {
        key: "_toggleCartNote",
        value: function _toggleCartNote() {
          var _this = this;
  
          var noteContainer = this.element.querySelector('.Cart__OffscreenNoteContainer'),
              cartNote = this.element.querySelector('#cart-note');
          this.element.classList.toggle('has-note-open');
          this.element.querySelector('.Cart__NoteButton').innerHTML = cartNote.value !== '' ? window.languages.cartEditNote : window.languages.cartAddNote;
          noteContainer.setAttribute('aria-hidden', noteContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
          this.isCartNoteOpen = noteContainer.getAttribute('aria-hidden') === 'false';
  
          if (this.element.classList.contains('has-note-open')) {
            var transitionEndListener = function transitionEndListener() {
              _this.element.querySelector('#cart-note').focus();
  
              noteContainer.removeEventListener('transitionend', transitionEndListener);
            };
  
            noteContainer.addEventListener('transitionend', transitionEndListener);
          }
        }
      }, {
        key: "_updateItemQuantity",
        value: function _updateItemQuantity(event, target) {
          var _this2 = this;
  
          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          var quantity = null,
              elementToAnimate = null;
  
          if (target.tagName === 'INPUT') {
            quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
          } else {
            quantity = parseInt(target.getAttribute('data-quantity'));
          } // If the quantity is 0, then we will animate the product with a removal effect
  
  
          if (quantity === 0) {
            elementToAnimate = target.closest('.CartItemWrapper');
          }
  
          fetch("".concat(window.routes.cartChangeUrl, ".js"), {
            body: JSON.stringify({
              line: target.getAttribute('data-line'),
              quantity: quantity
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
  
            }
          }).then(function (cart) {
            cart.json().then(function (content) {
              _this2.itemCount = content['item_count'];
  
              _this2._rerenderCart(elementToAnimate);
  
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
  
              //cart page reload
              if (window.location.href.indexOf("cart") > -1) {
                location.reload();
              }
             
            });
          });
          event.preventDefault();
        }
      }, {
        key: "_reloadPageWithQuantity",
        value: function _reloadPageWithQuantity(event, target) {
          window.location.href = "".concat(window.routes.cartChangeUrl, "?quantity=").concat(parseInt(target.value), "&line=").concat(target.getAttribute('data-line'));
        }
      }, {
        key: "_onProductAdded",
        value: function _onProductAdded(event) {
          var _this3 = this;
  
          this.itemCount += event.detail.quantity;
  
          this._rerenderCart().then(function () {
            _this3.sidebarDrawer.open();
          });
        }
      }, 
                                 {
        key: "_onDrawerClosed",
        value: function _onDrawerClosed() {
          if (this.isCartNoteOpen) {
            this._toggleCartNote();
          }
        }
        /**
         * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
         * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
         * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
         * all the time and hence having easier logic.
         */
  
      }, {
        key: "_rerenderCart",
        value: function _rerenderCart(elementToAnimate) {
          var _this4 = this;
  
          // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
          return fetch("".concat(window.routes.cartUrl, "?section_id=").concat(this.options['drawer'] && window.theme.pageType !== 'cart' ? 'mini-cart' : 'main-cart', "&timestamp=").concat(Date.now()), {
            credentials: 'same-origin',
            method: 'GET'
          }).then(function (content) {
            // If there is an element to animate, we animate it using a transition
            if (_this4.options['drawer'] && elementToAnimate) {
              var timelineLite = new TimelineLite({
                onComplete: function onComplete() {
                  content.text().then(function (html) {
                    _this4._replaceContent(html);
                  });
                }
              });
              timelineLite.to(elementToAnimate, 0.5, {
                height: 0,
                opacity: 0,
                ease: Cubic.easeOut
              }, 0);
  
              if (_this4.itemCount === 0) {
                timelineLite.to(_this4.element.querySelector('.Drawer__Footer'), 0.5, {
                  y: '100%',
                  transition: 'none',
                  ease: Cubic.easeInOut
                }, 0);
              }
            } else {
              content.text().then(function (html) {
                _this4._replaceContent(html);
              });
            }
          });
        }
      }, {
        key: "_replaceContent",
        value: function _replaceContent(html) {
          var _this5 = this;
  
          var tempElement = document.createElement('div');
          tempElement.innerHTML = html;
          var cartNodeParent = this.element.querySelector('.Cart').parentNode;
  
          if (this.options['drawer'] && window.theme.pageType !== 'cart') {
            var currentScrollPosition = this.element.querySelector('.Drawer__Main').scrollTop;
            cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
            this.element.querySelector('.Drawer__Main').scrollTop = currentScrollPosition;
          } else {
            // For dedicated page we replace the whole section if there is no more product
            if (this.itemCount === 0) {
              this.element.innerHTML = tempElement.querySelector('.shopify-section').firstElementChild.innerHTML;
            } else {
              //cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
             // this.element.querySelector('.PageHeader').innerHTML = tempElement.querySelector('.PageHeader').innerHTML;
            }
          } // We can also update the dot and the quantity
  
  
          var cartResult = JSON.parse(tempElement.querySelector('[data-section-type="cart"]').getAttribute('data-section-settings'));
          var cartDot = Dom.nodeListToArray(document.querySelectorAll('.Header__CartDot')),
              cartQuantity = Dom.nodeListToArray(document.querySelectorAll('.Header__CartCount'));
          this.itemCount = cartResult['itemCount'];
          var cartCountLabel = function (count) {
            var n = parseInt(count, 10) || 0;
            if (n === 1) return window.languages.openCartCountOne;
            return (window.languages.openCartCountOther || 'Open cart, COUNT items').replace('COUNT', String(n));
          };
          var syncCartControlLabel = function (el) {
            var control = el.closest('a, button');
            if (control && control.hasAttribute('aria-label')) {
              control.setAttribute('aria-label', cartCountLabel(_this5.itemCount));
            }
          };
          cartDot.forEach(function (item) {
            item.textContent = _this5.itemCount;
            item.setAttribute('aria-hidden', 'true');
            if (_this5.itemCount === 0) {
              item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
            } else {
              item.classList.add('is-visible');
            }
            syncCartControlLabel(item);
          });
          cartQuantity.forEach(function (item) {
            item.textContent = _this5.itemCount;
            item.setAttribute('aria-hidden', 'true');
            syncCartControlLabel(item);
          });
        }
      }]);
  
      return CartSection;
    }();
  
    var CollectionListSection = /*#__PURE__*/function () {
      function CollectionListSection(container) {
        _classCallCheck(this, CollectionListSection);
  
        this.element = container;
        var collectionListElement = this.element.querySelector('[data-flickity-config]');
  
        if (collectionListElement) {
          this.carousel = new Carousel(collectionListElement);
        }
      }
  
      _createClass(CollectionListSection, [{
        key: "onUnload",
        value: function onUnload() {
          if (this.carousel) {
            this.carousel.destroy();
          }
        }
      }, {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          if (this.carousel) {
            this.carousel.selectCell(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
          }
        }
      }, {
        key: "onBlockDeselect",
        value: function onBlockDeselect() {
          if (this.carousel) {
            this.carousel.unpausePlayer();
          }
        }
      }]);
  
      return CollectionListSection;
    }();
  
    /**
     * This class allows to automatically scrolls within a div when this div does not fit into the visible space
     */
    var OverflowScroller = /*#__PURE__*/function () {
      function OverflowScroller(element) {
        _classCallCheck(this, OverflowScroller);
  
        if (!element) {
          return;
        }
  
        this.element = element;
        this.lastKnownY = window.scrollY;
        this.currentTop = 0;
        this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top);
  
        this._attachListeners();
      }
  
      _createClass(OverflowScroller, [{
        key: "destroy",
        value: function destroy() {
          window.removeEventListener('scroll', this._checkPositionListener);
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._checkPositionListener = this._checkPosition.bind(this);
          window.addEventListener('scroll', this._checkPositionListener);
        }
      }, {
        key: "_checkPosition",
        value: function _checkPosition() {
          var _this = this;
  
          fastdom.measure(function () {
            var bounds = _this.element.getBoundingClientRect(),
                maxTop = bounds.top + window.scrollY - _this.element.offsetTop + _this.initialTopOffset,
                minTop = _this.element.clientHeight - window.innerHeight;
  
            if (window.scrollY < _this.lastKnownY) {
              _this.currentTop -= window.scrollY - _this.lastKnownY;
            } else {
              _this.currentTop += _this.lastKnownY - window.scrollY;
            }
  
            _this.currentTop = Math.min(Math.max(_this.currentTop, -minTop), maxTop, _this.initialTopOffset);
            _this.lastKnownY = window.scrollY;
          });
          fastdom.mutate(function () {
            _this.element.style.top = "".concat(_this.currentTop, "px");
          });
        }
      }]);
  
      return OverflowScroller;
    }();
  
    var CollectionSection = /*#__PURE__*/function () {
      function CollectionSection(element) {
        _classCallCheck(this, CollectionSection);
  
        this.element = element;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.toolbarElement = this.element.querySelector('.CollectionToolbar');
        this.collectionInnerElement = this.element.querySelector('.CollectionInner__Products');
        this.settings = JSON.parse(this.element.getAttribute('data-section-settings')); // Create the popover if available
  
        var sortPopoverElement = document.getElementById('collection-sort-popover');
        var sortActivator = this.element.querySelector('[data-sort-listbox]');

        if (!sortActivator && sortPopoverElement) {
          var sortActivatorCandidate = document.querySelector('[data-sort-popover="collection-sort-popover"]');

          if (sortActivatorCandidate && this.element.contains(sortActivatorCandidate)) {
            sortActivator = sortActivatorCandidate;
          }
        }

        if (sortPopoverElement && sortActivator) {
          var _this = this;

          this.sortActivator = sortActivator;
          this.sortPopover = new Popover(sortPopoverElement, {
            activator: sortActivator,
            suppressActivatorClick: true,
            onOpen: function () {
              if (_this.sortStatusEl) {
                _this.sortStatusEl.textContent = '';
              }

              // Move focus into the menu (retry — needed at zoom / mobile sheet timing)
              _this._scheduleSortMenuFocus();
            },
            onClose: function () {
              _this._onSortPopoverClosed();
            }
          });

          this._initSortListbox();
          this._syncSortActivatorA11y();

          if (!this._sortBreakpointListener) {
            this._sortBreakpointListener = this._syncSortActivatorA11y.bind(this);
            document.addEventListener('breakpoint:changed', this._sortBreakpointListener);
          }
        } // Create the filter drawer if available
  
  
        var filterDrawerElement = document.getElementById('collection-filter-drawer');
  
        if (filterDrawerElement) {
          this.filterDrawer = new Drawer(filterDrawerElement);
        } // Create scroller of sidebar
  
  
        if (this.settings['filterPosition'] === 'sidebar') {
          this.filterInnerSidebarScroller = new OverflowScroller(this.element.querySelector('.CollectionInner__Sidebar'));
        } // Setup parallax on image (if any)
  
  
        var collectionImageElement = this.element.querySelector('.PageHeader__ImageWrapper');
  
        if (collectionImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
          this.parallaxInstance = new Rellax('.PageHeader__ImageWrapper', {
            speed: -7,
            center: false,
            round: true
          });
        } // Setup product item color swatch
  
  
        new ProductItemColorSwatch(this.element.querySelector('.ProductList')); // Setup animation
  
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0
        });
        
  
        this._setupAnimation();
  
        this._attachListeners();

        this._renderSelectedFilterChips(this._collectCheckedFilters());
      }
  
      _createClass(CollectionSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off('click');
  
          if (this.sortPopover) {
            this.sortPopover.destroy();
          }

          this._destroySortListbox();

          if (this._sortBreakpointListener) {
            document.removeEventListener('breakpoint:changed', this._sortBreakpointListener);
            this._sortBreakpointListener = null;
          }
  
          if (this.filterDrawer) {
            this.filterDrawer.destroy();
          }
  
          if (this.filterInnerSidebarScroller) {
            this.filterInnerSidebarScroller.destroy();
          }
  
          if (this.parallaxInstance) {
            this.parallaxInstance.destroy();
          }
  
          if (window.theme.showElementStaggering) {
            this.intersectionObserver.disconnect();
            this.timeline.kill();
          }
        }
      }, {
        key: "_setupAnimation",
        value: function _setupAnimation() {
          var _this = this;
  
          var forceLoadFromTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  
          if (!window.theme.showElementStaggering) {
            return;
          } // If there is already an observer set up, we remove it first
  
  
          if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
          }
  
          if (forceLoadFromTop) {
            this.timeline.clear();
            this.timeline.staggerFromTo(this.element.querySelectorAll('.ProductList .ProductItem, .ArticleList .ArticleItem'), 0.25, {
              autoAlpha: 0,
              y: 25
            }, {
              autoAlpha: 1,
              y: 0
            }, 0.1);
          } else {
            this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this), {
              threshold: 0.3
            });
            Dom.nodeListToArray(this.element.querySelectorAll('.ProductList .ProductItem, .ArticleList .ArticleItem')).forEach(function (item) {
              _this.intersectionObserver.observe(item);
            });
          }
        }
      }, {
        key: "_reveal",
        value: function _reveal(results) {
          var _this2 = this;
  
          var toReveal = [];
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              // isIntersecting does not exist on Samsung Android browser
              toReveal.push(result.target);
  
              _this2.intersectionObserver.unobserve(result.target);
            }
          });
  
          if (toReveal.length === 0) {
            return;
          }
  
          this.timeline.staggerFromTo(toReveal, 0.35, {
            autoAlpha: 0,
            y: 25
          }, {
            autoAlpha: 1,
            y: 0
          }, 0.15);
        }
      }, {
        key: "_changeLayoutMode",
        value: function _changeLayoutMode(event, target) {
          var _this3 = this;
  
          var layoutType = target.getAttribute('data-grid-type'),
              newCount = parseInt(target.getAttribute('data-count')); // Otherwise we detect the mode, and change all classes
  
          var productList = this.collectionInnerElement.querySelector('.ProductList');
  
          if (productList) {
            var previousCount = parseInt(productList.getAttribute("data-".concat(layoutType, "-count")));
  
            if (previousCount === newCount) {
              return; // Nothing has changed so we just return to avoid reflow
            }
  
            productList.setAttribute("data-".concat(layoutType, "-count"), newCount);
            Dom.nodeListToArray(productList.querySelectorAll('.Grid__Cell')).forEach(function (item) {
              if (layoutType === 'mobile') {
                item.classList.remove("1/".concat(previousCount, "--phone")); // IE11 and lower does not support classList.replace
  
                item.classList.add("1/".concat(newCount, "--phone"));
              } else {
                var previousTabletCount = previousCount === 2 ? 2 : 3,
                    newTabletCount = newCount === 2 ? 2 : 3;
  
                if (_this3.settings['filterPosition'] === 'drawer') {
                  item.classList.remove("1/".concat(previousCount, "--lap-and-up"));
                  item.classList.add("1/".concat(newCount, "--lap-and-up"));
                } else {
                  item.classList.remove("1/".concat(previousCount, "--desk"));
                  item.classList.add("1/".concat(newCount, "--desk"));
                }
  
                item.classList.remove("1/".concat(previousTabletCount, "--tablet-and-up"));
                item.classList.add("1/".concat(newTabletCount, "--tablet-and-up"));
              }
  
              if (window.theme.showElementStaggering) {
                item.firstElementChild.style.visibility = 'hidden'; // Make it as hidden so we can re-trigger the animation
              }
            }); // Force lazy sizes to recalculate item sizes
  
            lazySizes.autoSizer.checkElems();
          }
  
          target.classList.add('is-active');
          Dom.getSiblings(target)[0].classList.remove('is-active');
  
          this._setupAnimation(); // In order to prevent reflow and provide better user experience, we save into cart attributes (those are removed before the checkout
          // is submitted) the user choices so they are preserved on page reload, without the need to use JavaScript
  
  
          fetch("".concat(window.routes.cartUrl, "/update.js"), {
            body: JSON.stringify({
              attributes: _defineProperty({}, "collection_".concat(layoutType, "_items_per_row"), newCount)
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
  
            }
          });
        }
      }, {
        key: "_syncSortActivatorA11y",
        value: function _syncSortActivatorA11y() {
          if (!this.sortActivator) {
            return;
          }

          var sortPopoverEl = document.getElementById('collection-sort-popover');

          // Menu Button pattern (desktop + mobile sheet share the same menu semantics)
          this.sortActivator.removeAttribute('aria-label');
          this.sortActivator.setAttribute('aria-haspopup', 'menu');
          this.sortActivator.setAttribute('aria-controls', 'collection-sort-listbox');

          var sortListbox = document.getElementById('collection-sort-listbox');
          var isPocket = !Responsive.matchesBreakpoint('lap-and-up');

          if (sortListbox) {
            // Mobile: label menu with visible Sort heading; desktop: label with trigger
            sortListbox.setAttribute('aria-labelledby', isPocket ? 'collection-sort-popover-title' : 'collection-sort-button');
          }

          if (sortPopoverEl) {
            sortPopoverEl.removeAttribute('role');
            sortPopoverEl.removeAttribute('aria-modal');
          }
        }
      }, {
        key: "_scheduleSortMenuFocus",
        value: function _scheduleSortMenuFocus() {
          var _thisSortFocus = this;

          if (this._sortFocusTimers) {
            this._sortFocusTimers.forEach(function (id) {
              window.clearTimeout(id);
            });
          }

          this._sortFocusTimers = [];

          var attempt = function attempt() {
            _thisSortFocus._handleSortPopoverOpened();
          };

          // Immediate + delayed retries (sheet animation / 200% zoom)
          attempt();
          [50, 150, 300].forEach(function (delay) {
            _thisSortFocus._sortFocusTimers.push(window.setTimeout(attempt, delay));
          });
        }
      }, {
        key: "_handleSortPopoverOpened",
        value: function _handleSortPopoverOpened() {
          if (!this.sortPopover || !this.sortPopover.isOpen) {
            return;
          }

          var isPocket = !Responsive.matchesBreakpoint('lap-and-up');
          var options = this._getSortOptions();

          if (this.sortPopover && typeof this.sortPopover._position === 'function' && !isPocket) {
            this.sortPopover._position();
          }

          // Mobile sheet: focus Close first (then heading in DOM, then options)
          if (isPocket) {
            if (this.sortCloseButton) {
              this.sortCloseButton.setAttribute('tabindex', '0');
              this.sortCloseButton.focus();
            }

            for (var i = 0; i < options.length; i++) {
              options[i].setAttribute('tabindex', '-1');
            }

            return;
          }

          if (!options.length) {
            return;
          }

          var focusTarget = this._sortOpenFocusTarget;
          var target = null;

          if (focusTarget === 'last') {
            target = options[options.length - 1];
          } else if (focusTarget === 'first') {
            target = options[0];
          } else {
            target = this._getSelectedSortOption() || options[0];
          }

          if (target) {
            this._focusSortOption(target);

            if (!this.sortListbox.contains(document.activeElement)) {
              target.focus({
                preventScroll: false
              });
            }
          }
        }
      }, {
        key: "_onSortPopoverClosed",
        value: function _onSortPopoverClosed() {
          this._sortOpenFocusTarget = null;

          if (this._sortFocusTimers) {
            this._sortFocusTimers.forEach(function (id) {
              window.clearTimeout(id);
            });
            this._sortFocusTimers = [];
          }

          if (this.sortCloseButton) {
            this.sortCloseButton.setAttribute('tabindex', '-1');
          }

          var options = this._getSortOptions();

          for (var i = 0; i < options.length; i++) {
            options[i].setAttribute('tabindex', '-1');
          }
        }
      }, {
        key: "_onSortActivatorClick",
        value: function _onSortActivatorClick(event) {
          if (!this.sortPopover) {
            return;
          }

          if (this._sortIgnoreActivatorClick) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }

          event.preventDefault();

          if (!this.sortPopover.isOpen) {
            this._sortOpenFocusTarget = 'first';
          }

          this.sortPopover.toggle();
        }
      }, {
        key: "_initSortListbox",
        value: function _initSortListbox() {
          var _thisSort = this;

          if (!this.sortActivator) {
            this.sortActivator = this.element.querySelector('[data-sort-listbox]');
          }

          this.sortListbox = document.getElementById('collection-sort-listbox');
          this.sortPopoverContent = document.querySelector('#collection-sort-popover .Popover__Content');
          this.sortPopoverEl = document.getElementById('collection-sort-popover');

          if (!this.sortActivator || !this.sortListbox) {
            return;
          }

          this.sortStatusEl = document.getElementById('CollectionSortStatus');
          this._sortOptionFocusedTemplate = this.sortListbox.getAttribute('data-msg-focused') || '__OPTION__, __POSITION__ of __TOTAL__';
          this._sortOptionSelectedTemplate = this.sortListbox.getAttribute('data-msg-selected') || '__OPTION__ selected, __POSITION__ of __TOTAL__';

          this._sortListboxClickHandler = function (event) {
            var option = event.target.closest('[role="menuitemradio"]');

            if (option && _thisSort.sortListbox.contains(option)) {
              _thisSort._selectSortOption(option);
            }
          };

          this._sortActivatorKeyHandler = function (event) {
            _thisSort._onSortActivatorKeydown(event);
          };

          this._sortListboxKeyHandler = function (event) {
            _thisSort._onSortListboxKeydown(event);
          };

          this.sortCloseButton = document.querySelector('#collection-sort-popover .Popover__Close');

          this._sortCloseKeyHandler = function (event) {
            if (Responsive.matchesBreakpoint('lap-and-up') || !_thisSort.sortPopover || !_thisSort.sortPopover.isOpen) {
              return;
            }

            var key = event.key;
            var options = _thisSort._getSortOptions();

            if ((key === 'ArrowDown' || key === 'Tab' && !event.shiftKey) && options.length) {
              event.preventDefault();
              event.stopPropagation();
              _thisSort._focusSortOption(options[0]);
            } else if (key === 'Escape') {
              event.preventDefault();
              _thisSort.sortPopover.close({
                restoreFocus: true
              });
            }
          };

          this.sortListbox.addEventListener('click', this._sortListboxClickHandler);
          this.sortActivator.addEventListener('keydown', this._sortActivatorKeyHandler);
          this.sortListbox.addEventListener('keydown', this._sortListboxKeyHandler);

          if (this.sortCloseButton) {
            this.sortCloseButton.addEventListener('keydown', this._sortCloseKeyHandler);
          }
        }
      }, {
        key: "_destroySortListbox",
        value: function _destroySortListbox() {
          if (this.sortListbox && this._sortListboxClickHandler) {
            this.sortListbox.removeEventListener('click', this._sortListboxClickHandler);
          }

          if (this.sortActivator && this._sortActivatorKeyHandler) {
            this.sortActivator.removeEventListener('keydown', this._sortActivatorKeyHandler);
          }

          if (this.sortListbox && this._sortListboxKeyHandler) {
            this.sortListbox.removeEventListener('keydown', this._sortListboxKeyHandler);
          }

          if (this.sortCloseButton && this._sortCloseKeyHandler) {
            this.sortCloseButton.removeEventListener('keydown', this._sortCloseKeyHandler);
          }
        }
      }, {
        key: "_getSortOptions",
        value: function _getSortOptions() {
          return this.sortListbox ? this.sortListbox.querySelectorAll('[role="menuitemradio"]') : [];
        }
      }, {
        key: "_getSelectedSortOption",
        value: function _getSelectedSortOption() {
          var options = this._getSortOptions();

          for (var i = 0; i < options.length; i++) {
            if (options[i].getAttribute('aria-checked') === 'true') {
              return options[i];
            }
          }

          return null;
        }
      }, {
        key: "_getFocusedSortOption",
        value: function _getFocusedSortOption() {
          var options = this._getSortOptions();
          var active = document.activeElement;

          if (active && active.getAttribute('role') === 'menuitemradio' && this.sortListbox && this.sortListbox.contains(active)) {
            return active;
          }

          for (var i = 0; i < options.length; i++) {
            if (options[i].getAttribute('tabindex') === '0') {
              return options[i];
            }
          }

          return null;
        }
      }, {
        key: "_focusSortOption",
        value: function _focusSortOption(option) {
          if (!option) {
            return;
          }

          var options = this._getSortOptions();

          options.forEach(function (item) {
            item.setAttribute('tabindex', item === option ? '0' : '-1');
          });

          option.focus();
        }
      }, {
        key: "_announceSortOption",
        value: function _announceSortOption(option, selected) {
          if (!this.sortStatusEl || !option) {
            return;
          }

          // Focused menuitemradio is announced by the screen reader from DOM focus
          if (!selected) {
            this.sortStatusEl.textContent = '';
            return;
          }

          var options = this._getSortOptions();
          var index = Array.prototype.indexOf.call(options, option);
          var label = option.getAttribute('data-label') || (option.textContent || '').replace(/\s+/g, ' ').trim();
          var position = index + 1;
          var total = options.length;
          var template = this._sortOptionSelectedTemplate;

          this.sortStatusEl.textContent = template.replace(/__OPTION__/g, label).replace(/__POSITION__/g, String(position)).replace(/__TOTAL__/g, String(total));
        }
      }, {
        key: "_onSortActivatorKeydown",
        value: function _onSortActivatorKeydown(event) {
          var _thisSort = this;
          var key = event.key;

          if (!this.sortPopover) {
            return;
          }

          if (!this.sortPopover.isOpen && (key === 'ArrowDown' || key === 'Enter' || key === ' ')) {
            event.preventDefault();
            event.stopPropagation();
            this._sortIgnoreActivatorClick = true;
            this._sortOpenFocusTarget = 'first';
            this.sortPopover.open();
            // Keep ignoring the synthetic click after Enter/Space (click fires after keyup)
            window.setTimeout(function () {
              _thisSort._sortIgnoreActivatorClick = false;
            }, 400);
            return;
          }

          if (!this.sortPopover.isOpen && key === 'ArrowUp') {
            event.preventDefault();
            event.stopPropagation();
            this._sortIgnoreActivatorClick = true;
            this._sortOpenFocusTarget = 'last';
            this.sortPopover.open();
            window.setTimeout(function () {
              _thisSort._sortIgnoreActivatorClick = false;
            }, 400);
          }
        }
      }, {
        key: "_onSortListboxKeydown",
        value: function _onSortListboxKeydown(event) {
          if (!this.sortPopover || !this.sortPopover.isOpen) {
            return;
          }

          var key = event.key;
          var options = this._getSortOptions();

          if (!options.length) {
            return;
          }

          var current = event.target.closest('[role="menuitemradio"]') || this._getFocusedSortOption() || options[0];
          var index = Array.prototype.indexOf.call(options, current);

          if (key === 'ArrowDown') {
            event.preventDefault();
            var nextDown = index === options.length - 1 ? 0 : index + 1;
            this._focusSortOption(options[nextDown]);
          } else if (key === 'ArrowUp') {
            event.preventDefault();

            if (index <= 0 && !Responsive.matchesBreakpoint('lap-and-up') && this.sortCloseButton) {
              this.sortCloseButton.focus();
            } else {
              var nextUp = index <= 0 ? options.length - 1 : index - 1;
              this._focusSortOption(options[nextUp]);
            }
          } else if (key === 'Home') {
            event.preventDefault();
            this._focusSortOption(options[0]);
          } else if (key === 'End') {
            event.preventDefault();
            this._focusSortOption(options[options.length - 1]);
          } else if (key === 'Tab') {
            var isPocket = !Responsive.matchesBreakpoint('lap-and-up');

            // Mobile: Shift+Tab from first option returns to Close
            if (isPocket && event.shiftKey && index <= 0 && this.sortCloseButton) {
              event.preventDefault();
              this.sortCloseButton.focus();
              return;
            }

            // Menu Button: Tab closes menu; focus continues to next/previous page control
            event.preventDefault();
            this.sortPopover.close({
              restoreFocus: false
            });

            if (this.sortActivator) {
              var focusables = Array.prototype.slice.call(document.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (el) {
                return el.offsetParent !== null && !el.closest('[inert]') && el.getAttribute('aria-hidden') !== 'true';
              });
              var activatorIndex = focusables.indexOf(this.sortActivator);

              if (activatorIndex !== -1) {
                var targetIndex = event.shiftKey ? activatorIndex - 1 : activatorIndex + 1;

                if (targetIndex >= 0 && targetIndex < focusables.length) {
                  focusables[targetIndex].focus();
                } else {
                  this.sortActivator.focus();
                }
              }
            }
          } else if (key === 'Enter' || key === ' ') {
            event.preventDefault();
            var option = event.target.closest('[role="menuitemradio"]');

            if (option) {
              this._selectSortOption(option);
            }
          } else if (key === 'Escape') {
            event.preventDefault();
            this.sortPopover.close({
              restoreFocus: true
            });
          } else if (key.length === 1 && /[a-z0-9]/i.test(key)) {
            // Typeahead: move to next item starting with typed character
            var char = key.toLowerCase();
            var start = index + 1;

            for (var step = 0; step < options.length; step++) {
              var candidate = options[(start + step) % options.length];
              var label = (candidate.getAttribute('data-label') || candidate.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

              if (label.charAt(0) === char) {
                event.preventDefault();
                this._focusSortOption(candidate);
                break;
              }
            }
          }
        }
      }, {
        key: "_selectSortOption",
        value: function _selectSortOption(option) {
          if (!option) {
            return;
          }

          var value = option.getAttribute('data-value');
          var wasSelected = option.getAttribute('aria-checked') === 'true';
          var options = this._getSortOptions();

          options.forEach(function (item) {
            var isActive = item === option;
            item.setAttribute('aria-checked', isActive ? 'true' : 'false');
            item.classList.toggle('is-selected', isActive);
          });

          this._announceSortOption(option, true);

          if (!wasSelected) {
            this._sortByChanged(value, option);
          } else if (this.sortPopover) {
            this.sortPopover.close({
              restoreFocus: true
            });
          }
        }
      }, {
        key: "_syncSortToolbar",
        value: function _syncSortToolbar(tempElement) {
          if (!tempElement) {
            return;
          }

          var newSelected = tempElement.querySelector('#collection-sort-listbox [role="menuitemradio"][aria-checked="true"]');
          var liveListbox = document.getElementById('collection-sort-listbox');

          if (!newSelected || !liveListbox) {
            return;
          }

          var selectedValue = newSelected.getAttribute('data-value');
          liveListbox.querySelectorAll('[role="menuitemradio"]').forEach(function (option) {
            var isActive = option.getAttribute('data-value') === selectedValue;
            option.setAttribute('aria-checked', isActive ? 'true' : 'false');
            option.classList.toggle('is-selected', isActive);
          });
        }
      }, {
        key: "_sortByChanged",
        value: function _sortByChanged(sortBy, selectedOption) {
          var sortLabel = '';

          if (selectedOption) {
            sortLabel = selectedOption.getAttribute('data-label') || (selectedOption.textContent || '').replace(/\s+/g, ' ').trim();
          }

          this._pendingSortAnnounce = {
            label: sortLabel || sortBy
          };

          if (this.sortStatusEl) {
            this.sortStatusEl.textContent = '';
          }

          if (this.sortPopover) {
            this.sortPopover.close({
              restoreFocus: true
            });
          }

          var currentUrl = new URL(location.href);
          currentUrl.searchParams.set('sort_by', sortBy);
          currentUrl.searchParams.delete('page');

          setTimeout(function(){
            function initializeEndlessScroll() {
              console.log('Initializing Endless Scroll...'); 
              if (document.querySelector('#magepow-Loop') && document.querySelector('#magepow-Pagination')) {
                var endlessScroll = new Ajaxinate({
                  container: '#magepow-Loop',
                  pagination: '#magepow-Pagination',
                });
              }
            }
          
            initializeEndlessScroll();
          },1000)
  
          this._reloadProducts(currentUrl.toString());
        }
      }, {
        key: "_onFiltersCleared",
        value: function _onFiltersCleared(event) {
          this._pendingFilterFocus = {
            id: null,
            name: null,
            value: null,
            action: 'clear-filters',
            label: 'Filters cleared'
          };
          this._reloadProducts(event.target.getAttribute('data-url'));
          setTimeout(function(){
            function initializeEndlessScroll() {
              console.log('Initializing Endless Scroll...'); 
              if (document.querySelector('#magepow-Loop') && document.querySelector('#magepow-Pagination')) {
                var endlessScroll = new Ajaxinate({
                  container: '#magepow-Loop',
                  pagination: '#magepow-Pagination',
                });
              }
            }
          
            initializeEndlessScroll();
          },1000)
          
          const mobileFilterForm = document.querySelector('#collection-filters-drawer-form');
          const collectionfilterselected = document.querySelector('.collectionfilterselected');

          if(collectionfilterselected){
            collectionfilterselected.innerHTML = '';
          }

          if(mobileFilterForm){
            const inputs = mobileFilterForm.querySelectorAll('input');
            inputs.forEach(input => {
              input.checked = false;
            });
          }

        }
      }, {
        key: "_onFilterChanged",
        value: function _onFilterChanged(event) {
          // Remember the control that changed — more reliable than activeElement after async DOM work
          var changed = event.target;
          if (changed && changed.name && changed.name.indexOf('filter.') === 0) {
            this._pendingFilterFocus = {
              id: changed.id || null,
              name: changed.getAttribute('name'),
              value: changed.value,
              action: null,
              label: ''
            };
            var labelEl = changed.id ? document.querySelector('label[for="' + changed.id + '"]') : null;
            if (labelEl) {
              this._pendingFilterFocus.label = (labelEl.getAttribute('data-tooltip') || labelEl.textContent || '').replace(/\s+/g, ' ').trim();
            }
          }

          var formData = new FormData(event.target.closest('form'));
          setTimeout(function(){
            function initializeEndlessScroll() {
              console.log('Initializing Endless Scroll...'); 
              if (document.querySelector('#magepow-Loop') && document.querySelector('#magepow-Pagination')) {
                var endlessScroll = new Ajaxinate({
                  container: '#magepow-Loop',
                  pagination: '#magepow-Pagination',
                });
              }
            }
          
            initializeEndlessScroll();
          },1000)
          
          if(window.innerWidth > 1007){
            var searchParamsAsString = new URLSearchParams(formData).toString();
            this._reloadProducts("".concat(window.location.pathname, "?").concat(searchParamsAsString));
          } else {
            var applyBtn = document.querySelector('#collection-filter-drawer .Drawer__Footer .ButtonGroup button');
            if (applyBtn) {
              applyBtn.addEventListener('click', function () {
                var searchParamsAsString = new URLSearchParams(formData).toString();
                this._reloadProducts("".concat(window.location.pathname, "?").concat(searchParamsAsString));
              }.bind(this), { once: true });
            }
          }
          var checkedvalue = new Array();
          
          
          document.querySelectorAll('#collection-filters-sidebar-form input[type=checkbox]:checked').forEach(function(checkbox){
            checkedvalue.push({
              option: checkbox.getAttribute('name'), 
              value:  checkbox.value,
              handleat:  checkbox.getAttribute('id'),
              splitvalue: checkbox.getAttribute('data-splitvalue'),
              banner: checkbox.getAttribute('image-data')
          })
          });

          if (window.location.href.indexOf("collections/all") > -1) {
          var checkOptionval = checkedvalue.map(item => {
            return item.option.replaceAll('.','-');
          });
          var checkOptionname = checkedvalue.map(item_n => {
            return item_n.value;
          });
          var checkOptionimg = checkedvalue.map(item_b => {
            return item_b.banner;
          });
          
          var page_head = document.querySelector('.SectionHeader__Heading');
          var def_head = page_head ? page_head.getAttribute('data-head') : '';
          // const filter_class = checkOptionval.replaceAll('.','-');
          if(page_head) {
          if(checkOptionval[0] == 'filter-v-m-filter-polarized' && checkedvalue.length > 1 || checkOptionval[0] == 'filter-v-m-filter-stylename' && checkedvalue.length > 1){
              page_head.innerHTML = def_head;
          } else {
             if(checkOptionval[0] == 'filter-v-m-filter-polarized'){
              if(checkOptionname[0] == 'Non-Polarized') {
                page_head.innerHTML = 'NON-POLARIZED SUNGLASSES';
              } else if (checkOptionname[0] == 'Polarized'){
                page_head.innerHTML = 'POLARIZED SUNGLASSES';
              }
          } else {
            page_head.innerHTML = def_head;
          }
          }
          }

          if(checkOptionval[0] == 'filter-v-m-filter-lens' && checkOptionval[1] == 'filter-v-m-filter-polarized'){
            // page_head.html(def_head);
            document.querySelectorAll('.PageHeader').forEach(function (el) {
              el.style.background = '';
            });
          }
           }
                
          this._renderSelectedFilterChips(this._collectCheckedFilters());
        }
      }, {
        key: "_collectCheckedFilters",
        value: function _collectCheckedFilters() {
          var checkedvalue = [];
          var form = document.getElementById('collection-filters-sidebar-form');
          if (!form) {
            return checkedvalue;
          }
          form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
            checkedvalue.push({
              option: input.getAttribute('name'),
              value: input.value,
              handleat: input.id,
              splitvalue: input.getAttribute('data-splitvalue'),
              banner: input.getAttribute('image-data'),
              category: CollectionSection.getFilterCategoryLabel(input)
            });
          });
          return checkedvalue;
        }
      }, {
        key: "_renderSelectedFilterChips",
        value: function _renderSelectedFilterChips(checkedvalue) {
          CollectionSection.renderSelectedFilterChips(checkedvalue);
        }
      }, {
        key: "_onSelectedFilterRemove",
        value: function _onSelectedFilterRemove(event) {
          var btn = event.target.closest('[data-action="remove-filter"]');
          if (!btn) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          var name = btn.getAttribute('data-name');
          var value = btn.getAttribute('data-value');
          var label = btn.getAttribute('data-label') || value || '';

          if (!name) {
            return;
          }

          var inputs = document.querySelectorAll('#collection-filters-sidebar-form [name="' + name.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"], #collection-filters-drawer-form [name="' + name.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]');
          for (var i = 0; i < inputs.length; i++) {
            if (String(inputs[i].value) === String(value)) {
              inputs[i].checked = false;
            }
          }

          this._renderSelectedFilterChips(this._collectCheckedFilters());

          this._pendingFilterFocus = {
            id: null,
            name: null,
            value: null,
            action: 'after-remove-filter',
            label: label ? label + ' filter removed' : 'Filter removed'
          };
          this._restoreFilterFocus(this._pendingFilterFocus);

          var form = document.querySelector('#collection-filters-sidebar-form') || document.querySelector('#collection-filters-drawer-form');
          if (!form) {
            return;
          }

          var formData = new FormData(form);
          var searchParamsAsString = new URLSearchParams(formData).toString();
          this._reloadProducts(''.concat(window.location.pathname, '?').concat(searchParamsAsString));
        }
      }, {
        key: "_reloadProducts",
        value: function _reloadProducts(url) {
          var _this4 = this;
          if (this.abortController) {
            this.abortController.abort();
          }  
          document.dispatchEvent(new CustomEvent('theme:loading:start'));
  
          if (history.replaceState) {
            window.history.pushState({
              path: url
            }, '', url);
          }
  
          var currentUrl = new URL(window.location);
          currentUrl.searchParams.set('section_id', this.settings['sectionId']);
  
          try {
            this.abortController = new AbortController();
            fetch(currentUrl.toString(), {
              signal: this.abortController.signal
            }).then(function (response) {
              response.text().then(function (content) {
                var tempElement = document.createElement('div');
                tempElement.innerHTML = content;

                var focusRestore = _this4._pendingFilterFocus || _this4._captureFilterFocus();

                var productsEl = tempElement.querySelector('.CollectionInner__Products');
                if (productsEl && _this4.collectionInnerElement) {
                  _this4.collectionInnerElement.innerHTML = productsEl.innerHTML;
                }

                var toolbarFilter = tempElement.querySelector('.CollectionToolbar__Item--filter');
  
                if (toolbarFilter) {
                  var newToolbarFilter = _this4.element.querySelector('.CollectionToolbar__Item--filter');
                  if (newToolbarFilter) {
                    newToolbarFilter.innerHTML = toolbarFilter.innerHTML;
                    newToolbarFilter.className = toolbarFilter.className;
                  }
                }

                // Do NOT replace sidebar/drawer filter markup — that destroys the focused
                // checkbox and drops keyboard/SR focus to "web content". Sync clear button only.
                _this4._syncFilterClearButton(tempElement);
                _this4._syncSortToolbar(tempElement);

                _this4._restoreFilterFocus(focusRestore);

                if (_this4._pendingSortAnnounce) {
                  _this4._announceSortResultsStatus(tempElement);
                } else {
                  _this4._announceFilterStatus(tempElement, focusRestore);
                }

                // Re-assert focus after animation/third-party scripts settle
                window.setTimeout(function () {
                  _this4._restoreFilterFocus(focusRestore);
                }, 50);
                window.setTimeout(function () {
                  _this4._restoreFilterFocus(focusRestore);
                }, 300);

                document.dispatchEvent(new CustomEvent('collection:reloaded'));
  
                document.dispatchEvent(new CustomEvent('theme:loading:end'));

                // Re-reveal mobile inset grid after AJAX filter (inline snippet script does not re-run)
                if (typeof window.applyInsetMobileOrder === 'function') {
                  window.applyInsetMobileOrder();
                }
  
                _this4._setupAnimation(true);

              });
            });
          } catch (exception) {}
        }
      }, {
        key: "_syncFilterClearButton",
        value: function _syncFilterClearButton(tempElement) {
          var forms = ['#collection-filters-sidebar-form', '#collection-filters-drawer-form'];
          forms.forEach(function (selector) {
            var liveForm = document.querySelector(selector);
            var newForm = tempElement.querySelector(selector);
            if (!liveForm || !newForm) {
              return;
            }

            var liveClear = liveForm.querySelector('[data-action="clear-filters"]');
            var newClear = newForm.querySelector('[data-action="clear-filters"]');

            if (newClear && !liveClear) {
              liveForm.appendChild(newClear.cloneNode(true));
            } else if (!newClear && liveClear) {
              liveClear.remove();
            } else if (newClear && liveClear) {
              liveClear.setAttribute('data-url', newClear.getAttribute('data-url'));
              liveClear.textContent = newClear.textContent;
            }
          });
        }
      }, {
        key: "_captureFilterFocus",
        value: function _captureFilterFocus() {
          var active = document.activeElement;
          if (!active || !this.element.contains(active)) {
            return null;
          }

          return {
            id: active.id || null,
            name: active.getAttribute('name'),
            value: active.value,
            action: active.getAttribute('data-action'),
            label: ''
          };
        }
      }, {
        key: "_restoreFilterFocus",
        value: function _restoreFilterFocus(focusRestore) {
          if (!focusRestore) {
            return;
          }

          var el = null;

          // After removing an applied-filter chip: last remaining chip, else first filter title
          if (focusRestore.action === 'after-remove-filter') {
            var chips = document.querySelectorAll('.collectionfilterselected [data-action="remove-filter"]');
            if (chips.length) {
              el = chips[chips.length - 1];
            } else {
              el = document.querySelector('#collection-filters-sidebar-form .Collapsible__FilterTitle') || document.querySelector('#collection-filters-sidebar-form [data-action="toggle-collapsible"]') || document.querySelector('#collection-filters-drawer-form [data-action="toggle-collapsible"]') || this.element.querySelector('#collection-filters-sidebar-form .Collapsible__Button') || this.element.querySelector('[name^="filter."]');
            }
          }

          if (!el && focusRestore.id) {
            el = document.getElementById(focusRestore.id);
          }

          if (!el && focusRestore.name) {
            var escapedName = focusRestore.name.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
            var inputs = this.element.querySelectorAll('[name="' + escapedName + '"]');
            for (var i = 0; i < inputs.length; i++) {
              if (String(inputs[i].value) === String(focusRestore.value)) {
                el = inputs[i];
                break;
              }
            }
          }

          if (!el && focusRestore.action === 'clear-filters') {
            el = this.element.querySelector('[data-action="clear-filters"]') || this.element.querySelector('#collection-filters-sidebar-form [name^="filter."]');
          }

          if (el && typeof el.focus === 'function') {
            try {
              el.focus({
                preventScroll: true
              });
            } catch (e) {
              el.focus();
            }
          }
        }
      }, {
        key: "_announceFilterStatus",
        value: function _announceFilterStatus(tempElement, focusRestore) {
          var status = document.getElementById('CollectionFilterStatus') || this.element.querySelector('[data-collection-filter-status]');
          if (!status) {
            return;
          }

          // Prefer a body-level region so product-grid swaps never interrupt it
          if (status.parentElement !== document.body) {
            document.body.appendChild(status);
          }

          var countEl = tempElement && tempElement.querySelector('[data-collection-products-count]');
          var count = countEl ? parseInt(countEl.getAttribute('data-collection-products-count'), 10) : NaN;

          if (isNaN(count)) {
            count = this.collectionInnerElement.querySelectorAll('.ProductItem').length;
          }

          var liveCountEl = this.collectionInnerElement.querySelector('[data-collection-products-count]');
          if (liveCountEl) {
            liveCountEl.setAttribute('data-collection-products-count', String(count));
          } else if (countEl) {
            this.collectionInnerElement.insertAdjacentHTML('afterbegin', countEl.outerHTML);
          }

          var hasFilters = false;
          try {
            var params = new URLSearchParams(window.location.search);
            params.forEach(function (_value, key) {
              if (key.indexOf('filter.') === 0) {
                hasFilters = true;
              }
            });
          } catch (e) {}

          if (!hasFilters) {
            hasFilters = this.element.querySelectorAll('[name^="filter."]:checked').length > 0;
          }

          var template;
          if (count === 0 && hasFilters) {
            template = status.getAttribute('data-msg-none') || 'Filters applied. No products found.';
          } else if (hasFilters) {
            template = status.getAttribute('data-msg-applied') || 'Filters applied. __COUNT__ products found.';
          } else {
            template = status.getAttribute('data-msg-results') || '__COUNT__ products found.';
          }

          var message = template.replace(/__COUNT__/g, String(count)).replace(/\{\{\s*count\s*\}\}/gi, String(count));
          if (focusRestore && focusRestore.label) {
            message = focusRestore.label + '. ' + message;
          }

          if (this._filterStatusAnnounceTimer) {
            window.clearTimeout(this._filterStatusAnnounceTimer);
          }

          // Replace the live-region node so NVDA/VO always treat it as a fresh update
          var parent = status.parentNode;
          var next = status.cloneNode(false);
          next.textContent = '';
          parent.replaceChild(next, status);
          status = next;

          this._filterStatusAnnounceTimer = window.setTimeout(function () {
            status.textContent = message;
          }, 100);
        }
      }, {
        key: "_announceSortResultsStatus",
        value: function _announceSortResultsStatus(tempElement) {
          var pending = this._pendingSortAnnounce;
          this._pendingSortAnnounce = null;

          if (!pending || !pending.label) {
            return;
          }

          var status = document.getElementById('CollectionSortStatus') || document.getElementById('CollectionFilterStatus');

          if (!status) {
            return;
          }

          if (status.parentElement !== document.body) {
            document.body.appendChild(status);
          }

          var countEl = tempElement && tempElement.querySelector('[data-collection-products-count]');
          var count = countEl ? parseInt(countEl.getAttribute('data-collection-products-count'), 10) : NaN;

          if (isNaN(count)) {
            count = this.collectionInnerElement ? this.collectionInnerElement.querySelectorAll('.ProductItem').length : 0;
          }

          var hasFilters = false;

          try {
            var params = new URLSearchParams(window.location.search);
            params.forEach(function (_value, key) {
              if (key.indexOf('filter.') === 0) {
                hasFilters = true;
              }
            });
          } catch (e) {}

          if (!hasFilters) {
            hasFilters = this.element.querySelectorAll('[name^="filter."]:checked').length > 0;
          }

          var template = hasFilters
            ? status.getAttribute('data-msg-sorted-with-filters') || 'Filters applied. Products sorted by __OPTION__. __COUNT__ products found.'
            : status.getAttribute('data-msg-sorted') || 'Products sorted by __OPTION__. __COUNT__ products found.';

          // Filter status region may not have sort templates — fall back to Sort status attrs / defaults
          if (status.id === 'CollectionFilterStatus') {
            var sortStatus = document.getElementById('CollectionSortStatus');
            if (sortStatus) {
              template = hasFilters
                ? sortStatus.getAttribute('data-msg-sorted-with-filters') || template
                : sortStatus.getAttribute('data-msg-sorted') || template;
              status = sortStatus;
              if (status.parentElement !== document.body) {
                document.body.appendChild(status);
              }
            }
          }

          var message = template.replace(/__OPTION__/g, pending.label).replace(/__COUNT__/g, String(count));

          if (this._sortStatusAnnounceTimer) {
            window.clearTimeout(this._sortStatusAnnounceTimer);
          }

          var parent = status.parentNode;
          var next = status.cloneNode(false);
          next.textContent = '';
          parent.replaceChild(next, status);
          status = next;

          // Delay slightly after filter status so both aren't spoken over each other;
          // sort is the intentional announcement for this action.
          this._sortStatusAnnounceTimer = window.setTimeout(function () {
            status.textContent = message;
          }, 150);
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._changeLayoutModeListener = this._changeLayoutMode.bind(this);
          this.delegateElement.on('click', '[data-action="change-layout-mode"]', this._changeLayoutModeListener);
          this.delegateElement.on('click', '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
          this.delegateElement.on('click', '[data-action="remove-filter"]', this._onSelectedFilterRemove.bind(this));
          this.delegateElement.on('click', '[data-sort-listbox]', this._onSortActivatorClick.bind(this));
          this.delegateElement.on('change', '[name^="filter."]', this._onFilterChanged.bind(this));
          window.addEventListener('popstate', function (event) {
            if (event.state.path) {
              window.location.href = event.state.path;
            }
          });
        }
      }]);

      CollectionSection.getFilterCategoryLabel = function getFilterCategoryLabel(input) {
        if (!input || !input.closest) {
          return '';
        }

        var group = input.closest('[role="group"][aria-labelledby]');
        if (group) {
          var labelledBy = group.getAttribute('aria-labelledby');
          if (labelledBy) {
            var labelEl = document.getElementById(labelledBy);
            if (labelEl) {
              return (labelEl.textContent || '').replace(/\s+/g, ' ').replace(/_NS/g, '').trim();
            }
          }
        }

        var collapsible = input.closest('.Collapsible');
        if (collapsible) {
          var titleEl = collapsible.querySelector('.Collapsible__FilterTitle')
            || collapsible.querySelector('.BooleanFilter label')
            || collapsible.querySelector('.Collapsible__Button');
          if (titleEl) {
            var clone = titleEl.cloneNode(true);
            Array.prototype.forEach.call(clone.querySelectorAll('.Collapsible__Plus, .u-visually-hidden'), function (node) {
              node.parentNode.removeChild(node);
            });
            return (clone.textContent || '').replace(/\s+/g, ' ').replace(/_NS/g, '').trim();
          }
        }

        return '';
      };

      CollectionSection.buildRemoveFilterName = function buildRemoveFilterName(template, label, category) {
        var text = (template || 'Remove __LABEL__ __CATEGORY__ filter')
          .replace(/__LABEL__/g, label || '')
          .replace(/__CATEGORY__/g, category || '');
        return text.replace(/\s+/g, ' ').trim();
      };

      CollectionSection.renderSelectedFilterChips = function renderSelectedFilterChips(checkedvalue) {
        var list = (checkedvalue || []).map(function (value) {
          if (value.category) {
            return value;
          }
          var input = value.handleat ? document.getElementById(value.handleat) : null;
          return Object.assign({}, value, {
            category: CollectionSection.getFilterCategoryLabel(input)
          });
        });
        var container = document.querySelector('.collectionfilterselected');
        if (!container) {
          return;
        }
        var template = container.getAttribute('data-remove-template') || 'Remove __LABEL__ __CATEGORY__ filter';
        container.innerHTML = '';
        list.forEach(function (value) {
          var label = value.splitvalue || value.value || '';
          var category = value.category || '';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'selectedfilter';
          btn.setAttribute('data-action', 'remove-filter');
          btn.setAttribute('data-name', value.option || '');
          btn.setAttribute('data-value', value.value || '');
          btn.setAttribute('data-label', label);
          btn.setAttribute('data-category', category);
          btn.setAttribute('aria-label', CollectionSection.buildRemoveFilterName(template, label, category));
          btn.appendChild(document.createTextNode(label));
          var x = document.createElement('span');
          x.className = 'cross-p';
          x.setAttribute('aria-hidden', 'true');
          x.textContent = 'X';
          btn.appendChild(x);
          container.appendChild(btn);
        });
      };

      if (typeof window !== 'undefined') {
        window.theme = window.theme || {};
        window.theme.renderSelectedFilterChips = CollectionSection.renderSelectedFilterChips;
        window.theme.getFilterCategoryLabel = CollectionSection.getFilterCategoryLabel;
        window.theme.buildRemoveFilterName = CollectionSection.buildRemoveFilterName;
      }
  
      return CollectionSection;
    }();
  
    var FaqSection = /*#__PURE__*/function () {
      function FaqSection(element) {
        _classCallCheck(this, FaqSection);
  
        this.element = element;
        this.delegateElement = new domDelegate.Delegate(this.element);
  
        this._attachListeners();
      }
  
      _createClass(FaqSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off();
        }
      }, {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          this._openItem(event.target);
        }
      }, {
        key: "onBlockDeselect",
        value: function onBlockDeselect(event) {
          this._closeItem(event.target);
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on('click', '.Faq__Question', this._toggleItem.bind(this));
          this.delegateElement.on('click', '.FaqSummary__Item', this._switchToCategory.bind(this));
        }
      }, {
        key: "_switchToCategory",
        value: function _switchToCategory(event, target) {
          target.classList.add('is-active');
          Dom.getSiblings(target, '.is-active').forEach(function (item) {
            item.classList.remove('is-active');
          });
        }
      }, {
        key: "_toggleItem",
        value: function _toggleItem(event, target) {
          var item = target.closest('.Faq__Item');
  
          if (item.getAttribute('aria-expanded') === 'true') {
            this._closeItem(item);
          } else {
            this._openItem(item);
          }
        }
      }, {
        key: "_openItem",
        value: function _openItem(item) {
          var answerWrapper = item.querySelector('.Faq__AnswerWrapper');
          item.setAttribute('aria-expanded', 'true');
          answerWrapper.setAttribute('aria-hidden', 'false');
          Animation.slideDown(answerWrapper, true);
          Dom.getSiblings(item, '[aria-expanded="true"]').forEach(function (siblingItem) {
            var siblingAnswerWrapper = siblingItem.querySelector('.Faq__AnswerWrapper');
            siblingItem.setAttribute('aria-expanded', 'false');
            siblingAnswerWrapper.setAttribute('aria-hidden', 'true');
            Animation.slideUp(siblingAnswerWrapper);
          });
        }
      }, {
        key: "_closeItem",
        value: function _closeItem(item) {
          var answerWrapper = item.querySelector('.Faq__AnswerWrapper');
          item.setAttribute('aria-expanded', 'false');
          answerWrapper.setAttribute('aria-hidden', 'true');
          Animation.slideUp(answerWrapper);
        }
      }]);
  
      return FaqSection;
    }();
  
    var FeaturedCollectionsSection = /*#__PURE__*/function () {
      function FeaturedCollectionsSection(container) {
        var _this = this;
  
        _classCallCheck(this, FeaturedCollectionsSection);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.options = JSON.parse(this.element.getAttribute('data-settings'));
        this.carousels = [];
        Dom.nodeListToArray(this.element.querySelectorAll('[data-flickity-config]')).forEach(function (item) {
          _this.carousels.push(new Carousel(item));
        }); // Setup product item color swatch
  
        new ProductItemColorSwatch(this.element);
  
        this._setupAnimation();
  
        this._attachListeners();
      }
  
      _createClass(FeaturedCollectionsSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.carousels.forEach(function (item) {
            return item.destroy();
          });
          this.delegateElement.off('click');
          this.intersectionObserver.disconnect();
          this.timeline.kill();
        }
      }, {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          // We simply trigger a click on the element that controls this tab
          this.element.querySelector("[aria-controls=\"".concat(event.target.id, "\"]")).click();
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on('click', '[data-action="toggle-tab"]', this._switchTab.bind(this));
        }
      }, {
        key: "_switchTab",
        value: function _switchTab(event, target) {
          var _this2 = this;
  
          // If the tab is already active, do nothing
          if (target.classList.contains('is-active')) {
            return;
          } // First, switch the current tab
  
  
          target.classList.add('is-active');
          Dom.getSiblings(target, '.is-active').forEach(function (item) {
            item.classList.remove('is-active');
          }); // Then, display the panel
  
          var tabPanelToShow = this.element.querySelector("#".concat(target.getAttribute('aria-controls')));
          this.timeline.eventCallback('onReverseComplete', function () {
            tabPanelToShow.setAttribute('aria-hidden', 'false');
            Dom.getSiblings(tabPanelToShow, '.TabPanel[aria-hidden="false"]').forEach(function (item) {
              item.setAttribute('aria-hidden', 'true');
            });
  
            if (Responsive.matchesBreakpoint('lap-and-up')) {
              _this2.carousels.forEach(function (carousel) {
                // There is a bug in Safari where it cannot detect the pseudo-element "::after" if the tab panel is hidden. As a consequence,
                // we manually activate it
                carousel.flickityInstance.activate();
                carousel.flickityInstance.resize(); // Ugly hack
              });
            }
            _this2.timeline.clear();
  
            _this2._setupAnimation();
          });
  
          if (this.options['layout'] === 'grid' && window.theme.showElementStaggering) {
            this.timeline.reverse().timeScale(3);
          } else {
            this.timeline.reverse();
          }
        }
      }, {
        key: "_setupAnimation",
        value: function _setupAnimation() {
          var _this3 = this;
  
          if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
          }
  
          this.timeline = new TimelineLite({
            delay: 0.5
          });
  
          if (this.options['layout'] === 'grid' && window.theme.showElementStaggering) {
            this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
            Dom.nodeListToArray(this.element.querySelectorAll('.TabPanel[aria-hidden="false"] .ProductList .ProductItem')).forEach(function (item) {
              _this3.intersectionObserver.observe(item);
            });
          } else {
            var productList = this.element.querySelector('.TabPanel[aria-hidden="false"] .ProductList');
  
            if (productList) {
              this.timeline.fromTo(productList, 0.6, {
                autoAlpha: 0,
                y: 25
              }, {
                autoAlpha: 1,
                y: 0
              });
            }
          }
        }
      }, {
        key: "_reveal",
        value: function _reveal(results) {
          var _this4 = this;
  
          var toReveal = [];
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              // isIntersecting does not exist on Samsung Android browser
              toReveal.push(result.target);
  
              _this4.intersectionObserver.unobserve(result.target);
            }
          });
  
          if (toReveal.length === 0) {
            return;
          }
  
          this.timeline.staggerFromTo(toReveal, 0.45, {
            autoAlpha: 0,
            y: 25
          }, {
            autoAlpha: 1,
            y: 0
          }, 0.2);
        }
      }]);
  
      return FeaturedCollectionsSection;
    }();
  
    var FeaturedProductSection = /*#__PURE__*/function () {
      function FeaturedProductSection(container) {
        _classCallCheck(this, FeaturedProductSection);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
  
        if (!this.options['usePlaceholder']) {
          this.productVariants = new ProductVariants(container, this.options);
        } // We have to re-order elements in the DOM
  
  
        var offscreenElement = this.element.querySelector('.Product__OffScreen');
  
        if (offscreenElement) {
          this.element.appendChild(offscreenElement);
        }
  
        this._attachListeners();
      }
  
      _createClass(FeaturedProductSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off('click');
  
          if (this.productVariants) {
            this.productVariants.destroy();
          }
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on('variant:changed', this._updateMainImage.bind(this));
        }
        /**
         * Update the main featured image
         */
  
      }, {
        key: "_updateMainImage",
        value: function _updateMainImage(event) {
          var variant = event.detail.variant,
              previousVariant = event.detail.previousVariant;
  
          if (!variant || !variant['featured_image'] || previousVariant['featured_image'] && previousVariant['featured_image']['id'] === variant['featured_image']['id']) {
            return;
          } // Otherwise we are on the home page. It's a bit more complex as we have to rewrite some code normally written in Liquid
  
  
          var newImage = variant['featured_image'];
          var mainImageContainer = this.element.querySelector('.FeaturedProduct__Gallery .AspectRatio');
          mainImageContainer.style.cssText = "max-width: ".concat(newImage['width'], "px; --aspect-ratio: ").concat(newImage['width'] / newImage['height']);
          var newImageElement = document.createElement('img');
          newImageElement.classList.add('Image--lazyLoad');
          newImageElement.setAttribute('data-src', Image.getSizedImageUrl(newImage['src'], '1x1').replace('_1x1.', '_{width}x.'));
          newImageElement.setAttribute('data-widths', "[".concat(Image.getSupportedSizes(newImage, [200, 400, 600, 700, 800, 900, 1000]).join(','), "]"));
          newImageElement.setAttribute('data-sizes', 'auto');
          mainImageContainer.replaceChild(newImageElement, mainImageContainer.querySelector('img'));
        }
      }]);
  
      return FeaturedProductSection;
    }();
  
    var BackgroundVideoSection = /*#__PURE__*/function () {
      function BackgroundVideoSection(container) {
        _classCallCheck(this, BackgroundVideoSection);
  
        this.element = container;
        this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
  
        this._loadScript().then(this._setupPlayer.bind(this));
      }
  
      _createClass(BackgroundVideoSection, [{
        key: "_loadScript",
        value: function _loadScript() {
          var _this = this;
  
          return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            document.body.appendChild(script);
            script.onload = resolve;
            script.onerror = reject;
            script.async = true;
            script.src = _this.options['videoType'] === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
          });
        }
      }, {
        key: "onUnload",
        value: function onUnload() {
          if (this.player) {
            this.player.destroy(); // Both YouTube and Vimeo use the same function name
          }
        }
      }, {
        key: "_setupPlayer",
        value: function _setupPlayer() {
          var _this2 = this;
  
          var elementToInsert = this.element.querySelector('.ImageHero__VideoHolder');
          var playerLoadingInterval = setInterval(function () {
            if (_this2.options['videoType'] === 'youtube') {
              if (window.YT) {
                _this2.player = new YT.Player(elementToInsert, {
                  videoId: _this2.options['videoId'],
                  playerVars: {
                    showinfo: 0,
                    controls: 0,
                    fs: 0,
                    rel: 0,
                    height: '100%',
                    width: '100%',
                    iv_load_policy: 3,
                    html5: 1,
                    loop: 1,
                    playsinline: 1,
                    modestbranding: 1,
                    disablekb: 1,
                    origin: _this2.options['requestHost']
                  },
                  events: {
                    onReady: _this2._onYouTubeReady.bind(_this2),
                    onStateChange: _this2._onYouTubeStateChange.bind(_this2)
                  }
                });
                clearInterval(playerLoadingInterval);
              }
            } else {
              if (window.Vimeo) {
                _this2.player = new Vimeo.Player(elementToInsert.parentNode, {
                  id: _this2.options['videoId'],
                  autoplay: true,
                  autopause: false,
                  muted: true,
                  background: true,
  
                  /*height: '100%',
                  width: '100%',*/
                  loop: true
                });
                clearInterval(playerLoadingInterval);
              }
            }
          }, 50);
        }
      }, {
        key: "_onYouTubeReady",
        value: function _onYouTubeReady(event) {
          this.player.mute();
          this.player.playVideo();
        }
      }, {
        key: "_onYouTubeStateChange",
        value: function _onYouTubeStateChange(event) {
          if (event.data === YT.PlayerState.ENDED) {
            this.player.playVideo();
          }
        }
      }]);
  
      return BackgroundVideoSection;
    }();
  
    var GiftCardSection = /*#__PURE__*/function () {
      function GiftCardSection(container) {
        _classCallCheck(this, GiftCardSection);
  
        this.element = container;
  
        this._createQrCode();
  
        this._setupPrint();
      }
  
      _createClass(GiftCardSection, [{
        key: "_createQrCode",
        value: function _createQrCode() {
          var qrCodeElement = document.getElementById('QrCode');
          new QRCode(qrCodeElement, {
            text: qrCodeElement.getAttribute('data-identifier'),
            width: 120,
            height: 120
          });
        }
      }, {
        key: "_setupPrint",
        value: function _setupPrint() {
          var printElement = document.getElementById('PrintGiftCard');
  
          if (printElement) {
            printElement.addEventListener('click', function () {
              window.print();
            });
          }
        }
      }]);
  
      return GiftCardSection;
    }();
  
    var HeaderSection = /*#__PURE__*/function () {
      function HeaderSection(container) {
        var _this = this;
  
        _classCallCheck(this, HeaderSection);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
        this.lastScrollPosition = -1;
        this.isTouch = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;
  
        if (this.options['isSticky']) {
          Stickyfill.addOne(this.element.parentNode);
        } // Set up the search bar
  
  
        this.searchBar = new SearchBar();
        this._isMovingMenuFocus = false;
  
        this._attachListeners();
  
        this._verifyNavigationOverlap(); // We set again some CSS variables that are used for some calculations in CSS
  
  
        var mainLogo = this.element.querySelector('.Header__LogoImage--primary');
  
        if (mainLogo && !mainLogo.complete) {
          mainLogo.addEventListener('load', function () {
            fastdom.measure(function () {
              document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
              document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
            });
          });
        } else {
          fastdom.measure(function () {
            document.documentElement.style.setProperty('--header-height', _this.element.clientHeight + 'px');
            document.documentElement.style.setProperty('--header-is-not-transparent', _this.options['hasTransparentHeader'] ? 0 : 1);
          });
        }
  
        window.addEventListener('pageshow', this._checkTransparentHeader.bind(this));
  
        this._setupLocalizationPopovers();
      }
  
      _createClass(HeaderSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.element.removeEventListener('mouseleave', this._closeNavigationListener);
          this.element.removeEventListener('mouseenter', this._focusNavigationListener);
          this.element.removeEventListener('focusin', this._focusNavigationListener);
          this.element.removeEventListener('keydown', this._navKeydownListener);
          this.delegateElement.off();
          window.removeEventListener('scroll', this._checkTransparentHeaderListener);
          window.removeEventListener('resize', this._verifyNavigationOverlapListener);
  
          if (this.options['isSticky']) {
            Stickyfill.removeOne(this.element.parentNode);
          }
  
          this.searchBar.destroy();
          this.localizationPopovers.forEach(function (localizationPopover) {
            localizationPopover.destroy();
          });
        }
      }, {
        key: "onSelect",
        value: function onSelect() {
          this._checkTransparentHeader();
        }
      }, {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          var _this2 = this;
  
          var listItem = event.target.closest('.HorizontalList__Item');
          fastdom.mutate(function () {
            event.target.setAttribute('aria-hidden', 'false');
  
            if (listItem) {
              listItem.classList.add('is-expanded');
              Dom.getSiblings(listItem, '.is-expanded').forEach(function (item) {
                item.classList.remove('is-expanded');
              });
            }
  
            _this2.element.classList.remove('Header--transparent'); // This is needed to make sure everything is visible
  
          });
        }
      }, {
        key: "onBlockDeselect",
        value: function onBlockDeselect(event) {
          var listItem = event.target.closest('.HorizontalList__Item');
          fastdom.mutate(function () {
            event.target.setAttribute('aria-hidden', 'true');
  
            if (listItem) {
              listItem.classList.remove('is-expanded');
            }
          });
  
          this._checkTransparentHeader();
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this);
          this._closeNavigationListener = this._closeNavigation.bind(this);
          this._focusNavigationListener = this._focusNavigation.bind(this);
          this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);
          this._navKeydownListener = this._handleNavKeyboard.bind(this);
          this.element.addEventListener('mouseleave', this._closeNavigationListener);
          this.element.addEventListener('keydown', this._navKeydownListener);
          this.delegateElement.on('mouseenter', '.Header__MainNav .HorizontalList__Item, .DropdownMenu .Linklist__Item[aria-haspopup]', this._openMenu.bind(this), true);
          this.delegateElement.on('focusout', '.Header__MainNav .HorizontalList__Item', this._onNavItemFocusOut.bind(this), false);
          this.delegateElement.on('click', '.Header__MenuToggle', this._toggleMenuButton.bind(this));
          this.delegateElement.on('focusin', '.MegaMenu a, .DropdownMenu a', this._onMenuLinkFocus.bind(this));
          this.delegateElement.on('click', '[data-action="toggle-search"]', this._closeNavigationListener);
          this.delegateElement.on('mouseleave', '.DropdownMenu [aria-haspopup]', this._closeMenu.bind(this), true);
          this.delegateElement.on('mouseenter', '.DropdownMenu [aria-haspopup]', this._adjustDropdownPosition.bind(this), true);
  
          if (this.isTouch) {
            this.delegateElement.on('click', '.Header__MainNav .HorizontalList__Item.has-submenu', this._handleTouchMenu.bind(this));
          }
  
          if (this.options['hasTransparentHeader']) {
            this.element.addEventListener('mouseenter', this._focusNavigationListener);
            this.element.addEventListener('focusin', this._focusNavigationListener);
          }
  
          if (this.options['isSticky'] && this.options['hasTransparentHeader']) {
            window.addEventListener('scroll', this._checkTransparentHeaderListener);
          }
  
          if (this.options['navigationStyle'] === 'inline' || this.options['navigationStyle'] === 'logoLeft') {
            window.addEventListener('resize', this._verifyNavigationOverlapListener);
          }
        }
      }, {
        key: "_setupLocalizationPopovers",
        value: function _setupLocalizationPopovers() {
          // Prestige is an extremely complex theme, especially in the header due to the various layouts that power different
          // features. One issue that arises with this is that we output the localization elements twice in the DOM (with the
          // same ID as we're doing a capture in Liquid), and then depending on the screen size one layout is choosen. We therefore
          // have to de-duplicate the ID here. This is honestly not the cleanest code on earth, but I prefer handling this here
          // rather than duplicating too much Liquid
          this.localizationPopovers = [];
          Dom.nodeListToArray(document.querySelectorAll('#header-locale-popover')).forEach(function (item, index) {
            item.id = "".concat(item.id, "-").concat(index);
          });
          Dom.nodeListToArray(document.querySelectorAll('[aria-controls="header-locale-popover"]')).forEach(function (item, index) {
            item.setAttribute('aria-controls', "".concat(item.getAttribute('aria-controls'), "-").concat(index));
          });
          Dom.nodeListToArray(document.querySelectorAll('#header-currency-popover')).forEach(function (item, index) {
            item.id = "".concat(item.id, "-").concat(index);
          });
          Dom.nodeListToArray(document.querySelectorAll('[aria-controls="header-currency-popover"]')).forEach(function (item, index) {
            item.setAttribute('aria-controls', "".concat(item.getAttribute('aria-controls'), "-").concat(index));
          });
          var localePopoverElement1 = document.getElementById('header-locale-popover-0');
  
          if (localePopoverElement1) {
            this.localizationPopovers.push(new Popover(localePopoverElement1, {
              preferredAlignment: 'center',
              preferredPosition: 'bottom',
              threshold: 12
            }));
          }
  
          var localePopoverElement2 = document.getElementById('header-locale-popover-1');
  
          if (localePopoverElement2) {
            this.localizationPopovers.push(new Popover(localePopoverElement2, {
              preferredAlignment: 'center',
              preferredPosition: 'bottom',
              threshold: 12
            }));
          }
  
          var currencyPopoverElement1 = document.getElementById('header-currency-popover-0');
  
          if (currencyPopoverElement1) {
            this.localizationPopovers.push(new Popover(currencyPopoverElement1, {
              preferredAlignment: 'center',
              preferredPosition: 'bottom',
              threshold: 12
            }));
          }
  
          var currencyPopoverElement2 = document.getElementById('header-currency-popover-1');
  
          if (currencyPopoverElement2) {
            this.localizationPopovers.push(new Popover(currencyPopoverElement2, {
              preferredAlignment: 'center',
              preferredPosition: 'bottom',
              threshold: 12
            }));
          }
        }
      }, {
        key: "_focusNavigation",
        value: function _focusNavigation() {
          var _this3 = this;
  
          fastdom.mutate(function () {
            if (!_this3.isTouch || Responsive.matchesBreakpoint('desk')) {
              _this3.element.classList.remove('Header--transparent');
            }
          });
        }
      }, {
        key: "_closeNavigation",
        value: function _closeNavigation() {
          var _this4 = this;
  
          fastdom.mutate(function () {
            Dom.nodeListToArray(_this4.element.querySelectorAll('.is-expanded')).forEach(function (item) {
              item.classList.remove('is-expanded');
            });
            Dom.nodeListToArray(_this4.element.querySelectorAll('.Header__MainNav [aria-hidden="false"]')).forEach(function (item) {
              item.setAttribute('aria-hidden', 'true');
            });
            Dom.nodeListToArray(_this4.element.querySelectorAll('.Header__MainNav [aria-expanded="true"]')).forEach(function (item) {
              item.setAttribute('aria-expanded', 'false');
            });
          });
  
          if (this.options['hasTransparentHeader']) {
            this._checkTransparentHeader();
          }
        }
      }, {
        key: "_getMenuTrigger",
        value: function _getMenuTrigger(item) {
          if (!item) {
            return null;
          }

          return item.querySelector('.Header__MenuToggle');
        }
      }, {
        key: "_syncMenuAria",
        value: function _syncMenuAria(item, isOpen) {
          var trigger = this._getMenuTrigger(item);

          if (!trigger) {
            return;
          }

          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
      }, {
        key: "_getFirstMenuLink",
        value: function _getFirstMenuLink(item) {
          if (!item) {
            return null;
          }

          return item.querySelector('.MegaMenu__PrimaryItem, .MegaMenu a[href], .DropdownMenu a[href]');
        }
      }, {
        key: "_onMenuLinkFocus",
        value: function _onMenuLinkFocus(event, target) {
          var item = target.closest('.HorizontalList__Item');

          if (!item) {
            return;
          }

          item.querySelectorAll('.is-keyboard-selected').forEach(function (el) {
            el.classList.remove('is-keyboard-selected');
          });
          target.classList.add('is-keyboard-selected');
        }
      }, {
        key: "_focusFirstMenuLink",
        value: function _focusFirstMenuLink(item) {
          var firstLink = this._getFirstMenuLink(item);

          if (!firstLink) {
            return false;
          }

          this._onMenuLinkFocus(null, firstLink);
          firstLink.focus({
            preventScroll: false
          });
          return document.activeElement === firstLink;
        }
      }, {
        key: "_toggleMenuButton",
        value: function _toggleMenuButton(event, target) {
          event.preventDefault();
          event.stopPropagation();
          var item = target.closest('.HorizontalList__Item');

          if (!item) {
            return;
          }

          var isOpen = target.getAttribute('aria-expanded') === 'true';

          if (isOpen) {
            this._setItemExpanded(item, false);
            target.focus();
            return;
          }

          var _thisToggle = this;
          this._isMovingMenuFocus = true;
          this._setItemExpanded(item, true, function () {
            target.blur();
            requestAnimationFrame(function () {
              _thisToggle._focusFirstMenuLink(item);
              requestAnimationFrame(function () {
                if (document.activeElement !== _thisToggle._getFirstMenuLink(item)) {
                  _thisToggle._focusFirstMenuLink(item);
                }
                _thisToggle._isMovingMenuFocus = false;
              });
            });
          });
        }
      }, {
        key: "_setItemExpanded",
        value: function _setItemExpanded(item, isOpen, onComplete) {
          var _thisMenu = this;

          if (!item) {
            return;
          }

          fastdom.mutate(function () {
            if (isOpen) {
              item.classList.add('is-expanded');

              Dom.nodeListToArray(item.children, '.Header__MainNav [aria-hidden="true"]').forEach(function (child) {
                child.setAttribute('aria-hidden', 'false');
              });
              Dom.getSiblings(item, '.is-expanded').forEach(function (sibling) {
                sibling.classList.remove('is-expanded');

                _thisMenu._syncMenuAria(sibling, false);

                Dom.nodeListToArray(sibling.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (child) {
                  child.setAttribute('aria-hidden', 'true');
                });
              });

              _thisMenu._syncMenuAria(item, true);
            } else {
              item.classList.remove('is-expanded');

              _thisMenu._syncMenuAria(item, false);

              item.querySelectorAll('.is-keyboard-selected').forEach(function (el) {
                el.classList.remove('is-keyboard-selected');
              });

              Dom.nodeListToArray(item.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (child) {
                child.setAttribute('aria-hidden', 'true');
              });
            }

            if (typeof onComplete === 'function') {
              onComplete();
            }
          });
        }
      }, {
        key: "_onNavItemFocusOut",
        value: function _onNavItemFocusOut(event, target) {
          var _thisFocusOut = this;

          if (this._isMovingMenuFocus) {
            return;
          }

          requestAnimationFrame(function () {
            if (_thisFocusOut._isMovingMenuFocus) {
              return;
            }

            if (!target.contains(document.activeElement)) {
              _thisFocusOut._setItemExpanded(target, false);
            }
          });
        }
      }, {
        key: "_handleNavKeyboard",
        value: function _handleNavKeyboard(event) {
          var nav = this.element.querySelector('.Header__MainNav');

          if (!nav || !nav.contains(event.target)) {
            return;
          }

          var key = event.key;
          var openItem = nav.querySelector('.HorizontalList__Item.is-expanded');

          if (key === 'Escape' || key === 'Esc') {
            if (openItem) {
              event.preventDefault();

              var openTrigger = this._getMenuTrigger(openItem);

              this._setItemExpanded(openItem, false);

              if (openTrigger) {
                openTrigger.focus();
              }
            }

            return;
          }

          var trigger = event.target.closest('.Header__MenuToggle');

          if (!trigger) {
            return;
          }

          var item = trigger.closest('.HorizontalList__Item');

          if (!item) {
            return;
          }

          if (key === 'ArrowDown') {
            event.preventDefault();
            this._isMovingMenuFocus = true;
            var _thisKey = this;
            this._setItemExpanded(item, true, function () {
              trigger.blur();
              requestAnimationFrame(function () {
                _thisKey._focusFirstMenuLink(item);
                _thisKey._isMovingMenuFocus = false;
              });
            });
          }
        }
      }, {
        key: "_openMenu",
        value: function _openMenu(event, target) {
          if (event.type === 'mouseenter' && target !== event.target) {
            return;
          }

          if (event.type === 'mouseenter' && document.body.classList.contains('is-tabbing')) {
            return;
          }

          this._setItemExpanded(target, true);
        }
      }, {
        key: "_closeMenu",
        value: function _closeMenu(event, target) {
          if (event.type === 'mouseleave' && target !== event.target) {
            return;
          }

          this._setItemExpanded(target, false);
        }
      }, {
        key: "_adjustDropdownPosition",
        value: function _adjustDropdownPosition(event, target) {
          var nestedMenus = Dom.nodeListToArray(target.querySelectorAll('.DropdownMenu')),
              shouldOpenLeft = false;
          fastdom.measure(function () {
            var windowWidth = window.innerWidth,
                rightEdge = target.getBoundingClientRect().right;
            nestedMenus.forEach(function (item) {
              if (rightEdge + item.offsetWidth > windowWidth) {
                shouldOpenLeft = true;
              }
            });
          });
          fastdom.mutate(function () {
            if (shouldOpenLeft) {
              nestedMenus.forEach(function (item) {
                item.classList.add('DropdownMenu--reversed');
              });
            } else {
              nestedMenus.forEach(function (item) {
                item.classList.remove('DropdownMenu--reversed');
              });
            }
          });
        }
        /**
         * On touch devices where we display the standard menu (like landscape iPad or Surface) we need to do additional code to properly
         * handle the opening of menu. Especially, what we do is that if an item has a sub-menu, a click does not follow the link but instead open
         * the sub-menu. If this link is clicked a second twice, then the menu is followed
         */
  
      }, {
        key: "_handleTouchMenu",
        value: function _handleTouchMenu(event, target) {
          if (event.target.closest('.header-nav-link')) {
            return;
          }

          if (!target.classList.contains('is-expanded')) {
            event.preventDefault();
          }
        }
      }, {
        key: "_verifyNavigationOverlap",
        value: function _verifyNavigationOverlap() {
          var _this5 = this;
  
          var isOverlapping = false,
              mainTopMenu = this.element.querySelector('.Header__MainNav');
          fastdom.measure(function () {
            // To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
            if (mainTopMenu) {
              // Get the first element
              var firstNavElementHeight = Dom.outerHeightWithMargin(mainTopMenu.querySelector('.HorizontalList__Item')),
                  mainNavHeight = mainTopMenu.scrollHeight;
  
              if (mainNavHeight > firstNavElementHeight) {
                isOverlapping = true;
              }
            }
          });
          this.element.classList.remove('Header--logoLeft', 'Header--inline', 'Header--center');
          this.element.classList.add("Header--".concat(this.options['navigationStyle']));
          this.element.clientWidth; // Forces a reflow
  
          fastdom.mutate(function () {
            if (isOverlapping) {
              _this5.element.classList.remove("Header--".concat(_this5.options['navigationStyle']));
  
              _this5.element.classList.add('Header--center'); // Check if still overlapping despite changing the mode
  
  
              if (mainTopMenu) {
                // Get the first element
                var itemTopSet = new Set();
                Array.from(mainTopMenu.querySelectorAll('.HorizontalList__Item')).forEach(function (item) {
                  itemTopSet.add(item.getBoundingClientRect().top);
                });
                isOverlapping = itemTopSet.size > 1;
              }
            } else {
              _this5.element.classList.add("Header--".concat(_this5.options['navigationStyle']));
  
              _this5.element.classList.remove('Header--center');
            }
  
            var logo = _this5.element.querySelector('.Header__FlexItem--logo');
  
            logo.classList.toggle('Header__FlexItem--increaseSpace', isOverlapping);
  
            _this5.element.classList.add('Header--initialized');
  
            fastdom.measure(function () {
              document.documentElement.style.setProperty('--header-height', _this5.element.clientHeight + 'px');
            });
          });
        }
        /**
         * If the header mode is set to "transparent", we have to do extra work to automatically make it with fill colors when the
         * user starts scrolling. For performance we are using fastDOM to do that (which relies of requestAnimationFrame instead of
         * scroll listener)
         */
  
      }, {
        key: "_checkTransparentHeader",
        value: function _checkTransparentHeader() {
          var _this6 = this;
  
          if (!this.options['hasTransparentHeader']) {
            return;
          }
  
          var scrollThreshold = 10;
          fastdom.measure(function () {
            _this6.lastScrollPosition = window.pageYOffset;
          });
          fastdom.mutate(function () {
            if (_this6.lastScrollPosition <= scrollThreshold) {
              const mobileMenuBurgerButton = document.querySelector('.mobileMenuBurgerButton');
              if(!mobileMenuBurgerButton.classList.contains('is-active')) {
                _this6.element.classList.add('Header--transparent');
              }
            } else {
              _this6.element.classList.remove('Header--transparent');
            }
          });
        }
      }]);
  
      return HeaderSection;
    }();
  
    var FooterSection = /*#__PURE__*/function () {
      function FooterSection(container) {
        _classCallCheck(this, FooterSection);
  
        this.element = container;
        var localePopoverElement = document.getElementById('footer-locale-popover');
  
        if (localePopoverElement) {
          this.localePopover = new Popover(localePopoverElement, {
            preferredAlignment: 'center',
            preferredPosition: 'top',
            threshold: 12
          });
        }
  
        var currencyPopoverElement = document.getElementById('footer-currency-popover');
  
        if (currencyPopoverElement) {
          this.currencyPopover = new Popover(currencyPopoverElement, {
            preferredAlignment: 'center',
            preferredPosition: 'top',
            threshold: 12
          });
        }
      }
  
      _createClass(FooterSection, [{
        key: "onUnload",
        value: function onUnload() {
          if (this.localePopover) {
            this.localePopover.destroy();
          }
  
          if (this.currencyPopover) {
            this.currencyPopover.destroy();
          }
        }
      }]);
  
      return FooterSection;
    }();
  
    var ImageWithTextBlockSection = /*#__PURE__*/function () {
      function ImageWithTextBlockSection(container) {
        _classCallCheck(this, ImageWithTextBlockSection);
  
        this.element = container;
      }
  
      _createClass(ImageWithTextBlockSection, [{
        key: "onUnload",
        value: function onUnload() {}
      }]);
  
      return ImageWithTextBlockSection;
    }();
  
    var LoginSection = /*#__PURE__*/function () {
      function LoginSection(container) {
        _classCallCheck(this, LoginSection);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.timelineLite = new TimelineLite();
        this.customerLoginForm = this.element.querySelector('#customer_login');
        this.recoverPasswordForm = this.element.querySelector('#recover_customer_password');
        this.delegateElement.on('click', '[data-action="toggle-recover-form"]', this._showRecoverPassword.bind(this));
      }
  
      _createClass(LoginSection, [{
        key: "_showRecoverPassword",
        value: function _showRecoverPassword() {
          var isLoginActive = this.customerLoginForm.style.display === 'block';
  
          if (isLoginActive) {
            this.timelineLite.fromTo(this.customerLoginForm, 0.5, {
              autoAlpha: 1,
              display: 'block',
              y: 0
            }, {
              autoAlpha: 0,
              y: 20,
              display: 'none'
            }).fromTo(this.recoverPasswordForm, 0.5, {
              autoAlpha: 0,
              display: 'none',
              y: 20
            }, {
              autoAlpha: 1,
              display: 'block',
              y: 0,
              delay: 0.25
            });
          } else {
            this.timelineLite.fromTo(this.recoverPasswordForm, 0.5, {
              autoAlpha: 1,
              display: 'block',
              y: 0
            }, {
              autoAlpha: 0,
              y: 20,
              display: 'none'
            }).fromTo(this.customerLoginForm, 0.5, {
              autoAlpha: 0,
              display: 'none',
              y: 20
            }, {
              autoAlpha: 1,
              display: 'block',
              y: 0,
              delay: 0.25
            });
          }
        }
      }]);
  
      return LoginSection;
    }();
  
    var MapSection = /*#__PURE__*/function () {
      function MapSection(element) {
        _classCallCheck(this, MapSection);
  
        this.element = element;
        this.options = JSON.parse(element.getAttribute('data-section-settings'));
  
        if (this.options['apiKey'] && this.options['mapAddress']) {
          this._loadScript().then(this._initMap.bind(this));
        }
      }
  
      _createClass(MapSection, [{
        key: "_loadScript",
        value: function _loadScript() {
          var _this = this;
  
          return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            document.body.appendChild(script);
            script.onload = resolve;
            script.onerror = reject;
            script.async = true;
            script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(_this.options['apiKey']);
          });
        }
      }, {
        key: "_initMap",
        value: function _initMap() {
          var _this2 = this;
  
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode({
            address: this.options['mapAddress']
          }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
              if (Shopify.designMode) ;
            } else {
              var mapOptions = {
                zoom: _this2.options['zoom'],
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
              var map = new google.maps.Map(_this2.element.querySelector('.FeaturedMap__GMap'), mapOptions),
                  center = map.getCenter();
              map.setCenter(center);
              var icon = {
                path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
                fillColor: _this2.options['markerColor'],
                fillOpacity: 1,
                anchor: new google.maps.Point(15, 55),
                strokeWeight: 0,
                scale: 0.6
              };
              new google.maps.Marker({
                map: map,
                position: map.getCenter(),
                icon: icon
              });
              var styledMapType = new google.maps.StyledMapType(JSON.parse(_this2.element.querySelector('[data-gmap-style]').innerHTML));
              map.mapTypes.set('styled_map', styledMapType);
              map.setMapTypeId('styled_map');
              google.maps.event.addDomListener(window, 'resize', function () {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
              });
            }
          });
        }
      }]);
  
      return MapSection;
    }();
  
    var NewsletterPopupSection = /*#__PURE__*/function () {
      function NewsletterPopupSection(element) {
        _classCallCheck(this, NewsletterPopupSection);
  
        this.element = element;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.options = JSON.parse(element.getAttribute('data-section-settings')); // If the popup has been already displayed, we do not display it
  
        try {
          if (window.location.hash === '#newsletter-popup' && window.theme.pageType !== null) {
            this._openPopup();
          } else if (!this.options['showOnlyOnce'] || this.options['showOnlyOnce'] && localStorage.getItem('themePopup') === null) {
            setTimeout(this._openPopup.bind(this), this.options['apparitionDelay'] * 1000);
          }
        } catch (error) {// Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
        }
  
        this._attachListeners();
      }
  
      _createClass(NewsletterPopupSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off();
        }
      }, {
        key: "onSelect",
        value: function onSelect() {
          this._openPopup();
        }
      }, {
        key: "onDeselect",
        value: function onDeselect() {
          this._closePopup();
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on('click', '[data-action="close-popup"]', this._closePopup.bind(this));
        }
      }, {
        key: "_openPopup",
        value: function _openPopup() {
          this.element.setAttribute('aria-hidden', 'false');
          localStorage.setItem('themePopup', 'true');
        }
      }, {
        key: "_closePopup",
        value: function _closePopup() {
          this.element.setAttribute('aria-hidden', 'true');
        }
      }]);
  
      return NewsletterPopupSection;
    }();
  
    var ProductRecommendationsSection = /*#__PURE__*/function () {
      function ProductRecommendationsSection(container) {
        _classCallCheck(this, ProductRecommendationsSection);
  
        this.element = container;
        this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
  
        this._loadRecommendations().then(this._createSlideshow.bind(this));
      }
  
      _createClass(ProductRecommendationsSection, [{
        key: "_loadRecommendations",
        value: function _loadRecommendations() {
          var _this = this;
  
          var url = "".concat(window.routes.productRecommendationsUrl, "?section_id=").concat(this.element.getAttribute('data-section-id'), "&product_id=").concat(this.options['productId'], "&limit=").concat(this.options['recommendationsCount'], "&intent=related");
          return fetch(url).then(function (response) {
            return response.text().then(function (content) {
              var container = document.createElement('div');
              container.innerHTML = content;
              var recommendations = container.querySelector('.ProductRecommendations');
              var target = _this.element.querySelector('.ProductRecommendations');

              if (!recommendations || !target) {
                return;
              }

              target.innerHTML = recommendations.innerHTML;

              // Explore other styles filters same-style / accessories in Liquid — hide if nothing left
              if (!target.querySelector('.Carousel__Cell')) {
                var shopifySection = _this.element.closest('.shopify-section');
                if (shopifySection) {
                  shopifySection.style.display = 'none';
                }
              }
            });
          });
        }
      }, {
        key: "_createSlideshow",
        value: function _createSlideshow() {
          var flickityElement = this.element.querySelector('[data-flickity-config]');
  
          if (!flickityElement || !flickityElement.querySelector('.Carousel__Cell')) {
            return;
          }
  
          this.carousel = new Carousel(flickityElement); // Setup product item color swatch
  
          new ProductItemColorSwatch(this.element);
        }
      }, {
        key: "onUnload",
        value: function onUnload() {
          if (this.carousel) {
            this.carousel.destroy();
          }
        }
      }]);
  
      return ProductRecommendationsSection;
    }();
  
    var ProductSection = /*#__PURE__*/function () {
      function ProductSection(container) {
        var _this = this;
  
        _classCallCheck(this, ProductSection);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
        this.viewInSpaceElement = this.element.querySelector('[data-shopify-xr]');
        this.productVariants = new ProductVariants(container, this.options);
        this.productReviews = new ProductReviews(container);
        var productSlideshowElement = this.element.querySelector('.Product__Slideshow'); // If there is no image at all, there is nothing to init
  
        if (productSlideshowElement) {
          this.productSlideshow = new Carousel(productSlideshowElement, {
            onSelect: this._onImageChanged.bind(this),
            onSettle: this._onImageSettled.bind(this)
          }, {
            draggable: !Responsive.matchesBreakpoint('supports-hover')
          });
          this.mediaList = {}; // We keep track of a list of media element
  
          this.previouslySelectedMedia = null; // Keep track of the previously selected media
          // For each model and video, we register a media
  
          productSlideshowElement.querySelectorAll('[data-media-type="model"]').forEach(function (model) {
            _this.mediaList[model.getAttribute('data-media-id')] = new ProductModel(model, _this.options['stackProductImages']);
          });
          productSlideshowElement.querySelectorAll('[data-media-type="video"], [data-media-type="external_video"]').forEach(function (video) {
            _this.mediaList[video.getAttribute('data-media-id')] = new ProductVideo(video, _this.options['stackProductImages'], _this.options['enableVideoLooping']);
          });
  
          if (this.options['stackProductImages']) {
            this.slideshowNavDots = this.element.querySelector('.Product__SlideshowNav--dots');
            this.slideshowNavDotsItems = this.slideshowNavDots ? Dom.nodeListToArray(this.slideshowNavDots.querySelectorAll('a')) : [];
          }
  
          if (this.options['showThumbnails']) {
            this.slideshowNavThumbnails = this.element.querySelector('.Product__SlideshowNav--thumbnails');
            this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails ? Dom.nodeListToArray(this.slideshowNavThumbnails.querySelectorAll('.Product__SlideshowNavImage')) : [];
          }
  
          this.slideshowImages = Dom.nodeListToArray(productSlideshowElement.querySelectorAll('.Carousel__Cell')); // Setup the mobile nav
  
          this._setupSlideshowMobileNav();
          this._syncGalleryAccessibilityState();
        }
  
        this.productWrapperElement = this.element.querySelector('.Product__Wrapper');
        this.productInfoElement = this.element.querySelector('.Product__Info');
        this.productAsideElement = this.element.querySelector('.Product__Aside');
        this.productGalleryElement = this.element.querySelector('.Product__Gallery');
        this.quickNav = this.element.querySelector('.Product__QuickNav');
  
        if (this.options['enableImageZoom']) {
          this.imageZoomInstance = new ProductImageZoom(this.element, this.productSlideshow);
        }
  
        Stickyfill.addOne(this.productInfoElement); // We have to re-order elements in the DOM
  
        var offscreenElement = this.element.querySelector('.Product__OffScreen');
  
        if (offscreenElement) {
          this.element.appendChild(offscreenElement);
        }
  
        this._setupDeviceFeatures();
  
        this._attachListeners();
      }
  
      _createClass(ProductSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off('click');
          this.productReviews.destroy();
  
          if (this.productVariants) {
            this.productVariants.destroy();
          }
  
          if (this.productSlideshow) {
            this.productSlideshow.destroy();
          }
  
          if (this.options['enableImageZoom']) {
            this.imageZoomInstance.destroy();
          }
  
          if (this.carouselNavScrollSpy) {
            this.carouselNavScrollSpy.destroy();
          }
  
          if (this.quickNav) {
            window.removeEventListener('scroll', this._checkQuickNavListener);
          }
  
          if (this.productInfoScroller) {
            this.productInfoScroller.destroy();
          }
  
          if (this.productThumbnailsScroller) {
            this.productThumbnailsScroller.destroy();
          }
  
          if (window.ResizeObserver && this.productInfoResizeObserver) {
            this.productInfoResizeObserver.disconnect();
          }
  
          Stickyfill.removeOne(this.productInfoElement);
          document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onBreakpointChangedListener = this._setupDeviceFeatures.bind(this);
          this._checkQuickNavListener = this._checkQuickNav.bind(this);
          this.delegateElement.on('click', '[data-action="toggle-social-share"]', this._toggleSocialShare.bind(this));
          this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));
          this.delegateElement.on('scrollspy:target:changed', this._onScrollTargetChanged.bind(this));
          this.delegateElement.on('model:played', this._onMediaPlayed.bind(this));
          this.delegateElement.on('video:played', this._onMediaPlayed.bind(this));
          this.delegateElement.on('model:paused', this._onMediaPaused.bind(this));
          this.delegateElement.on('video:paused', this._onMediaPaused.bind(this));
          document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
  
          if (this.quickNav) {
            window.addEventListener('scroll', this._checkQuickNavListener);
          }
  
          if (this.options['showThumbnails']) {
            this.delegateElement.on('click', '.Product__SlideshowNavImage', this._onThumbnailClick.bind(this));
            this.delegateElement.on('keydown', '.Product__SlideshowNavImage', this._onThumbnailKeydown.bind(this));
          }

          this.delegateElement.on('click', '[data-action="carousel-previous"]', this._onCarouselPrevious.bind(this));
          this.delegateElement.on('click', '[data-action="carousel-next"]', this._onCarouselNext.bind(this));
        }
      }, {
        key: "_setupSlideshowMobileNav",
        value: function _setupSlideshowMobileNav() {
          var _this2 = this;
  
          this.slideshowMobileNav = this.element.querySelector('.Product__SlideshowMobileNav');
  
          if (this.slideshowMobileNav) {
            var slideshowMobileNavDelegate = new domDelegate.Delegate(this.slideshowMobileNav); // Handle the dot
  
            slideshowMobileNavDelegate.on('click', '.dot', function (event, element) {
              _this2._slideWillChange();
  
              _this2.productSlideshow.selectCell(parseInt(element.getAttribute('data-index')));
            }); // Handle the buttons
  
            slideshowMobileNavDelegate.on('click', '.Product__SlideshowNavArrow', function (event, element) {
              if (element.disabled || element.getAttribute('aria-disabled') === 'true') {
                event.preventDefault();
                return;
              }

              _this2._slideWillChange();

              if (element.getAttribute('data-direction') === 'next') {
                _this2.productSlideshow.next();
              } else {
                _this2.productSlideshow.previous();
              }
            });
          }
        }
        /**
         * Update the main carousel image
         */
  
      }, {
        key: "_updateSlideshowImage",
        value: function _updateSlideshowImage(event) {
          var variant = event.detail.variant,
              previousVariant = event.detail.previousVariant;
  
          if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
            return;
          } // We have two logic here: if we are on pocket mode, we switch using the carousel, otherwise we simulate a link to the anchor
  
  
          this._slideWillChange();
  
          if (Responsive.matchesBreakpoint('pocket') || !this.options['stackProductImages']) {
            for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
              var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
                  mediaId = parseInt(cellElement.getAttribute('data-media-id'));
  
              if (mediaId === variant['featured_media']['id']) {
                this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
              }
            }
          } else {
            var thumbnailButton = this.element.querySelector('.Product__SlideshowNavImage[data-media-id="'.concat(variant['featured_media']['id'], '"]'));

            if (thumbnailButton) {
              this._scrollToGalleryPanel(thumbnailButton);
            }
          }
        }
        /**
         * This happens when a media is played
         */
  
      }, {
        key: "_onMediaPlayed",
        value: function _onMediaPlayed(event) {
          // Remove draggability
          this.productSlideshow.getFlickityInstance().options.draggable = false;
          this.productSlideshow.getFlickityInstance().unbindDrag(); // If there is a previously enabled media, we disable it
  
          if (this.previouslySelectedMedia && this.previouslySelectedMedia !== event.target) {
            this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')].hasBeenDeselected();
          } // If the slideshow is configured to stack images, the "select" method from the carousel is not called, so we
          // have to keep track of it here
  
  
          if (this.options['stackProductImages']) {
            this.previouslySelectedMedia = event.target;
          }
        }
        /**
         * This happens when a given media is paused
         */
  
      }, {
        key: "_onMediaPaused",
        value: function _onMediaPaused() {
          // Enable draggability
          this.productSlideshow.getFlickityInstance().options.draggable = !Responsive.matchesBreakpoint('supports-hover');
          this.productSlideshow.getFlickityInstance().bindDrag();
        }
        /**
         * This method is called when a media changed in the slideshow
         */
  
      }, {
        key: "_handleMedia",
        value: function _handleMedia(item) {
          // First, we need to turn off the previous media (if any)
          if (this.previouslySelectedMedia && this.previouslySelectedMedia !== item) {
            switch (this.previouslySelectedMedia.getAttribute('data-media-type')) {
              case 'video':
              case 'external_video':
              case 'model':
                this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')].hasBeenDeselected();
            } // If the previous media was a model, we need to adjust the "view in space" button to go back to initial value
  
  
            if (this.previouslySelectedMedia.getAttribute('data-media-type') === 'model' && this.viewInSpaceElement) {
              this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', this.viewInSpaceElement.getAttribute('data-shopify-model3d-default-id'));
            }
          } // Then, we have to handle the currently selected media
  
  
          switch (item.getAttribute('data-media-type')) {
            case 'video':
            case 'external_video':
            case 'model':
              this.mediaList[item.getAttribute('data-media-id')].hasBeenSelected();
              break;
          } // If the media is a model, we need to adjust the "view in space" button
  
  
          if (item.getAttribute('data-media-type') === 'model' && this.viewInSpaceElement) {
            this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', item.getAttribute('data-media-id'));
          } // We set the previously selected media to the currently new one, so that when it changes it can be properly accounted
  
  
          this.previouslySelectedMedia = item;
        }
        /**
         * Callback when the target changes
         */
  
      }, {
        key: "_onScrollTargetChanged",
        value: function _onScrollTargetChanged(event) {
          // The scrollspy emit also an "oldTarget", but when scrolling very fast with Firefox or Safari, it prevents the old to be removed, so we
          // manually iterate through all of them to remove it first
          if (this.options['stackProductImages']) {
            this.slideshowNavDotsItems.forEach(function (item) {
              return item.classList.remove('is-selected');
            });
            this.slideshowNavDotsItems[parseInt(event.detail.newTarget.getAttribute('data-media-position')) - 1].classList.add('is-selected');
  
            if (this.options['showThumbnails']) {
              this._updateGalleryTabState(event.detail.newTarget.getAttribute('data-media-id'));
            }
          }
        }
      }, {
        key: "_updateGalleryTabState",
        value: function _updateGalleryTabState(mediaId) {
          if (!mediaId) {
            return;
          }

          var mediaIdString = String(mediaId);

          if (this.slideshowNavThumbnailsItems && this.slideshowNavThumbnailsItems.length) {
            this.slideshowNavThumbnailsItems.forEach(function (thumbnail) {
              var isSelected = thumbnail.getAttribute('data-media-id') === mediaIdString;
              thumbnail.classList.toggle('is-selected', isSelected);
              thumbnail.setAttribute('aria-selected', isSelected ? 'true' : 'false');
              thumbnail.setAttribute('tabindex', isSelected ? '0' : '-1');
              thumbnail.removeAttribute('aria-current');
            });
          }

          if (this.slideshowImages && this.slideshowImages.length) {
            var slideshowElement = this.element.querySelector('.Product__Slideshow');
            var shouldHideSlides = slideshowElement && slideshowElement.classList.contains('flickity-enabled');

            if (shouldHideSlides) {
              this.slideshowImages.forEach(function (slide) {
                var isSelected = slide.getAttribute('data-media-id') === mediaIdString;
                slide.setAttribute('aria-hidden', isSelected ? 'false' : 'true');

                var zoomButton = slide.querySelector('.Product__SlideItem__ZoomButton');

                if (zoomButton) {
                  if (isSelected) {
                    zoomButton.removeAttribute('tabindex');
                  } else {
                    zoomButton.setAttribute('tabindex', '-1');
                  }
                }
              });
            } else {
              this.slideshowImages.forEach(function (slide) {
                slide.removeAttribute('aria-hidden');

                var zoomButton = slide.querySelector('.Product__SlideItem__ZoomButton');

                if (zoomButton) {
                  zoomButton.removeAttribute('tabindex');
                }
              });
            }

            var selectedIndex = this.slideshowImages.findIndex(function (slide) {
              return slide.getAttribute('data-media-id') === mediaIdString;
            });
            this._updateCarouselNavDisabledState(selectedIndex);
          }
        }
      }, {
        key: "_updateCarouselNavDisabledState",
        value: function _updateCarouselNavDisabledState(selectedIndex) {
          if (!this.slideshowImages || !this.slideshowImages.length) {
            return;
          }

          var index = typeof selectedIndex === 'number' ? selectedIndex : -1;

          if (index < 0) {
            index = this.slideshowImages.findIndex(function (slide) {
              return slide.classList.contains('is-selected');
            });
          }

          if (index < 0) {
            index = 0;
          }

          var isFirst = index <= 0;
          var isLast = index >= this.slideshowImages.length - 1;
          var navButtons = this.element.querySelectorAll('.Product__SlideshowNavArrow--previous, .Product__SlideshowNavArrow--next, .Product__SlideshowCarouselControl');

          Dom.nodeListToArray(navButtons).forEach(function (button) {
            var isPrevious = button.classList.contains('Product__SlideshowNavArrow--previous') || button.getAttribute('data-action') === 'carousel-previous';
            var isNext = button.classList.contains('Product__SlideshowNavArrow--next') || button.getAttribute('data-action') === 'carousel-next';
            var shouldDisable = isPrevious && isFirst || isNext && isLast;

            if (!isPrevious && !isNext) {
              return;
            }

            button.disabled = shouldDisable;
            button.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
          });
        }
      }, {
        key: "_syncGalleryAccessibilityState",
        value: function _syncGalleryAccessibilityState() {
          var selectedSlide = this.element.querySelector('.Product__SlideItem.is-selected');

          if (selectedSlide) {
            this._updateGalleryTabState(selectedSlide.getAttribute('data-media-id'));
          }
        }
      }, {
        key: "_isFlickityCarouselActive",
        value: function _isFlickityCarouselActive() {
          var slideshowElement = this.element.querySelector('.Product__Slideshow');
          return slideshowElement && slideshowElement.classList.contains('flickity-enabled');
        }
      }, {
        key: "_onCarouselPrevious",
        value: function _onCarouselPrevious(event) {
          if (event.currentTarget && event.currentTarget.disabled) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          this._navigateCarousel('previous');
        }
      }, {
        key: "_onCarouselNext",
        value: function _onCarouselNext(event) {
          if (event.currentTarget && event.currentTarget.disabled) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          this._navigateCarousel('next');
        }
      }, {
        key: "_navigateCarousel",
        value: function _navigateCarousel(direction) {
          this._slideWillChange();

          if (this._isFlickityCarouselActive() && this.productSlideshow) {
            if (direction === 'next') {
              this.productSlideshow.next();
            } else {
              this.productSlideshow.previous();
            }

            return;
          }

          if (!this.slideshowNavThumbnailsItems || !this.slideshowNavThumbnailsItems.length) {
            if (this.slideshowImages && this.slideshowImages.length > 1) {
              var selectedIndex = this.slideshowImages.findIndex(function (slide) {
                return slide.classList.contains('is-selected');
              });

              if (selectedIndex === -1) {
                selectedIndex = 0;
              }

              var slideIndex = direction === 'next' ? selectedIndex + 1 : selectedIndex - 1;

              if (slideIndex >= 0 && slideIndex < this.slideshowImages.length) {
                var nextSlide = this.slideshowImages[slideIndex];
                this._scrollToGalleryPanel({
                  getAttribute: function (name) {
                    if (name === 'data-media-id') {
                      return nextSlide.getAttribute('data-media-id');
                    }

                    if (name === 'data-offset') {
                      return '-25';
                    }

                    return null;
                  },
                  hasAttribute: function (name) {
                    return name === 'data-focus-on-click';
                  }
                });
              }
            }

            return;
          }

          var currentIndex = this.slideshowNavThumbnailsItems.findIndex(function (thumbnail) {
            return thumbnail.getAttribute('aria-selected') === 'true' || thumbnail.classList.contains('is-selected');
          });

          if (currentIndex === -1) {
            currentIndex = 0;
          }

          var newIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;

          if (newIndex < 0 || newIndex >= this.slideshowNavThumbnailsItems.length) {
            return;
          }

          this._scrollToGalleryPanel(this.slideshowNavThumbnailsItems[newIndex]);
        }
      }, {
        key: "_scrollToGalleryPanel",
        value: function _scrollToGalleryPanel(target) {
          var mediaId = target.getAttribute('data-media-id');
          var element = document.getElementById('Media' + mediaId);

          if (!element) {
            return;
          }

          var offset = parseInt(target.getAttribute('data-offset') || -25);
          var announcementBar = document.querySelector('.AnnouncementBar');

          if (announcementBar) {
            offset -= announcementBar.clientHeight;
          }

          if (target.hasAttribute('data-focus-on-click')) {
            var prevScrollY = window.pageYOffset;
            element.focus({
              preventScroll: true
            });

            if (window.pageYOffset !== prevScrollY) {
              window.scrollTo(window.pageXOffset, prevScrollY);
            }

            element.focus();
          }

          window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - offset
          });

          this._updateGalleryTabState(mediaId);
        }
      }, {
        key: "_onThumbnailClick",
        value: function _onThumbnailClick(event, target) {
          event.preventDefault();

          this._slideWillChange();

          if (this.options['stackProductImages']) {
            this._scrollToGalleryPanel(target);
          } else {
            this._switchToImage(event, target);
          }
        }
      }, {
        key: "_onThumbnailKeydown",
        value: function _onThumbnailKeydown(event, target) {
          var navigationKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];

          if (navigationKeys.indexOf(event.key) === -1) {
            return;
          }

          if (!this.slideshowNavThumbnailsItems || !this.slideshowNavThumbnailsItems.length) {
            return;
          }

          event.preventDefault();

          var currentIndex = this.slideshowNavThumbnailsItems.indexOf(target);
          var newIndex = currentIndex;

          switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              newIndex = currentIndex + 1;
              break;

            case 'ArrowLeft':
            case 'ArrowUp':
              newIndex = currentIndex - 1;
              break;

            case 'Home':
              newIndex = 0;
              break;

            case 'End':
              newIndex = this.slideshowNavThumbnailsItems.length - 1;
              break;
          }

          if (newIndex < 0 || newIndex >= this.slideshowNavThumbnailsItems.length || newIndex === currentIndex) {
            return;
          }

          var newTab = this.slideshowNavThumbnailsItems[newIndex];
          newTab.focus();

          this._slideWillChange();

          if (this.options['stackProductImages']) {
            this._scrollToGalleryPanel(newTab);
          } else {
            this._switchToImage({
              preventDefault: function preventDefault() {}
            }, newTab);
          }
        }
      }, {
        key: "_switchToImage",
        value: function _switchToImage(event, target) {
          event.preventDefault();
  
          this._slideWillChange();
  
          for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
            var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
                mediaId = parseInt(cellElement.getAttribute('data-media-id'));
  
            if (mediaId === parseInt(target.getAttribute('data-media-id'))) {
              this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
            }
          }
        }
        /**
         * Check the quick nav
         */
  
      }, {
        key: "_checkQuickNav",
        value: function _checkQuickNav() {
          var _this3 = this;
  
          var showAsideQuickNav = false;
          fastdom.measure(function () {
            showAsideQuickNav = window.scrollY >= _this3.productAsideElement.offsetTop - _this3.productAsideElement.clientHeight;
          });
          fastdom.mutate(function () {
            if (showAsideQuickNav) {
              _this3.quickNav.classList.add('is-flipped');
            } else {
              _this3.quickNav.classList.remove('is-flipped');
            }
          });
        }
        /**
         * Toggle the social share icons
         */
  
      }, {
        key: "_toggleSocialShare",
        value: function _toggleSocialShare(event, target) {
          target.classList.toggle('is-active');
          target.classList.toggle('RoundButton--secondaryState');
          target.setAttribute('aria-expanded', target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
          target.nextElementSibling.setAttribute('aria-hidden', target.nextElementSibling.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
        }
      }, {
        key: "_onImageChanged",
        value: function _onImageChanged(event, cell) {
          // If cell is video or model, we hide the action list
          if (Responsive.matchesBreakpoint('pocket')) {
            var productGalleryActionListElement = this.element.querySelector('.Product__Gallery .Product__ActionList');
  
            if (productGalleryActionListElement) {
              if (cell.classList.contains('Product__SlideItem--image')) {
                productGalleryActionListElement.classList.remove('is-hidden');
              } else {
                productGalleryActionListElement.classList.add('is-hidden');
              }
            }
          } // If we have non-stacked with thumbnails, update it
  
  
          this._updateGalleryTabState(cell.getAttribute('data-media-id')); // If we have the mobile navigation, we also update it
  
  
          if (this.slideshowMobileNav) {
            var selectedIndex = parseInt(cell.getAttribute('data-media-position')) - 1; // The -1 is to make it 0 indexed
  
            Dom.nodeListToArray(this.slideshowMobileNav.querySelectorAll('.dot')).forEach(function (item, index) {
              if (index === selectedIndex) {
                item.classList.add('is-selected');
              } else {
                item.classList.remove('is-selected');
              }
            });
          }
        }
      }, {
        key: "_onImageSettled",
        value: function _onImageSettled(index, cell) {
          this._handleMedia(cell);
  
          if (Responsive.matchesBreakpoint('lap-and-up')) {
            var slides = this.element.querySelectorAll('.Product__SlideItem:not(.is-selected)');
            slides.forEach(function (slide) {
              slide.classList.add('Product__SlideItem--hidden');
            });
          }
        }
      }, {
        key: "_slideWillChange",
        value: function _slideWillChange() {
          if (Responsive.matchesBreakpoint('lap-and-up')) {
            var slides = this.element.querySelectorAll('.Product__SlideItem');
            slides.forEach(function (slide) {
              slide.classList.remove('Product__SlideItem--hidden');
            });
          }
        }
        /**
         * Verify when the screen size changes to create additional stuff on non pocket mode
         */
  
      }, {
        key: "_setupDeviceFeatures",
        value: function _setupDeviceFeatures(event) {
          var _this4 = this;
  
          var currentBreakpoint = event ? event.detail.currentBreakpoint : Responsive.getCurrentBreakpoint(),
              previousBreakpoint = event ? event.detail.previousBreakpoint : null;
  
          if (currentBreakpoint === previousBreakpoint) {
            return; // Nothing has changed, no specific setup to do
          }
  
          if (currentBreakpoint === 'phone' || currentBreakpoint === 'tablet') {
            if (this.carouselNavScrollSpy) {
              this.carouselNavScrollSpy.destroy();
            }
  
            if (this.productInfoScroller) {
              this.productInfoScroller.destroy();
            }
  
            if (this.productThumbnailsScroller) {
              this.productThumbnailsScroller.destroy();
            }
  
            if (this.productAsideElement) {
              this.productAsideElement.style.minHeight = null;
            } else {
              this.productWrapperElement.style.minHeight = null;
            }
  
            this.productInfoElement.parentNode.style.maxHeight = null;
            this._syncGalleryAccessibilityState();
          } else {
            // 1st: scrollspy for the dots and image
            if (this.slideshowImages && this.slideshowImages.length > 1) {
              var offsetTop = 0;
  
              if (this.options['stackProductImages'] && this.slideshowNavDots) {
                offsetTop = this.slideshowNavDots.firstElementChild.offsetTop;
              }
  
              if (this.options['showThumbnails'] && Responsive.matchesBreakpoint('desk')) {
                offsetTop = 250;
              }
  
              this.carouselNavScrollSpy = new ScrollSpy(this.element, this.slideshowImages, {
                rootMargin: "-".concat(offsetTop, "px 0px 0px 0px")
              });
            }
  
            var productInfoStyles = window.getComputedStyle(this.productInfoElement),
                productInfoPadding = parseInt(productInfoStyles.paddingTop) + parseInt(productInfoStyles.paddingBottom),
                productGalleryHeight = this.productGalleryElement ? parseInt(this.productGalleryElement.scrollHeight) : 0; // 2nd: making sure to set up enough space in aside part
  
            var calculateMinHeight = function calculateMinHeight() {
              if (_this4.productAsideElement) {
                _this4.productAsideElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - productInfoPadding - productGalleryHeight, "px");
                _this4.productInfoElement.closest('.Product__InfoWrapper').style.maxHeight = _this4.productAsideElement.offsetTop + _this4.productInfoElement.scrollHeight - productInfoPadding + 'px';
              } else {
                _this4.productWrapperElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - parseInt(productInfoStyles.paddingTop), "px");
              }
            };
  
            calculateMinHeight(); // This code actually works well, but if a merchant is using an app that dynamically adds content (such as ReCharge or any other widget-based app), this
            // will mess the min height. There is a clean solution to this issue, which is by using ResizeObserver. However it's only supported in Chrome for now,
            // but I feel it's already good to have a clean fix
  
            if (window.ResizeObserver) {
              this.productInfoResizeObserver = new ResizeObserver(function () {
                calculateMinHeight(); // We currently do not take advantage of the values returned by the observer as our calculation depends on other values
              });
              this.productInfoResizeObserver.observe(this.productInfoElement);
            } // 3rd: let's handle the scroll for the product info
  
  
            this.productInfoScroller = new OverflowScroller(this.productInfoElement); // 4th: let's handle the scroll for the thumbnails
  
            if (this.options['showThumbnails'] && this.slideshowNavThumbnails) {
              this.productThumbnailsScroller = new OverflowScroller(this.slideshowNavThumbnails);
            }

            this._syncGalleryAccessibilityState();
          }
        }
      }]);
  
      return ProductSection;
    }();
  
    var RecentlyViewedProductsSection = /*#__PURE__*/function () {
      function RecentlyViewedProductsSection(container) {
        _classCallCheck(this, RecentlyViewedProductsSection);
  
        this.element = container;
        this.options = JSON.parse(this.element.getAttribute('data-section-settings')); // Setup product item color swatch
  
        new ProductItemColorSwatch(this.element);
  
        this._fetchProducts();
      }
  
      _createClass(RecentlyViewedProductsSection, [{
        key: "onUnload",
        value: function onUnload() {
          if (this.carousel) {
            this.carousel.destroy();
          }
        }
        /**
         * In order to get the products to display, we hit the search template with the given IDS
         */
  
      }, {
        key: "_fetchProducts",
        value: function _fetchProducts() {
          var _this = this;
  
          var queryString = this._getSearchQueryString();
  
          if (queryString === '') {
            return;
          } // If we have a non empty query string we do a search query
  
  
          fetch("".concat(window.routes.searchUrl, "?section_id=").concat(this.element.getAttribute('data-section-id'), "&type=product&q=").concat(queryString), {
            credentials: 'same-origin',
            method: 'GET'
          }).then(function (response) {
            response.text().then(function (content) {
              var tempElement = document.createElement('div');
              tempElement.innerHTML = content; // Set the content
  
              _this.element.innerHTML = tempElement.querySelector('.Section').innerHTML; // Show the section
  
              _this.element.parentNode.style.display = 'block'; // And finally let's create the carousel !
  
              _this.carousel = new Carousel(_this.element.querySelector('[data-flickity-config]'));
            });
          });
        }
      }, {
        key: "_getSearchQueryString",
        value: function _getSearchQueryString() {
          var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]'); // If we are on a product template, we make sure to remove the main product from the related product
  
          if (items.includes(this.options['productId'])) {
            items.splice(items.indexOf(this.options['productId']), 1);
          }
  
          return items.map(function (item) {
            return 'id:' + item;
          }).join(' OR ');
        }
      }]);
  
      return RecentlyViewedProductsSection;
    }();
  
    /**
     * This code is extracted from Slate
     */
  
    var SectionContainer = /*#__PURE__*/function () {
      function SectionContainer() {
        _classCallCheck(this, SectionContainer);
  
        this.constructors = [];
        this.instances = [];
  
        this._attachListeners();
      }
  
      _createClass(SectionContainer, [{
        key: "_attachListeners",
        value: function _attachListeners() {
          document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
          document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
          document.addEventListener('shopify:section:select', this._onSelect.bind(this));
          document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
          document.addEventListener('shopify:section:reorder', this._onReorder.bind(this));
          document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
          document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
        }
      }, {
        key: "register",
        value: function register(type, constructor) {
          var _this = this;
  
          this.constructors[type] = constructor;
          Dom.nodeListToArray(document.querySelectorAll("[data-section-type=".concat(type, "]"))).forEach(function (container) {
            _this._createInstance(container, constructor);
          });
        }
        /**
         * Return an object from an array of objects that matches the provided key and value
         */
  
      }, {
        key: "_findInstance",
        value: function _findInstance(array, key, value) {
          for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
              return array[i];
            }
          }
        }
        /**
         * Remove an object from an array of objects by matching the provided key and value
         */
  
      }, {
        key: "_removeInstance",
        value: function _removeInstance(array, key, value) {
          var i = array.length;
  
          while (i--) {
            if (array[i][key] === value) {
              array.splice(i, 1);
              break;
            }
          }
  
          return array;
        }
      }, {
        key: "_onSectionLoad",
        value: function _onSectionLoad(event) {
          var container = event.target.querySelector('[data-section-id]');
  
          if (container) {
            this._createInstance(container);
          }
        }
      }, {
        key: "_onSectionUnload",
        value: function _onSectionUnload(event) {
          var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
          if (!instance) {
            return;
          }
  
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(event);
          }
  
          this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId);
        }
      }, {
        key: "_onSelect",
        value: function _onSelect(event) {
          var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
          if (instance && typeof instance.onSelect === 'function') {
            instance.onSelect(event);
          }
        }
      }, {
        key: "_onDeselect",
        value: function _onDeselect(event) {
          var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
          if (instance && typeof instance.onDeselect === 'function') {
            instance.onDeselect(event);
          }
        }
      }, {
        key: "_onReorder",
        value: function _onReorder(event) {
          var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
          if (instance && typeof instance.onReorder === 'function') {
            instance.onReorder(event);
          }
        }
      }, {
        key: "_onBlockSelect",
        value: function _onBlockSelect(event) {
          var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
          if (instance && typeof instance.onBlockSelect === 'function') {
            instance.onBlockSelect(event);
          }
        }
      }, {
        key: "_onBlockDeselect",
        value: function _onBlockDeselect(event) {
          var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
  
          if (instance && typeof instance.onBlockDeselect === 'function') {
            instance.onBlockDeselect(event);
          }
        }
      }, {
        key: "_createInstance",
        value: function _createInstance(container, constructor) {
          var id = container.getAttribute('data-section-id'),
              type = container.getAttribute('data-section-type');
          constructor = constructor || this.constructors[type];
  
          if (typeof constructor === 'undefined') {
            return;
          }
  
          var instance = Object.assign(new constructor(container), {
            id: id,
            type: type,
            container: container
          });
          this.instances.push(instance);
        }
      }]);
  
      return SectionContainer;
    }();
  
    var ShopNowSection = /*#__PURE__*/function () {
      function ShopNowSection(container) {
        _classCallCheck(this, ShopNowSection);
  
        this.element = container;
        this.carousel = new Carousel(this.element.querySelector('[data-flickity-config]')); // Setup product item color swatch
  
        new ProductItemColorSwatch(this.element);
      }
  
      _createClass(ShopNowSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.carousel.destroy();
        }
      }]);
  
      return ShopNowSection;
    }();
  
    var ShopTheLookSection = /*#__PURE__*/function () {
      function ShopTheLookSection(container) {
        _classCallCheck(this, ShopTheLookSection);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.usePocketMode = Responsive.matchesBreakpoint('pocket');
        this.pocketActivatorButton = this.element.querySelector('[data-action="open-look"]');
  
        this._createOuterCarousel();
  
        this._createPocketPopovers();
  
        this._attachListeners();
      }
  
      _createClass(ShopTheLookSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.outerCarousel.destroy();
          this.innerCarousels.forEach(function (item) {
            item.forEach(function (innerItem) {
              return innerItem.destroy();
            });
          });
          this.popovers.forEach(function (item) {
            return item.destroy();
          });
          this.delegateElement.off();
        }
      }, {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          this.outerCarousel.selectCell(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
        }
        /**
         * Attach all the listeners
         */
  
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on('click', '.ShopTheLook__Dot', this._onDotClicked.bind(this));
        }
        /**
         * There is one mobile and tablet popover per look, so we pre-create them
         */
  
      }, {
        key: "_createPocketPopovers",
        value: function _createPocketPopovers() {
          var _this = this;
  
          this.popovers = [];
          Dom.nodeListToArray(this.element.querySelectorAll('.Popover')).forEach(function (popover) {
            _this.popovers.push(new Popover(popover, {
              activator: _this.pocketActivatorButton,
              showOverlay: false,
              onOpen: _this._openPocketZoom.bind(_this),
              onClose: _this._closePocketZoom.bind(_this)
            }));
          });
        }
        /**
         * The outer carousel is the carousel that holds the main one (all the looks). Internally, it also creates
         * a sub-carousel for each inner carousel
         */
  
      }, {
        key: "_createOuterCarousel",
        value: function _createOuterCarousel() {
          var _this2 = this;
  
          this.outerCarousel = new Carousel(this.element.querySelector('.ShopTheLook'), {
            onSelect: this._onLookChanged.bind(this)
          });
          this.innerCarousels = new Array(this.outerCarousel.flickityInstance.cells.length);
  
          for (var i = 0; i !== this.innerCarousels.length; ++i) {
            this.innerCarousels[i] = [];
          } // We need to create ALL the carousels (both in desktop and mobile). Fortunately Flickity is quite fast, but
          // we have no other choices if we want to have proper animations everywhere.
  
  
          Dom.nodeListToArray(this.element.querySelectorAll('.ShopTheLook__ProductList')).forEach(function (item) {
            var lookIndex = parseInt(item.getAttribute('data-look-index'));
  
            _this2.innerCarousels[lookIndex].push(new Carousel(item, {
              onSelect: _this2._onProductChanged.bind(_this2)
            })); // By default, Flickity will append the carousel, hence making the "ViewButton" before the carousel. We need to manipulate it to move it after
  
  
            item.insertBefore(item.querySelector('.flickity-viewport'), item.querySelector('.ShopTheLook__ViewButton'));
          });
          this.outerCarousel.resize(); // Needed in case the products are taller than the image
        }
        /**
         * This function is called whenever the main look has changed, so that we can modify the popover activator
         */
  
      }, {
        key: "_onLookChanged",
        value: function _onLookChanged(selectedIndex, selectedCell) {
          // Then, we update the mobile button so that it opens the correct block
          this.pocketActivatorButton.setAttribute('aria-controls', "".concat(selectedCell.getAttribute('id'), "-popover"));
        }
        /**
         * This function is called whenever a product is changed in the list for a given look. This allows to focus the main dot
         */
  
      }, {
        key: "_onProductChanged",
        value: function _onProductChanged(selectedIndex, selectedCell) {
          var lookItem = this.outerCarousel.getSelectedCell(),
              activeDot = null;
          Dom.nodeListToArray(lookItem.querySelectorAll('.ShopTheLook__Dot')).forEach(function (dot, index) {
            dot.classList.remove('is-active'); // IE11 and lower does not support "toggle" with second parameter :(
  
            if (index === selectedIndex) {
              dot.classList.add('is-active');
              activeDot = dot;
            }
          }); // Update the link to the product (if using the desktop view)
  
          lookItem.querySelector('.ShopTheLook__ViewButton').setAttribute('href', selectedCell.getAttribute('data-product-url')); // We trigger an event so that when the dot change we can recalculate the position
  
          lookItem.dispatchEvent(new CustomEvent('product:changed', {
            detail: {
              dot: activeDot
            }
          }));
        }
        /**
         * This function is called whenever you explicitly click on a dot.
         *
         * On mobile and tablet, this must open the appropriate popver
         */
  
      }, {
        key: "_onDotClicked",
        value: function _onDotClicked(event, target) {
          var shouldAnimateCarousel = false,
              hasOnePopoverOpen = false,
              lookIndex = this.outerCarousel.getSelectedIndex();
          this.popovers.forEach(function (item) {
            if (item.isOpen) {
              hasOnePopoverOpen = true;
              shouldAnimateCarousel = true;
            }
          }); // Each inner carousel has a mobile AND desktop version, so we change both
  
          this.innerCarousels[lookIndex].forEach(function (innerCarousel) {
            innerCarousel.selectCell(parseInt(target.getAttribute('data-product-index')) - 1, false, shouldAnimateCarousel);
          });
  
          if (this.usePocketMode && !hasOnePopoverOpen) {
            this.popovers[lookIndex].open();
          }
        }
        /**
         * This is called when, on mobile, the popover is open. We must open the image in full resolution
         */
  
      }, {
        key: "_openPocketZoom",
        value: function _openPocketZoom(popover) {
          var _this3 = this;
  
          this._calculateImageTransform(popover);
  
          fastdom.mutate(function () {
            // We need to animate the header to avoid a slightly ugly effect if image overlap the header
            document.getElementById('shopify-section-header').style.cssText = 'transform: translateY(-100%); transition: transform 0.3s ease-in-out;';
  
            _this3.outerCarousel.flickityInstance.unbindDrag(); // Prevent changing the active slide
  
  
            _this3.outerCarousel.flickityInstance.element.classList.add('is-zoomed');
  
            _this3.outerCarousel.getSelectedCell().classList.add('is-expanded');
          });
        }
        /**
         * When the mobile zoom is open, and whenever the active dot changes, we need to potentially re-calculate the transform
         */
  
      }, {
        key: "_calculateImageTransform",
        value: function _calculateImageTransform(openPopover) {
          var _this4 = this;
  
          var selectedCell = this.outerCarousel.getSelectedCell();
          fastdom.measure(function () {
            // We first need to compute the initial transform and scale factor
            var scale = window.innerWidth / (selectedCell.offsetWidth - parseInt(window.getComputedStyle(selectedCell).paddingLeft) * 2),
                heightAfterScale = Math.round(selectedCell.offsetHeight * scale),
                // Height of the selected cell once the scale transform is applied
            hiddenImageHeight = Math.round(Math.max(heightAfterScale - (window.innerHeight - openPopover.element.offsetHeight), 0)),
                // Part of image that is below popover
            visibleImageHeight = heightAfterScale - hiddenImageHeight,
                // Part of the image that is visible in the viewport
            minTranslateY = Math.round(-(selectedCell.getBoundingClientRect().top - (heightAfterScale - selectedCell.offsetHeight) / 2)),
                // The minimum translate Y transform allowed so that image is visible
            maxTranslateY = Math.round(minTranslateY - hiddenImageHeight); // The maximum translate Y transform allowed so that image is visible
  
            _this4._calculateTransformForDotListener = function (event) {
              var dotTopPosition = Math.round((event.detail.dot.offsetTop + event.detail.dot.offsetHeight / 2) * scale),
                  offsetToMove = Math.round(dotTopPosition - visibleImageHeight / 2),
                  translateY = Math.min(Math.max(minTranslateY - offsetToMove, maxTranslateY), minTranslateY);
              fastdom.mutate(function () {
                _this4.outerCarousel.flickityInstance.viewport.style.transform = "translate3d(0, ".concat(Math.round(translateY), "px, 0) scale(").concat(scale, ")");
              });
            }; // We manually generate an event the first time to trigger the positioning
  
  
            selectedCell.addEventListener('product:changed', _this4._calculateTransformForDotListener);
            selectedCell.dispatchEvent(new CustomEvent('product:changed', {
              detail: {
                dot: selectedCell.querySelector('.ShopTheLook__Dot.is-active')
              }
            }));
          });
        }
        /**
         * Close the mobile zoom (which close the popover and remove any transform
         */
  
      }, {
        key: "_closePocketZoom",
        value: function _closePocketZoom() {
          var _this5 = this;
  
          var selectedCell = this.outerCarousel.getSelectedCell();
          selectedCell.removeEventListener('product:changed', this._calculateTransformForDotListener);
          fastdom.mutate(function () {
            document.getElementById('shopify-section-header').style.cssText = 'transform: translateY(0); transition: transform 0.3s ease-in-out 0.3s;';
  
            _this5.outerCarousel.flickityInstance.bindDrag();
  
            _this5.outerCarousel.flickityInstance.element.classList.remove('is-zoomed');
  
            _this5.outerCarousel.flickityInstance.viewport.style.transform = null;
            selectedCell.classList.remove('is-expanded');
          });
        }
      }]);
  
      return ShopTheLookSection;
    }();
  
    var SidebarMenuSection = /*#__PURE__*/function () {
      function SidebarMenuSection(container) {
        _classCallCheck(this, SidebarMenuSection);
  
        this.element = container;
        this.sidebarDrawer = new Drawer(container);
      }
  
      _createClass(SidebarMenuSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.sidebarDrawer.destroy();
        }
      }, {
        key: "onSelect",
        value: function onSelect() {
          this.sidebarDrawer.open();
        }
      }, {
        key: "onDeselect",
        value: function onDeselect() {
          this.sidebarDrawer.close();
        }
      }]);
  
      return SidebarMenuSection;
    }();
  
    var SlideshowSection = /*#__PURE__*/function () {
      function SlideshowSection(container) {
        _classCallCheck(this, SlideshowSection);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.slideshow = new Carousel(this.element.querySelector('[data-flickity-config]'), {
          onSelect: this._onSlideChanged.bind(this)
        });
        this.selectedSlide = null;
        this.shouldAnimate = true;
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0
        });
  
        if (this.slideshow.flickityInstance.cells.length > 0) {
          this._transitionToSlide(this.slideshow.flickityInstance.selectedCell.element, true);
        }
  
        this._attachListeners();
      }
  
      _createClass(SlideshowSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.slideshow.destroy();
          this.timeline.kill();
          this.delegateElement.off();
          document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
        }
      }, {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.stopPlayer();
          }
  
          this.shouldAnimate = !event.detail.load;
          this.slideshow.selectCell(event.target.getAttribute('data-slide-index'), false, !event.detail.load);
        }
      }, {
        key: "onBlockDeselect",
        value: function onBlockDeselect() {
          this.shouldAnimate = true;
  
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.playPlayer();
          }
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
          this.delegateElement.on('mouseenter', '.Button', this._pauseSlideshow.bind(this), true);
          this.delegateElement.on('mouseleave', '.Button', this._resumeSlideshow.bind(this), true);
          document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
        }
      }, {
        key: "_pauseSlideshow",
        value: function _pauseSlideshow() {
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.pausePlayer();
          }
        }
      }, {
        key: "_resumeSlideshow",
        value: function _resumeSlideshow() {
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.unpausePlayer();
          }
        }
      }, {
        key: "_onSlideChanged",
        value: function _onSlideChanged(index, element) {
          this._transitionToSlide(element);
        }
      }, {
        key: "_transitionToSlide",
        value: function _transitionToSlide(slide) {
          var _this = this;
  
          this.timeline.clear(); // First, we check if there is a previous slide selected, if that's the case
  
          if (this.selectedSlide) {
            this._slideLeave(this.selectedSlide);
  
            this.timeline.addLabel('enter', this.shouldAnimate ? '-=0.4' : 0);
          } // We get the next slide (if any) to preload it
  
  
          this._lazyLoadNextImage();
  
          this.timeline.fromTo(slide, this.selectedSlide && this.shouldAnimate ? 0.3 : 0, {
            autoAlpha: 0
          }, {
            autoAlpha: 1,
            ease: Cubic.easeInOut
          }, 'enter'); // The image may take 1s or more to load depending on the network, so we make sure to pause the player, and restart it once it has transitioned
  
          if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'playing') {
            this.slideshow.flickityInstance.pausePlayer();
          }
  
          Dom.nodeListToArray(slide.querySelectorAll('.Slideshow__Image')).forEach(function (image) {
            if (image.classList.contains('Image--lazyLoading') || image.classList.contains('Image--lazyLoad')) {
              image.addEventListener('lazyloaded', _this._slideEnter.bind(_this, slide));
            } else {
              _this._slideEnter(slide);
            }
          });
          this.selectedSlide = slide;
        }
      }, {
        key: "_slideLeave",
        value: function _slideLeave(slide) {
          var content = slide.querySelector('.SectionHeader'),
              buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');
          this.timeline.fromTo(slide, this.shouldAnimate ? 0.3 : 0, {
            autoAlpha: 1
          }, {
            autoAlpha: 0,
            ease: Cubic.easeInOut,
            delay: this.shouldAnimate ? 0.35 : 0
          });
  
          if (content) {
            this.timeline.fromTo(content, this.shouldAnimate ? 0.4 : 0, {
              autoAlpha: 1,
              y: 0
            }, {
              autoAlpha: 0,
              y: 20,
              ease: Cubic.easeIn
            }, 0);
          }
  
          if (buttonWrapper) {
            this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.4 : 0, {
              autoAlpha: 1,
              y: 0
            }, {
              autoAlpha: 0,
              y: 10,
              ease: Cubic.easeIn
            }, 0);
          }
        }
      }, {
        key: "_slideEnter",
        value: function _slideEnter(slide) {
          var images = slide.querySelectorAll('.Slideshow__Image'),
              content = slide.querySelector('.SectionHeader'),
              buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');
  
          if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'paused') {
            this.slideshow.flickityInstance.unpausePlayer();
          }
  
          if (window.CSS && window.CSS.supports('(object-fit: cover) or (-o-object-fit: cover)')) {
            if (window.theme.showImageZooming) {
              this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
                opacity: 0,
                scale: 1.2
              }, {
                opacity: 1,
                scale: 1,
                ease: Quad.easeOut
              }, 'enter');
            } else {
              this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, {
                opacity: 0
              }, {
                opacity: 1,
                ease: Quad.easeOut
              }, 'enter');
            }
          }
  
          if (content) {
            this.timeline.fromTo(content, this.shouldAnimate ? 0.8 : 0, {
              autoAlpha: 0,
              y: 30
            }, {
              autoAlpha: 1,
              y: 0,
              delay: this.shouldAnimate ? 0.8 : 0,
              ease: Cubic.easeOut
            }, 'enter');
          }
  
          if (buttonWrapper) {
            this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.8 : 0, {
              autoAlpha: 0,
              y: 20
            }, {
              autoAlpha: 1,
              y: 0,
              delay: this.shouldAnimate ? 0.8 : 0,
              ease: Cubic.easeOut
            }, 'enter');
          }
        }
      }, {
        key: "_lazyLoadNextImage",
        value: function _lazyLoadNextImage() {
          var currentIndex = this.slideshow.flickityInstance.selectedIndex,
              breakpoint = Responsive.getCurrentBreakpoint();
  
          if (this.slideshow.flickityInstance.cells.length - 1 > currentIndex) {
            var nextCellElement = this.slideshow.flickityInstance.cells[currentIndex + 1].element,
                imageContainers = Dom.nodeListToArray(nextCellElement.querySelectorAll('.Slideshow__ImageContainer')),
                imageToReveal = null;
  
            if (breakpoint === 'phone') {
              imageToReveal = imageContainers[0];
            } else {
              imageToReveal = imageContainers[1];
            }
  
            if (window.lazySizes && imageToReveal && imageToReveal.classList.contains('Image--lazyLoad')) {
              lazySizes.loader.unveil(imageToReveal.firstElementChild);
            }
          }
        }
      }, {
        key: "_onBreakpointChanged",
        value: function _onBreakpointChanged(event) {
          if (event.detail.previousBreakpoint === 'phone' && event.detail.currentBreakpoint !== 'phone' || event.detail.previousBreakpoint !== 'phone' && event.detail.currentBreakpoint === 'phone') {
            this.selectedSlide = null;
  
            this._transitionToSlide(this.slideshow.flickityInstance.selectedElement);
          }
        }
      }]);
  
      return SlideshowSection;
    }();
  
    var TestimonialsSection = /*#__PURE__*/function () {
      function TestimonialsSection(container) {
        _classCallCheck(this, TestimonialsSection);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.navItems = Dom.nodeListToArray(this.element.querySelectorAll('.TestimonialNav__Item'));
        this.carousel = new Carousel(this.element.querySelector('.TestimonialList'), {
          onSelect: this._testimonialChanged.bind(this)
        });
  
        this._attachListeners();
      }
  
      _createClass(TestimonialsSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.carousel.destroy();
          this.delegateElement.off('click');
        }
      }, {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          this.carousel.selectCell(event.target.getAttribute('data-slide-index'), true);
        }
      }, {
        key: "onBlockDeselect",
        value: function onBlockDeselect() {
          this.carousel.unpausePlayer();
        }
      }, {
        key: "_testimonialClicked",
        value: function _testimonialClicked(event, target) {
          this.carousel.pausePlayer();
          this.carousel.selectCell(parseInt(target.getAttribute('data-index')));
          this.carousel.unpausePlayer();
        }
      }, {
        key: "_testimonialChanged",
        value: function _testimonialChanged(newIndex) {
          this.navItems.forEach(function (item, index) {
            item.classList.remove('is-selected'); // IE11 and lower does not support classList.toggle
  
            if (newIndex === index) {
              item.classList.add('is-selected');
            }
          });
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on('click', '.TestimonialNav__Item', this._testimonialClicked.bind(this));
        }
      }]);
  
      return TestimonialsSection;
    }();
  
    var TimelineSection = /*#__PURE__*/function () {
      function TimelineSection(container) {
        _classCallCheck(this, TimelineSection);
  
        this.element = container;
        this.delegateElement = new domDelegate.Delegate(this.element);
        this.items = Dom.nodeListToArray(this.element.querySelectorAll('.Timeline__Item'));
        this.navItems = Dom.nodeListToArray(this.element.querySelectorAll('.Timeline__NavItem'));
  
        this._attachListeners();
      }
  
      _createClass(TimelineSection, [{
        key: "onUnload",
        value: function onUnload() {
          this.delegateElement.off('click');
        }
      }, {
        key: "onBlockSelect",
        value: function onBlockSelect(event) {
          this.navItems[parseInt(event.target.getAttribute('data-index'))].click(); // Simulate a click on the given nav item
        }
      }, {
        key: "_attachListeners",
        value: function _attachListeners() {
          this.delegateElement.on('click', '.Timeline__NavItem', this._clickOnNavItem.bind(this));
        }
      }, {
        key: "_clickOnNavItem",
        value: function _clickOnNavItem(event, target) {
          var newItem = this.items[parseInt(target.getAttribute('data-index'))];
  
          if (newItem.classList.contains('is-selected')) {
            return;
          }
  
          var isContentLarger = false,
              navWrapper = target.parentNode,
              scrollableOffset = 0;
          fastdom.measure(function () {
            var scrollableWidth = navWrapper.scrollWidth,
                visibleWidth = navWrapper.offsetWidth;
            isContentLarger = visibleWidth < scrollableWidth;
  
            if (isContentLarger) {
              var beginBound = target.offsetLeft,
                  endBound = beginBound + target.offsetWidth,
                  closerToLeft = beginBound <= visibleWidth - endBound;
              var itemToUse = null;
  
              if (closerToLeft) {
                // If closer to left, we try to make the previous item visible (if possible)
                itemToUse = target.previousElementSibling || target;
              } else {
                // If closer to right, we try to make the next item visible (if possible)
                itemToUse = target.nextElementSibling || target;
              }
  
              var itemBeginBound = itemToUse.offsetLeft - navWrapper.scrollLeft,
                  itemEndBound = itemBeginBound + itemToUse.offsetWidth;
  
              if (itemEndBound > visibleWidth) {
                // Element is not visible from the right, so we must move by a given amount so that endBound is within viewable screen
                scrollableOffset = itemEndBound - visibleWidth;
              } else if (itemBeginBound < 0) {
                // Element is not visible from the left, so we simply use the opposite of the negative offset
                scrollableOffset = itemBeginBound;
              }
            }
          });
          fastdom.mutate(function () {
            if (isContentLarger) {
              navWrapper.scrollBy({
                behavior: 'smooth',
                left: scrollableOffset
              });
            } // First we set the class on the selected item and remove it on siblings
  
  
            target.classList.add('is-selected');
            Dom.getSiblings(target, '.is-selected').forEach(function (item) {
              item.classList.remove('is-selected');
            }); // Then we slide to the appropriate element
  
            newItem.classList.add('is-selected');
            Dom.getSiblings(newItem, '.is-selected').forEach(function (item) {
              item.classList.remove('is-selected');
            });
          });
        }
      }]);
  
      return TimelineSection;
    }();
  
    var PriceRange = /*#__PURE__*/function (_HTMLElement) {
      _inherits(PriceRange, _HTMLElement);
  
      var _super = _createSuper(PriceRange);
  
      function PriceRange() {
        _classCallCheck(this, PriceRange);
  
        return _super.apply(this, arguments);
      }
  
      _createClass(PriceRange, [{
        key: "connectedCallback",
        value: function connectedCallback() {
          var _this = this;
  
          this.rangeLowerBound = this.querySelector('.price-range__range-group input:first-child');
          this.rangeHigherBound = this.querySelector('.price-range__range-group input:last-child');
          this.textInputLowerBound = this.querySelector('.price-range__input:first-child input');
          this.textInputHigherBound = this.querySelector('.price-range__input:last-child input'); // Select whole text on focus for text field to improve user experience
  
          this.textInputLowerBound.addEventListener('focus', function () {
            return _this.textInputLowerBound.select();
          });
          this.textInputHigherBound.addEventListener('focus', function () {
            return _this.textInputHigherBound.select();
          }); // Keep in sync the range with the text input fields
  
          this.textInputLowerBound.addEventListener('change', function (event) {
            event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
            _this.rangeLowerBound.value = event.target.value;
  
            _this.rangeLowerBound.parentElement.style.setProperty('--range-min', "".concat(parseInt(_this.rangeLowerBound.value) / parseInt(_this.rangeLowerBound.max) * 100, "%"));
          });
          this.textInputHigherBound.addEventListener('change', function (event) {
            event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
            _this.rangeHigherBound.value = event.target.value;
  
            _this.rangeHigherBound.parentElement.style.setProperty('--range-max', "".concat(parseInt(_this.rangeHigherBound.value) / parseInt(_this.rangeHigherBound.max) * 100, "%"));
          });
          this.rangeLowerBound.addEventListener('change', function (event) {
            _this.textInputLowerBound.value = event.target.value;
  
            _this.textInputLowerBound.dispatchEvent(new Event('change', {
              bubbles: true
            }));
          });
          this.rangeHigherBound.addEventListener('change', function (event) {
            _this.textInputHigherBound.value = event.target.value;
  
            _this.textInputHigherBound.dispatchEvent(new Event('change', {
              bubbles: true
            }));
          }); // We also have to bound the two range sliders
  
          this.rangeLowerBound.addEventListener('input', function (event) {
            event.target.value = Math.min(parseInt(event.target.value), parseInt(_this.textInputHigherBound.value || event.target.max) - 1); // Bound the value
  
            event.target.parentElement.style.setProperty('--range-min', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
            _this.textInputLowerBound.value = event.target.value;
          });
          this.rangeHigherBound.addEventListener('input', function (event) {
            event.target.value = Math.max(parseInt(event.target.value), parseInt(_this.textInputLowerBound.value || event.target.min) + 1); // Bound the value
  
            event.target.parentElement.style.setProperty('--range-max', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
            _this.textInputHigherBound.value = event.target.value;
          });
        }
      }]);
  
      return PriceRange;
    }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
    window.customElements.define('price-range', PriceRange);
  
    var ProductRecommendations = /*#__PURE__*/function (_HTMLElement) {
      _inherits(ProductRecommendations, _HTMLElement);
  
      var _super = _createSuper(ProductRecommendations);
  
      function ProductRecommendations() {
        var _this;
  
        _classCallCheck(this, ProductRecommendations);
  
        _this = _super.call(this);
        _this._isLoaded = false;
        return _this;
      }
  
      _createClass(ProductRecommendations, [{
        key: "connectedCallback",
        value: function connectedCallback() {
          this._loadRecommendations();
        }
      }, {
        key: "_loadRecommendations",
        value: function _loadRecommendations() {
          var _this2 = this;
  
          if (this._isLoaded) {
            return;
          }
  
          this._isLoaded = true;
          var section = this.closest('.shopify-section'),
              intent = this.getAttribute('intent') || 'related',
              url = "".concat(Shopify.routes.root, "recommendations/products?product_id=").concat(this.getAttribute('product'), "&limit=").concat(this.getAttribute('limit') || 4, "&section_id=").concat(this.getAttribute('section-id'), "&intent=").concat(intent);
          fetch(url).then(function (response) {
            response.text().then(function (text) {
              var tempDiv = new DOMParser().parseFromString(text, 'text/html'),
                  productRecommendationsElement = tempDiv.querySelector('product-recommendations');
  
              if (productRecommendationsElement.childElementCount > 0) {
                _this2.replaceChildren.apply(_this2, _toConsumableArray(document.importNode(productRecommendationsElement, true).childNodes));
              } else {
                if (intent === 'related') {
                  section.remove();
                } else {
                  _this2.remove();
                }
              }
            });
          });
        }
      }]);
  
      return ProductRecommendations;
    }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  
    if (!window.customElements.get('product-recommendations')) {
      window.customElements.define('product-recommendations', ProductRecommendations);
    }
  
    (function () {
      // First, we register all plugins that are used for all pages
      new Modal();
      new Responsive();
  
      if (window.theme.pageType !== 'password' && window.theme.pageType !== 'gift_card') {
        new LoadingBar();
      }
  
      var sections = new SectionContainer();
      sections.register('header', HeaderSection);
      sections.register('footer', FooterSection);
      sections.register('sidebar-menu', SidebarMenuSection);
      sections.register('cart', CartSection);
      sections.register('newsletter-popup', NewsletterPopupSection); // Sections used on index
  
      sections.register('slideshow', SlideshowSection);
      sections.register('collection-list', CollectionListSection);
      sections.register('article-list', ArticleList);
      sections.register('featured-product', FeaturedProductSection);
      sections.register('image-with-text-block', ImageWithTextBlockSection);
      sections.register('timeline', TimelineSection);
      sections.register('map', MapSection);
      sections.register('featured-collections', FeaturedCollectionsSection);
      sections.register('shop-the-look', ShopTheLookSection);
      sections.register('testimonials', TestimonialsSection);
      sections.register('background-video', BackgroundVideoSection); // Sections used on product page
  
      sections.register('product', ProductSection);
      sections.register('product-recommendations', ProductRecommendationsSection); // Sections used on collection page
  
      sections.register('collection', CollectionSection); // Sections used on blog page
  
      sections.register('article-list', ArticleList); // Sections used on article page
  
      sections.register('article', ArticleSection); // Sections used on content pages
  
      sections.register('faq', FaqSection); // Sections used on login page
  
      sections.register('login', LoginSection); // Sections used on addresses page
  
      sections.register('addresses', AddressesSection); // Sections used on gift card page
  
      sections.register('gift-card', GiftCardSection); // Sections used on different pages
  
      sections.register('recently-viewed-products', RecentlyViewedProductsSection);
      sections.register('shop-now', ShopNowSection);
      /**
       * ----------------------------------------------------------------------------
       * FLICKITY
       *
       * Starting from iOS 11, Safari on iOS is experiencing a bug that prevents
       * event.preventDefault to be called on dynamically added listeners, which is
       * what Flickity is using.
       *
       * The bug is coming from iOS but it impacts indirectly Flickity. A temporary
       * fix has been suggested here: https://github.com/metafizzy/flickity/issues/740
       * and that we are using here as a temporary workaround, that should be removed
       * once the bug is fixed on iOS
       * ----------------------------------------------------------------------------
       */
  
      if (window.Flickity) {
        Flickity.defaults.dragThreshold = 7;
      }
  
      (function () {
        var touchingCarousel = false,
            touchStartCoords;
        document.body.addEventListener('touchstart', function (e) {
          if (e.target.closest('.flickity-slider')) {
            touchingCarousel = true;
          } else {
            touchingCarousel = false;
            return;
          }
  
          touchStartCoords = {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY
          };
        });
        document.body.addEventListener('touchmove', function (e) {
          if (!(touchingCarousel && e.cancelable)) {
            return;
          }
  
          var moveVector = {
            x: e.touches[0].pageX - touchStartCoords.x,
            y: e.touches[0].pageY - touchStartCoords.y
          };
          if (Math.abs(moveVector.x) > ((window.Flickity && Flickity.defaults.dragThreshold) || 7)) e.preventDefault();
        }, {
          passive: false
        });
      })();
      /**
       * ----------------------------------------------------------------------------
       * FLICKITY 2
       *
       * Starting from iOS 15, Safari on iOS automatically starts to expand/collapse
       * the bottom bar as soon as you do even a minor diagonal movement. This is causing
       * a performance issue on iOS15 as it does a lot of reflow. We therefore have to
       * patch Flickity to make sure they re-size the carousel only when the width is
       * changed, by ignoring the height
       * ----------------------------------------------------------------------------
       */
  
  
      (function () {
        if (window.Flickity) {
          var originalResizeMethod = window.Flickity.prototype.resize,
              lastWidth = window.innerWidth;
  
          window.Flickity.prototype.resize = function () {
            if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
              return;
            }
  
            lastWidth = window.innerWidth;
            originalResizeMethod.apply(this, arguments); // Call original method
          };
        }
      })();
      /**
       * ----------------------------------------------------------------------------
       * RTE
       * ----------------------------------------------------------------------------
       */
  
  
      (function () {
        // We wrap each RTE table by a specific class to allow wrapping
        Dom.nodeListToArray(document.querySelectorAll('.Rte table')).forEach(function (table) {
          table.outerHTML = '<div class="TableWrapper">' + table.outerHTML + '</div>';
        });
        Dom.nodeListToArray(document.querySelectorAll('.Rte iframe')).forEach(function (iframe) {
          // We scope the wrapping only for YouTube and Vimeo
          if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
            iframe.outerHTML = '<div class="VideoWrapper">' + iframe.outerHTML + '</div>'; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
            // https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar
  
            iframe.src = iframe.src;
          }
        });
      })();
      /**
       * ----------------------------------------------------------------------------
       * UTILS
       * ----------------------------------------------------------------------------
       */
  
  
      (function () {
        var documentDelegate = new domDelegate.Delegate(document.body),
            announcementBar = document.querySelector('.AnnouncementBar');
        documentDelegate.on('click', '[href^="#"], [data-href]', function (event, target) {
          var selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href');
  
          if (selector === '#' || selector === '#main') {
            return;
          }
  
          var element = document.querySelector(selector),
              offset = parseInt(target.getAttribute('data-offset') || 0);
  
          if (announcementBar) {
            offset -= announcementBar.clientHeight;
          }
  
          if (target.hasAttribute('data-focus-on-click')) {
            var prevScrollY = window.pageYOffset;
            element.focus({
              preventScroll: true
            }); // hack to fix scroll jump after focus
  
            if (window.pageYOffset !== prevScrollY) {
              window.scrollTo(window.pageXOffset, prevScrollY);
            }
  
            element.focus();
          }
  
          window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - offset
          });
          event.preventDefault();
        });
      })();
  
      (function () {
        var windowWidth = window.innerWidth,
            headerSection = document.getElementById('shopify-section-header');
        window.addEventListener('resize', function () {
          var newWidth = -1;
          fastdom.measure(function () {
            newWidth = window.innerWidth;
          });
          fastdom.mutate(function () {
            if (newWidth === windowWidth) {
              return;
            }
  
            windowWidth = newWidth;
            document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
  
            if (headerSection) {
              document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
            }
          });
        });
      })();
  
      (function () {
        function handleFirstTab(event) {
          if (event.keyCode === 9) {
            document.body.classList.add('is-tabbing');
            window.removeEventListener('keydown', handleFirstTab);
          }
        }
  
        window.addEventListener('keydown', handleFirstTab);
      })();
      /**
       * ----------------------------------------------------------------------------
       * ANIMATION
       *
       * Important: this has to be at the very end of the file
       * ----------------------------------------------------------------------------
       */
  
  
      if (window.theme.showPageTransition) {
        PageTransition.getInstance();
      }
    })();
  
  })));
  document.addEventListener('click', function (event) {
    var customCart = event.target.closest('.customcart');
    if (!customCart) return;
    var keysAttr = customCart.getAttribute('data-keys');
    if (!keysAttr) return;
    var keys = keysAttr.split(',');
    console.log(keys);
    var updateData = {};
    for (var i = 0; i < keys.length; i++) {
      var item = keys[i];
      updateData[item] = '0';
    }
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updateData })
    })
      .then(function () { location.reload(); })
      .catch(function (err) { console.error('Booo!', err); });
  });
  document.addEventListener('click', function (event) {
    var customCartd = event.target.closest('.customcartd');
    if (!customCartd) return;
    var keysAttr = customCartd.getAttribute('data-keys');
    if (!keysAttr) return;
    var keys = keysAttr.split(',');
    console.log(keys);
    var updateData = {};
    for (var i = 0; i < keys.length; i++) {
      var item = keys[i];
      updateData[item] = '0';
    }
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updateData })
    })
      .catch(function (err) { console.error('Booo!', err); });
  });
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.btninternational');
    if (!btn) return;
    var target = document.querySelector('.intcon');
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });

/* ------ Satin Collections ------ */

/* Mobile filter expand/collapse is handled in assets/custom.js for both
   .Collapsible__Button and .collapsible_button (TalkBack / VoiceOver operable). */

  // Collection card color swatches: swap main image on hover (delegated for AJAX filters)
  (function () {
    if (window.__productSwatchHoverBound) return;
    window.__productSwatchHoverBound = true;

    function getMainImage(swatchItem) {
      var container = swatchItem.closest('.product_item_image_container');
      if (!container) return null;
      return container.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    }

    function getHoverUrl(swatchItem) {
      var img = swatchItem.querySelector('img');
      if (!img) return null;
      return img.getAttribute('data-main-image') || img.getAttribute('src');
    }

    function storeOriginal(mainImage) {
      if (mainImage.getAttribute('data-swatch-original-saved') === '1') return;
      mainImage.setAttribute('data-swatch-original-src', mainImage.getAttribute('src') || '');
      mainImage.setAttribute('data-swatch-original-srcset', mainImage.getAttribute('srcset') || '');
      mainImage.setAttribute('data-swatch-original-data-src', mainImage.getAttribute('data-src') || '');
      mainImage.setAttribute(
        'data-swatch-original-current',
        mainImage.currentSrc || mainImage.getAttribute('src') || ''
      );
      mainImage.setAttribute('data-swatch-original-saved', '1');
    }

    function applyImage(mainImage, url) {
      if (!mainImage || !url) return;
      mainImage.setAttribute('src', url);
      mainImage.setAttribute('srcset', url);
      mainImage.removeAttribute('data-src');
      mainImage.removeAttribute('sizes');
      mainImage.classList.remove('Image--lazyLoad', 'lazyload', 'lazyloading');
      mainImage.classList.add('lazyloaded');
    }

    function restoreImage(mainImage) {
      if (!mainImage) return;
      var originalSrc = mainImage.getAttribute('data-swatch-original-src');
      var originalSrcset = mainImage.getAttribute('data-swatch-original-srcset');
      var originalDataSrc = mainImage.getAttribute('data-swatch-original-data-src');
      var originalCurrent = mainImage.getAttribute('data-swatch-original-current');

      if (originalSrc) {
        mainImage.setAttribute('src', originalSrc);
      } else if (originalCurrent) {
        mainImage.setAttribute('src', originalCurrent);
      }

      if (originalSrcset) {
        mainImage.setAttribute('srcset', originalSrcset);
      } else if (originalCurrent) {
        mainImage.setAttribute('srcset', originalCurrent);
      }

      if (originalDataSrc) {
        mainImage.setAttribute('data-src', originalDataSrc);
      }
    }

    document.addEventListener(
      'mouseover',
      function (event) {
        var swatchItem = event.target.closest('.gs_product_swatch_item');
        if (!swatchItem) return;
        // Ignore when moving within the same swatch
        if (event.relatedTarget && swatchItem.contains(event.relatedTarget)) return;

        var mainImage = getMainImage(swatchItem);
        var hoverUrl = getHoverUrl(swatchItem);
        if (!mainImage || !hoverUrl) return;

        storeOriginal(mainImage);
        applyImage(mainImage, hoverUrl);
      },
      true
    );

    document.addEventListener(
      'mouseout',
      function (event) {
        var swatchItem = event.target.closest('.gs_product_swatch_item');
        if (!swatchItem) return;
        if (event.relatedTarget && swatchItem.contains(event.relatedTarget)) return;

        var mainImage = getMainImage(swatchItem);
        if (!mainImage) return;
        restoreImage(mainImage);
      },
      true
    );
  })();

/* ------ Satin COllections ------ */

/**
 * Blog comment success after Shopify native POST reload.
 * Primary announce runs inline next to the success message (iOS VoiceOver).
 * This only reclaims focus once if something else stole it (e.g. cookie banner).
 */
(function initArticleCommentSuccessAnnouncement() {
  window.addEventListener('load', function () {
    window.setTimeout(function () {
      var messageEl = document.querySelector('[data-comment-success-message]');
      if (!messageEl) return;
      if (document.activeElement === messageEl) return;

      try {
        messageEl.scrollIntoView({ block: 'center', behavior: 'auto' });
      } catch (e) {}

      try {
        messageEl.focus();
      } catch (e2) {}
    }, 400);
  });
})();

